<template>


    <div id="app" :class="getMainClasses">
        <!-- full screen loader -->
        <app-loader></app-loader>

        <!-- company message -->
        <companies-messages
            v-if="$store.getters.isAdmin && $route.name !== 'loginEfacturaRoute' && $route.name !== 'mainEfacturaRoute' && $route.name !== 'companyEfacturaRoute' &&
            $route.name !== 'messagesCompanyEfacturaRoute' && $route.name !== 'billingEfacturaRoute' && $route.name !== 'clientsEfacturaRoute' && $route.name !== 'articlesEfacturaRoute' && $route.name !== 'categoriesEfacturaRoute' && $route.name !== 'registerCompanyEfacturaRoute'  && $route.name !== 'passwordRecoverEfacturaRoute'"
        ></companies-messages>

        <!-- full screen search -->
        <top-search
                :isSearchOpen="$store.state.searchBarIsOpen"
                @searchClose="topSearch_onSearchClose"
        ></top-search>


        <message-banner
                :extraTopMargin="tdRouterViewTopMargin"
        ></message-banner>

        <!-- Fixed navbar -->
        <!-- Hide navbar on qr check in and rfid devices -->
        <nav v-if="$route.name === 'loginEfacturaRoute' || $route.name === 'registerCompanyEfacturaRoute' || $route.name === 'passwordRecoverEfacturaRoute'" key="1"  class="navbar navbar-default navbar-fixed-top td-efactura-navbar">
            <div class="container">
                <div class="col-md-12 td-navbar-wrap">
                    <div class ="td-login-menu">
                        <!-- login -->
                        <router-link class="td-navbar-link td-navbar-login-register" active-class="active" :to="{ name: 'loginEfacturaRoute', params:{language: language} }"><a href="#">{{$__('Log in')}}</a></router-link>
                        <!-- register company -->
                        <router-link class="td-navbar-link td-navbar-login-register" active-class="active" :to="{ name: 'registerCompanyEfacturaRoute', params:{language: language} }"><a href="#">{{$__('Register your company')}}</a></router-link>
                    </div>

<!--                    <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar" ref="navbarToggle">-->
<!--                        <span class="sr-only">Toggle navigation</span>-->
<!--                        <span class="icon-bar"></span>-->
<!--                        <span class="icon-bar"></span>-->
<!--                        <span class="icon-bar"></span>-->
<!--                    </button>-->
                    <div class="navbar-header">
                        <a class="navbar-brand" href="https://iflow.ro"><img src="./assets/logo-image2.png"/></a>
                    </div>
                </div>
            </div>
        </nav>

        <!--eFactura nav bar-->
        <nav v-if="$route.name === 'mainEfacturaRoute' || $route.name === 'companyEfacturaRoute' || $route.name === 'messagesCompanyEfacturaRoute' || $route.name === 'billingEfacturaRoute' || $route.name === 'clientsEfacturaRoute' || $route.name === 'articlesEfacturaRoute' || $route.name === 'categoriesEfacturaRoute' || $route.name === 'efacturaSettingsRoute'" key="2" class="navbar navbar-default navbar-fixed-top">
                <div class="container">
                    <div class="col-md-12 td-navbar-wrap-efactura">


                        <div class ="td-login-menu" v-if="$store.getters.isLoggedIn === false && allowRegistration">
                            <!-- login -->
                            <router-link class="td-navbar-link td-navbar-login-register" active-class="active" :to="{ name: 'loginRoute', params:{language: language} }"><a href="#">{{$__('Log in')}}</a></router-link>
                            <!-- register company -->
                            <div v-if="!$store.getters.isIphoneOrIpodState && isLoginLanguage('ro_RO')" class="td-navbar-link td-navbar-login-register"><a href="https://iflow.ro/cont-nou-home">{{$__('Register your company')}}</a></div>
                            <div v-else-if="!$store.getters.isIphoneOrIpodState && isLoginLanguage('hu_HU')" class="td-navbar-link td-navbar-login-register"><a href="https://iflowapp.hu/uj-fiok/">{{$__('Register your company')}}</a></div>
                            <div v-else-if="!$store.getters.isIphoneOrIpodState && isLoginLanguage('en_US')" class="td-navbar-link td-navbar-login-register"><a href="https://iflow.ro/en/new-account">{{$__('Register your company')}}</a></div>
                            <div v-else-if="!$store.getters.isIphoneOrIpodState && isLoginLanguage('es_ES')" class="td-navbar-link td-navbar-login-register"><a href="https://app.iflow.ro/#/registerCompany/es_ES">{{$__('Register your company')}}</a></div>
                            <div v-else-if="!$store.getters.isIphoneOrIpodState" class="td-navbar-link td-navbar-login-register"><a href="https://iflow.ro/cont-nou-home">{{$__('Register your company')}}</a></div>
                        </div>
                        <button v-else type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-efactura-main" aria-expanded="false" aria-controls="navbar" ref="navbarToggle">
                            <span class="sr-only">Toggle navigation</span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>


                        <!-- logo button efactura with dropdown for mobile -->
                        <div v-if="$store.getters.isAdmin">
                            <div class="navbar-header button-logo-dropdown-mobile" :class="{ 'is-open': isDropdownOpen }">
                                <a @click="toggleLogoDropdown" v-if="!this.$store.getters.isLoggedIn"
                                   :class="{
                                    'navbar-brand': !$store.getters.isIphoneOrIpodState,
                                    'navbar-brand-iphone': $store.getters.isIphoneOrIpodState,
                                    'button-logo-dropdown-mobile-arrow': true
                                }"
                                   :href="getHomePageLink()" >
                                    <img src="./assets/iflow-efactura-white.png" alt="logo-efactura"/>
                                </a>
                                <router-link v-else :to="{ name: 'mainEfacturaRoute', params: {}}" class="navbar-brand button-logo-dropdown-mobile-arrow" active-class="active">
                                    <img @click="toggleLogoDropdown" src="./assets/iflow-efactura-white.png" alt="logo-efactura"/>
                                </router-link>
                            </div>
                            <div v-show="isDropdownOpen" class="logo-dropdown-container">
                                <div class="logo-swiper-container">
                                    <router-link class="td-navbar-link" active-class="active" exact :to="{ name: 'dashboardRoute', params: {}}" style="width: 70px">
<!--                                        <img src="./assets/logo-all-apps-full-iflow.svg" alt="Logo" class="link-logo-mobil">-->
                                            <svg data-name="Layer 003" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 124.7422243 46.5729221" fill="#395FC5">
                                                <g>
                                                    <path d="M24.4936368,1.7001233c-12.1503844.0010997-21.9925372,9.8465517-21.9936368,21.9947359.0010997,12.1426867,9.8432524,21.9881373,21.9936368,21.9925378,12.145986-.0044005,21.9925378-9.8498511,21.9925378-21.9925378,0-12.1481842-9.8465517-21.9936362-21.9925378-21.9947359ZM24.4936368,43.4286496c-5.4566212,0-10.3831964-2.2059623-13.9582614-5.7799283-.2100392-.2100413-.4156795-.4233757-.6147222-.6444119h.3090107c.9028389.0044005,1.7748868-.3057114,2.3918082-.9259311.6202207-.6158212.9270322-1.4867691.924832-2.3885099v-6.7817377c0-.7103944.5751333-1.2822294,1.2844286-1.2833285.7114945.0010991,1.2844286.5729341,1.2866278,1.2833285v6.5497044c.0021992,1.9563333,1.5857416,3.5442762,3.543174,3.5464744,1.9585335-.0021982,3.543175-1.5857406,3.5442741-3.5464744v-12.2724492c.0022003-.7092953.5751344-1.2855288,1.2888281-1.2866278.7092953.0010991,1.2855288.5773325,1.2855288,1.2866278v12.2735483c0,1.9563333,1.5835424,3.5442762,3.542076,3.5464744,1.9574344-.0021982,3.542076-1.5857406,3.543175-3.5464744v-6.5497044c.0022003-.7103944.5762335-1.2822294,1.2877269-1.2833285.7092953.0010991,1.2844276.5729341,1.2844276,1.2833285v6.7784405c-.0032993.903939.3057114,1.7759859.9259311,2.3918072.6158212.6191206,1.4878702.9303316,2.3907081.9259311h.3090087c-.2001412.2210363-.404683.4343748-.6158233.6444119-3.5717615,3.5728669-8.501635,5.7788293-13.9527587,5.7788293ZM40.8437065,34.7477621h-2.0893972c-.4310734-.0043984-.6510106-.1231638-.7961686-.2606241-.1385593-.145158-.2584259-.3650952-.2617231-.7994679v-6.7784405c-.0010991-1.9563333-1.5868418-3.542076-3.543175-3.542076-1.9574344,0-3.5442741,1.5846415-3.5442741,3.542076v6.5497044c0,.7103944-.5773325,1.2888281-1.2866278,1.2888281-.7103944,0-1.2855288-.5784316-1.2866278-1.2888281v-12.2735483c0-1.9563333-1.5857406-3.5409758-3.5409748-3.5409758-1.9585335,0-3.5442741,1.5835414-3.5464744,3.5409758v12.2735483c0,.7103944-.5773325,1.2888281-1.2866278,1.2888281-.7103944,0-1.2833285-.5784316-1.2855277-1.2888281v-6.5497044c-.0021992-1.9563333-1.5890399-3.542076-3.5442752-3.542076-1.9563343,0-3.5420749,1.5857406-3.5442741,3.542076v6.7817377c-.0032993.4310755-.1220648.6510106-.2617242.7961686-.1429588.1374602-.3661943.2562257-.7961696.2606241h-2.0893956c-2.1366816-3.1527885-3.3826213-6.9532882-3.3826213-11.0529008,0-5.4533219,2.2059616-10.3820963,5.7777283-13.9571624,3.5750651-3.573966,8.5005401-5.7799278,13.9582604-5.7799278,5.4522228,0,10.3809951,2.2059618,13.953862,5.7799278,3.5750651,3.5750661,5.7821265,8.5038405,5.7821265,13.9571624,0,4.0996146-1.248137,7.9001144-3.3859188,11.0529028Z"/>
                                                    <circle cx="24.4914366" cy="12.4066258" r="2.8943626"/>
                                                    <path d="M37.0465061,18.1315698c0,1.5945385-1.2932265,2.8932624-2.8932635,2.8932624-1.5989379,0-2.8943626-1.298724-2.8943626-2.8932635,0-1.600037,1.2954247-2.8943626,2.8943626-2.8943626,1.5989379.0011001,2.8932635,1.2943266,2.8932635,2.8943636Z"/>
                                                    <path d="M17.7261945,18.1315698c0,1.5945385-1.2954257,2.8932624-2.8943626,2.8932624-1.5978378,0-2.8943626-1.298724-2.8943626-2.8932635,0-1.600037,1.2965248-2.8943626,2.8943626-2.8943626,1.5978378.0011001,2.8943626,1.2943266,2.8943626,2.8943636Z"/>
                                                </g>
                                                <g>
                                                    <g>
                                                        <path d="M57.8095995,34.102249c-.6587083,0-1.1755602-.5575387-1.1755602-1.267933v-12.5319742c0-.6851009.5267477-1.2701333,1.1524669-1.2701333.6609107,0,1.1788574.560838,1.1788574,1.2701333v12.5319742c0,.7213914-.4970558,1.267933-1.1557642,1.267933h0Z"/>
                                                        <path d="M65.5953448,34.102249c-.6400156,0-1.1810597-.5960274-1.1810597-1.2954247V15.3636704c0-.7048958.5410441-1.2976249,1.1810597-1.2976249h11.0715977c.6125219,0,1.1029791.5289469,1.1029791,1.184357,0,.6686063-.4904572,1.2140489-1.1029791,1.2140489h-9.8674447v6.6156857h8.7171801c.6070265,0,1.1029791.530047,1.1029791,1.184357,0,.6565102-.4959526,1.1865572-1.1029791,1.1865572h-8.7171801v7.3546719c.0010991.715894-.5410441,1.2965258-1.204153,1.2965258h0Z"/>
                                                        <path d="M82.2148353,34.102249c-.6609065,0-1.1777583-.5575387-1.1777583-1.267933V14.3585607c0-.7015976.5157527-1.267933,1.1513637-1.267933.6499157,0,1.1744611.5674356,1.1744611,1.267933v18.4757553c0,.7213914-.4904572,1.267933-1.1480664,1.267933h0Z"/>
                                                        <path d="M93.7966903,34.2979918c-3.9445566,0-7.0335692-3.3617265-7.0335692-7.6581851,0-4.384431,3.1132007-7.77255,7.0841519-7.77255,3.9621502,0,7.0599554,3.3639268,7.0599554,7.6603833,0,4.3822328-3.1230924,7.7703519-7.1105382,7.7703519h0ZM93.7966903,21.1238038c-2.6513363,0-4.652757,2.3247278-4.652757,5.402737,0,3.0967041,2.0662998,5.4830137,4.7033397,5.4830137,2.66893,0,4.6813498-2.3115304,4.6813498-5.3708449-.0000084-3.115401-2.0773073-5.5149059-4.7319325-5.5149059h0Z"/>
                                                        <path d="M116.9383936,34.1880232h-.0758783c-.6059274,0-1.0490991-.3936859-1.2481412-1.1106789l-3.1252989-9.9686165-3.1538834,9.9730149c-.1913486.6971991-.6477092,1.1062805-1.2426375,1.1062805-.6389166,0-1.10188-.4002845-1.3229205-1.1062805l-4.0160386-12.1910734c-.0703829-.2243356-.1374602-.436573-.1374602-.6433129,0-.6708066.5267435-1.2140489,1.1777583-1.2140489.5553363,0,.9842116.373892,1.1689657,1.0260038l3.1505861,10.2600315,3.180278-10.2919215c.1946458-.6400156.6015227-.9930126,1.141472-.9930126h.1066693c.5663355,0,1.0018136.363994,1.1953519.9952128l3.1505861,10.2908225,3.2000782-10.3227146c.1803494-.6191206.5740374-.9644219,1.1194736-.9644219.6400156,0,1.1579665.5311461,1.1579665,1.1887554,0,.1935447-.0670773.4024827-.1187675.5729341l-4.0600268,12.2889437c-.2210321.6906026-.6884002,1.1040823-1.2481328,1.1040823h0Z"/>
                                                    </g>
                                                    <path d="M57.785403,16.9428134c-1.0622922,0-1.9244432-.8654493-1.9244432-1.9277426s.862151-1.9255433,1.9244432-1.9255433c1.0611931,0,1.9255423.8632501,1.9255423,1.9255433s-.8643492,1.9277426-1.9255423,1.9277426h0Z"/>
                                                </g>
                                            </svg>
                                    </router-link>
                                    <router-link class="td-navbar-link" active-class="active" exact :to="{name: 'mainEfacturaRoute'}" style="width: 70px;">
<!--                                        <img src="./assets/logo-all-apps-full-efact.svg" alt="Logo" class="link-logo-mobil">-->
                                            <svg data-name="Layer 001" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 110 40.4193548" fill="#395FC5">
                                                <g>
                                                    <circle cx="5.2250028" cy="26.4432585" r="3.6258658"/>
                                                    <g>
                                                        <path d="M35.6783484,22.8837218c-1.2815709-.4219627-2.6625015.2749231-3.0844291,1.556494-.5926845,1.800297-1.5596165,3.4723247-2.8463449,4.888796-1.2876055,1.416752-2.8914988,2.5792106-4.7807354,3.3727545-1.7192866.7212345-3.4906038,1.0596607-5.2370459,1.0600817-2.9744038.0007719-5.8769543-.9898774-8.2261677-2.7788772-1.0736069-.817226-2.6064188-.6093497-3.4236097.4642397-.8172085,1.0735893-.6093497,2.6064012.4642572,3.4236272l-.0000175-.0000351c3.1979454,2.433434,7.1284577,3.7762627,11.1855377,3.7770346,2.3801756.000421,4.803786-.4649414,7.1280718-1.4408551,2.5553882-1.0721509,4.753615-2.6622208,6.5064776-4.5928572,1.7537047-1.9309171,3.0654835-4.2011375,3.8705-6.645974.4219276-1.2815709-.2749582-2.6625015-1.556494-3.0844291Z"/>
                                                        <path d="M14.4792747,7.7176587c1.7190761-.7213398,3.4903933-1.0597309,5.2369757-1.0601519,2.642784-.0004912,5.228801.7809836,7.4204319,2.2106818,1.5426005,1.0071741,2.8864116,2.3298643,3.928951,3.9307403l-19.0922599,8.0143443c-1.244083.5221995-1.8292594,1.954108-1.3070248,3.1981735.522217,1.2440655,1.954108,1.8292418,3.1981735,1.3070424v-.0000351l21.5487621-9.0455163c.5931756-.2490306,1.0725017-.7328826,1.3158837-1.3284089.2433469-.5954912.2401191-1.2765889-.0088764-1.8697646-1.4769221-3.520952-3.9353364-6.3579995-6.9146169-8.2992314-2.9798419-1.9428458-6.4847251-3.003524-10.0894241-3.0040152-2.3801756-.000421-4.8039263.4648361-7.1282296,1.4409954-3.191139,1.3386536-5.8222573,3.4843587-7.7310009,6.0929001-1.9100417,2.6091027-3.1071991,5.6816733-3.4619046,8.9023711-.1475834,1.3411446.8199977,2.5479853,2.1611599,2.6955512,1.3411446.1475659,2.5479853-.8199977,2.6955688-2.1611423.2598893-2.3655453,1.1432323-4.6332045,2.5473538-6.5501579,1.4054196-1.9175498,3.3221099-3.4836921,5.6800769-4.4743765Z"/>
                                                    </g>
                                                </g>
                                                <g>
                                                    <path d="M50.5388841,34.3442948c-2.2453159,0-3.9049947-1.5759779-3.9049947-3.8631442v-.02796c0-2.1337446,1.5201474-3.8911043,3.6958321-3.8911043,2.4964185,0,3.5981513,2.050223,3.5981513,3.5982409,0,.6136868-.4323051,1.0180319-.9901615,1.0180319h-4.1978581c.2091625.9622911.8785902,1.4644962,1.8269012,1.4644962.5858164,0,1.0739519-.1813817,1.506257-.5022052.1534217-.1114817.2928634-.1672225.516006-.1672225.4741555,0,.8228494.3625842.8228494.8366501,0,.2790626-.1255513.4882252-.2788834.6276668-.6555373.5577668-1.506257.9065502-2.5940994.9065502ZM51.9056098,29.8534837c-.1254617-.948311-.6833181-1.5899579-1.5758883-1.5899579-.8786798,0-1.4504266.6276668-1.6178283,1.5899579h3.1937166Z"/>
                                                    <path d="M55.7678579,25.4883135c0-.5997068.4742451-1.0739519,1.0739519-1.0739519h5.4669029c.543966,0,.9762711.4323051.9762711.9762711s-.4323051.9762711-.9762711.9762711h-4.3931302v2.0780038h3.7656426c.5437868,0,.9762711.4323051.9762711.9762711s-.4324843.9762711-.9762711.9762711h-3.7656426v2.7891923c0,.5997068-.4740659,1.0739519-1.0737727,1.0739519s-1.0739519-.4742451-1.0739519-1.0739519v-7.6983284Z"/>
                                                    <path d="M63.8977745,32.0291684v-.02796c0-1.6317187,1.2413537-2.3848472,3.0125141-2.3848472.7531285,0,1.2969153.1256409,1.8269012.3068434v-.1254617c0-.8785902-.5437868-1.3668153-1.6037587-1.3668153-.5857268,0-1.0599719.0837009-1.4644962.2091625-.1254617.04194-.2091625.0559201-.3066642.0559201-.4882252,0-.8787694-.3765643-.8787694-.8647894,0-.3765643.2371226-.6972085.571926-.8228494.6694277-.2509234,1.3945961-.390365,2.3848472-.390365,1.1574736,0,1.994303.3066642,2.5242889.8366501.5577668.557946.8088693,1.3807954.8088693,2.3848472v3.4030583c0,.5717468-.4602651,1.0180319-1.0320119,1.0180319-.6136868,0-1.0182111-.4323051-1.0182111-.8785902v-.01398c-.516006.5717468-1.2271944.948311-2.2592063.948311-1.4085762,0-2.566229-.8088693-2.566229-2.2871664ZM68.7651498,31.5409432v-.376385c-.3625842-.1674017-.8368294-.2790626-1.3528353-.2790626-.9065502,0-1.464317.3625842-1.464317,1.0320119v.02796c0,.5717468.4740659.9065502,1.1574736.9065502.9902511,0,1.6596787-.543966,1.6596787-1.3110745Z"/>
                                                    <path d="M72.2370329,30.4811505v-.02796c0-2.1337446,1.6317187-3.8911043,3.9188851-3.8911043,1.1296928,0,1.9247613.3068434,2.552249.8368294.1394417.1116609.3348034.3625842.3348034.7251685,0,.529986-.4324843.9484903-.9622911.9484903-.2790626,0-.4882252-.1116609-.6136868-.2093418-.3765643-.2928634-.7671085-.4740659-1.3248753-.4740659-1.0599719,0-1.8131005.934331-1.8131005,2.0360638v.02796c0,1.1436728.7391485,2.0640238,1.8968013,2.0640238.5577668,0,.9900719-.1951825,1.3945961-.516006.1114817-.0837009.3206442-.1951825.5717468-.1951825.5020259,0,.8925702.4043451.8925702.9065502,0,.2788834-.1254617.5020259-.3068434.6694277-.6274876.5717468-1.4225562.9622911-2.6497506.9622911-2.2454055,0-3.8911043-1.7293996-3.8911043-3.8631442Z"/>
                                                    <path d="M80.9110947,32.0571284v-3.5425h-.0697208c-.5022052,0-.9065502-.4043451-.9065502-.9065502,0-.5020259.4043451-.906371.9065502-.906371h.0697208v-.9345103c0-.5857268.4740659-1.0599719,1.0597927-1.0599719s1.0599719.4742451,1.0599719,1.0599719v.9345103h.9345103c.5020259,0,.906371.4043451.906371.906371,0,.5022052-.4043451.9065502-.906371.9065502h-.9345103v3.1937166c0,.4882252.2091625.7251685.6834077.7251685.0697208,0,.2091625-.0138008.2511026-.0138008.4740659,0,.8785902.390365.8785902.8785902,0,.3765643-.2511026.6834077-.543966.7948893-.3905443.1534217-.7531285.2091625-1.2133936.2091625-1.2969153,0-2.1755055-.516006-2.1755055-2.2452263Z"/>
                                                    <path d="M93.1414573,33.200622c0,.5857268-.4742451,1.0599719-1.0599719,1.0599719s-1.0599719-.4742451-1.0599719-1.0599719v-.0837009c-.4880459.6276668-1.1157128,1.1994136-2.1894855,1.1994136-1.6039379,0-2.5382689-1.0599719-2.5382689-2.7753915v-3.8631442c0-.5857268.4742451-1.0597927,1.0599719-1.0597927s1.0597927.4740659,1.0597927,1.0597927v3.1937166c0,1.0042311.4742451,1.5202371,1.2831145,1.5202371s1.3248753-.516006,1.3248753-1.5202371v-3.1937166c0-.5857268.4742451-1.0597927,1.0599719-1.0597927s1.0599719.4740659,1.0599719,1.0597927v5.522823Z"/>
                                                    <path d="M95.037004,27.677799c0-.5857268.4742451-1.0597927,1.0599719-1.0597927s1.0599719.4740659,1.0599719,1.0597927v.3348034c.3068434-.7251685.8088693-1.3945961,1.436357-1.3945961.6556269,0,1.0321911.4323051,1.0321911,1.0320119,0,.5577668-.3627635.8925702-.7950686.9900719-1.0737727.2511026-1.6734795,1.0739519-1.6734795,2.580209v1.9803229c0,.5857268-.4742451,1.0599719-1.0599719,1.0599719s-1.0599719-.4742451-1.0599719-1.0599719v-5.522823Z"/>
                                                    <path d="M100.0712434,32.0291684v-.02796c0-1.6317187,1.2413537-2.3848472,3.0125141-2.3848472.7531285,0,1.2969153.1256409,1.8269012.3068434v-.1254617c0-.8785902-.5437868-1.3668153-1.6037587-1.3668153-.5857268,0-1.0599719.0837009-1.4644962.2091625-.1254617.04194-.2091625.0559201-.3066642.0559201-.4882252,0-.8787694-.3765643-.8787694-.8647894,0-.3765643.2371226-.6972085.571926-.8228494.6694277-.2509234,1.3945961-.390365,2.3848472-.390365,1.1574736,0,1.994303.3066642,2.5242889.8366501.5577668.557946.8088693,1.3807954.8088693,2.3848472v3.4030583c0,.5717468-.4602651,1.0180319-1.0320119,1.0180319-.6136868,0-1.0182111-.4323051-1.0182111-.8785902v-.01398c-.516006.5717468-1.2271944.948311-2.2592063.948311-1.4085762,0-2.566229-.8088693-2.566229-2.2871664ZM104.9386187,31.5409432v-.376385c-.3625842-.1674017-.8368294-.2790626-1.3528353-.2790626-.9065502,0-1.464317.3625842-1.464317,1.0320119v.02796c0,.5717468.4740659.9065502,1.1574736.9065502.9902511,0,1.6596787-.543966,1.6596787-1.3110745Z"/>
                                                    <path d="M47.6780541,12.4052382c0-.963564.7802819-1.7435652,1.7438459-1.7435652.9638446,0,1.7438459.7800012,1.7438459,1.7435652v8.2297816c0,.963564-.7800012,1.7435652-1.7438459,1.7435652-.963564,0-1.7438459-.7800012-1.7438459-1.7435652v-8.2297816Z"/>
                                                    <path d="M54.8137041,7.9461764c0-.9868601.7800012-1.7668614,1.7668614-1.7668614h8.9945735c.8947981,0,1.6060335.7112354,1.6060335,1.6063142,0,.8947981-.7112354,1.6060335-1.6060335,1.6060335h-7.2279928v3.4189259h6.1953823c.8947981,0,1.6063142.7112354,1.6063142,1.6060335,0,.8950788-.7115161,1.6063142-1.6063142,1.6063142h-6.1953823v4.5890681c0,.9865795-.7800012,1.7665807-1.7665807,1.7665807-.9868601,0-1.7668614-.7800012-1.7668614-1.7665807V7.9461764Z"/>
                                                    <path d="M69.6589886,7.0971286c0-.963564.7802819-1.7438459,1.7438459-1.7438459.9638446,0,1.7438459.7802819,1.7438459,1.7438459v13.5378912c0,.963564-.7800012,1.7435652-1.7438459,1.7435652-.963564,0-1.7438459-.7800012-1.7438459-1.7435652V7.0971286Z"/>
                                                    <path d="M75.8310746,16.1604679v-.0457503c0-3.5337228,2.8449415-6.4019605,6.6770239-6.4019605,3.8087862,0,6.6309929,2.8224874,6.6309929,6.3559295v.046031c0,3.5334421-2.8449415,6.4016798-6.6770239,6.4016798-3.8087862,0-6.6309929-2.8222067-6.6309929-6.3559295ZM85.6974307,16.1604679v-.0457503c0-1.8128924-1.3079546-3.3959104-3.2353632-3.3959104-1.9961745,0-3.1893322,1.5372676-3.1893322,3.3498794v.046031c0,1.8126117,1.3079546,3.3959104,3.2353632,3.3959104,1.9961745,0,3.1893322-1.5375483,3.1893322-3.35016Z"/>
                                                    <path d="M93.6363782,20.9100832l-3.0057694-8.6731984c-.0687659-.2065782-.1605472-.5506882-.1605472-.8490478,0-.8030167.6424695-1.583018,1.67508-1.583018.8717826,0,1.4454863.5506882,1.6978149,1.3537049l1.8813776,6.2411326,1.9276893-6.2183978c.2523286-.8257516.8947981-1.3994553,1.7895962-1.3994553h.2065782c.8947981,0,1.5372676.5737037,1.7895962,1.3994553l1.9504241,6.2411326,1.9274086-6.2868829c.2295937-.7342509.7572664-1.3306894,1.67508-1.3306894.963564,0,1.629049.7342509,1.629049,1.6060335,0,.2295937-.0687659.5506882-.1147969.7112354l-3.0975508,8.7879952c-.3671254,1.0786415-1.0783608,1.5605638-1.9274086,1.5605638h-.1147969c-.8490478,0-1.5602832-.4819223-1.8813776-1.4915173l-1.9504241-6.1953823-1.9734396,6.1953823c-.3210944,1.009595-1.0323298,1.4915173-1.8813776,1.4915173h-.1147969c-.8487671,0-1.5602832-.4819223-1.9274086-1.5605638Z"/>
                                                    <circle cx="49.4219" cy="7.4554353" r="2.1021526"/>
                                                </g>
                                            </svg>
                                    </router-link>
                                    <a class="link-logo-mobil" href="https://adeverintavechime.ro/?utm_source=app&utm_medium=header&utm_campaign=iflowapp" target="_blank" rel="noopener noreferrer" style="width: 70px;">
<!--                                        <img src="./assets/logo-all-apps-full-irevisal.svg" alt="Logo" class="link-logo-mobil">-->
                                        <svg data-name="Layer 004" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 110 40.4193548" fill="#395FC5">
                                            <path d="M21.9201313,17.829111c1.2785701,0,2.3653551-1.0228563,2.3653551-2.3653551s-1.0228551-2.3653545-2.3653551-2.3653545h-11.5071301v18.7310505h4.6667809v-14.0003409h6.8403492Z"/>
                                            <rect x="3.1251522" y="13.098402" width="4.6667807" height="18.7310499"/>
                                            <path d="M31.5094068,15.4637571h0c0-2.684997-1.0228551-5.1142803-2.8128551-6.8403498s-4.0914228-2.8128545-6.7764204-2.8128545h-11.5071307v4.730709h11.5071307c1.3424976,0,2.6210677.5753563,3.5160677,1.406427.9589276.9589276,1.4064276,2.1096407,1.4064276,3.5160671h0c0,1.3424988-.5753575,2.6210689-1.4064276,3.5160677-.9589276.9589276-2.1096401,1.4064276-3.5160677,1.4064276h-4.2192815v4.6667803l7.7353492,9.269633h6.0732079l-7.8632055-9.3974881c1.9817826-.38357,3.7078527-1.2785701,5.1142803-2.6849976,1.7260701-1.7260701,2.7489252-4.0914252,2.7489252-6.7764216Z"/>
                                            <circle cx="5.4905068" cy="8.1759072" r="2.6210685"/>
                                            <path d="M46.6604652,25.4366039h-10.3564205c.0639275.9589276.38357,1.6621401.895,2.1096401.5114275.5114275,1.1507126.7671425,1.9178551.7671425,1.1507126,0,1.9178551-.5114275,2.3653551-1.4703551h4.8585678c-.255715.9589276-.7032126,1.8539276-1.3424976,2.6849976-.639285.7671425-1.4703575,1.4064276-2.4292851,1.8539276s-2.1096401.639285-3.3242827.639285c-1.4703551,0-2.7489252-.3196425-3.8996378-.9589276s-2.0457126-1.5342851-2.6849976-2.6849976-.9589276-2.4932126-.9589276-4.091424.3196425-2.9407114.9589276-4.091424,1.5342851-2.0457126,2.6849976-2.6849976,2.4292827-.9589276,3.9635677-.9589276c1.4703551,0,2.7489252.3196425,3.8357102.8949988,1.150715.639285,1.9817826,1.4703551,2.6210677,2.6210689.639285,1.1507126.9589276,2.4292827.9589276,3.9635677,0,.5114251,0,.9589251-.0639275,1.4064251ZM42.05761,22.8794638c0-.7671425-.255715-1.4064276-.8310701-1.8539264-.5114275-.4475-1.2146425-.7032138-1.9817826-.7032138-.7671425,0-1.4064276.191785-1.9178551.639285s-.8310701,1.0867851-.9589276,1.9178551h5.6896354Z"/>
                                            <path d="M55.0990257,27.5462441l3.1964252-10.6760606h4.8585653l-5.3060678,14.9592684h-5.6257103l-5.3060678-14.9592696h4.9224928l3.2603625,10.6760618Z"/>
                                            <path d="M68.9075815,16.8701835v14.9592684h-4.6028503v-14.9592684h4.6028503Z"/>
                                            <path d="M74.0218618,31.3819543c-1.0228551-.4475-1.8539276-1.0867851-2.4292851-1.8539276s-.895-1.6621401-1.0228551-2.6210677h4.5389228c.0639275.5114275.3196425.9589276.7032126,1.2785701s.9589276.5114275,1.5982126.5114275c.5753575,0,1.0228551-.1278575,1.3424976-.3196425s.4474976-.5114275.4474976-.895c0-.4475-.1917875-.7671425-.639285-.9589276s-1.150715-.4475-2.1735701-.7032126c-1.0867826-.255715-1.9817826-.5114275-2.6849952-.7671425s-1.3424976-.7032138-1.8539276-1.3424988c-.51143-.5753563-.7671401-1.4064276-.7671401-2.4292827,0-.8310701.255715-1.6621413.7032126-2.3653551s1.150715-1.2785701,2.1096426-1.6621413c.895-.3835713,2.0457102-.639285,3.2603527-.639285,1.8539276,0,3.3242802.4475,4.4110677,1.4064276,1.0867826.9589276,1.7260677,2.1735689,1.8539227,3.7078527h-4.2192803c-.0639275-.5114275-.3196425-.9589276-.7032126-1.2146413-.38357-.3196425-.895-.4475-1.5342851-.4475-.51143,0-.9589276.1278575-1.2146425.3196425s-.4474976.5114275-.4474976.8310701c0,.4475.255715.7671425.7032126.9589276s1.150715.4475,2.1096426.639285c1.0867826.2557138,1.9817826.5753563,2.6849952.8310701s1.2785701.7032138,1.8539276,1.3424988c.51143.639285.8310725,1.4703551.8310725,2.4932126,0,.895-.255715,1.6621401-.7671401,2.3653551-.51143.7032126-1.2146425,1.2146425-2.1096426,1.5982126s-1.9817826.5753575-3.1964252.5753575c-1.2146377,0-2.3653527-.191785-3.3882078-.639285Z"/>
                                            <path d="M85.5289974,20.2583949c.5753526-1.1507126,1.3425025-2.0457126,2.3653527-2.6849964,1.02286-.639285,2.1096426-.9589276,3.3242802-.9589276,1.02286,0,1.9817875.191785,2.7489276.639285s1.4064251,1.0228563,1.8539227,1.6621413v-2.1096401h4.6028503v14.9592696h-4.6028503v-2.1096401c-.4474976.7032126-1.0867826,1.2785701-1.8539227,1.6621401s-1.7260677.639285-2.7489276.639285c-1.2146377,0-2.30143-.3196425-3.3242802-.9589276-1.02286-.639285-1.7900001-1.5342851-2.3653527-2.6849976s-.8949952-2.4932126-.8949952-4.091424c.0639227-1.4703563.3196328-2.8128551.8949952-3.9635677ZM94.9264855,21.6008937c-.639285-.639285-1.4064251-1.0228563-2.30143-1.0228563s-1.662145.3196425-2.30143.9589276-.9589276,1.5342838-.9589276,2.6849964.3196425,2.0457126.9589276,2.7489252c.639285.639285,1.4064251,1.0228551,2.30143,1.0228551s1.662145-.3196425,2.30143-1.0228551c.639285-.639285.9589276-1.5342851.9589276-2.6849976,0-1.0867826-.3196425-1.9817826-.9589276-2.6849952Z"/>
                                            <path d="M107.5843312,11.9476894v19.817835h-4.6028503V11.9476882s4.6028503,0,4.6028503.0000012Z"/>
                                            <circle cx="66.6061564" cy="12.2673319" r="2.6210683"/>
                                        </svg>
                                    </a>
                                    <a class="logo-nav-dropdown" href="https://tagdiv.ro/?utm_source=app&utm_medium=header&utm_campaign=iflowapp" target="_blank" rel="noopener noreferrer" style="width: 70px;">
<!--                                        <img src="./assets/logo-all-apps-full-tagdiv.svg" alt="Logo" class="link-logo-mobil">-->
                                        <svg data-name="Layer 002" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 118.7096774 35.2580645" fill="#395FC5">
                                            <g>
                                                <path d="M58.719361,9.4932383v2.6477859h2.8763625v1.5294595h-2.8763625v5.9577515c0,1.3694283.3881001,2.1456469,1.5067034,2.1456469.5479005,0,.8675015-.0455261,1.1640694-.1370305l.0913014,1.5069111c-.3878693.1595697-1.0043151.2966002-1.7805152.2966002-.935816,0-1.6890292-.3195917-2.1684307-.8672707-.5706567-.593662-.7762001-1.5754287-.7762001-2.8763394v-6.026269h-1.7120161v-1.5294595h1.7120161v-2.0316171l1.9630718-.6161689Z"/>
                                                <path d="M71.6171337,20.541489c0,.9587798.045743,1.8945681.1825566,2.6477998h-1.8260274l-.1598005-1.3924152h-.0685453c-.6163997.8672707-1.8032713,1.6434893-3.3784739,1.6434893-2.2369298,0-3.3782892-1.5749764-3.3782892-3.1729396,0-2.6707867,2.3739741-4.1317194,6.6427518-4.1087325v-.228535c0-.9128014-.2511019-2.5562861-2.5110185-2.5562861-1.027302,0-2.1001162.319601-2.8763163.8217585l-.4564145-1.3243776c.9130137-.593182,2.2369298-.9813282,3.6293449-.9813282,3.3784739,0,4.2002324,2.3057058,4.2002324,4.5198472v4.1317194ZM69.676818,17.551106c-2.1914176-.0459784-4.679403.3421355-4.679403,2.4882301,0,1.3009107.8672707,1.9171072,1.8945727,1.9171072,1.4381582,0,2.3511719-.9128014,2.6707728-1.8485897.0685453-.2055527.1140575-.4340877.1140575-.6391876v-1.9175601Z"/>
                                                <path d="M84.2872531,21.5913209c0,2.53377-.5021575,4.0862164-1.5752025,5.0449732-1.0728142,1.0043151-2.6250298,1.3239161-4.017445,1.3239161-1.3241007,0-2.7850611-.319601-3.6750879-.9132445l.5021575-1.5294595c.7304571.4565992,1.8718166.8677323,3.2414295.8677323,2.0543732,0,3.5610766-1.0728604,3.5610766-3.8581246v-1.2323931h-.045743c-.6164458,1.0272928-1.8033175,1.849042-3.5153336,1.849042-2.7392719,0-4.7023899-2.3286604-4.7023899-5.3871041,0-3.7440486,2.4424733-5.8667363,4.9762479-5.8667363,1.9175596,0,2.9676177,1.0043151,3.4467883,1.9175596h.045743l.0913014-1.6664578h1.7577591c-.0457892.7987254-.0913014,1.6890292-.0913014,3.0358999v6.4143968ZM82.3011944,16.5008217c0-.3421309-.0227561-.6391835-.1140575-.9128014-.365344-1.1643279-1.3469029-2.1231262-2.8078172-2.1231262-1.9173288,0-3.2869879,1.6209732-3.2869879,4.1772686,0,2.1686338,1.0955703,3.9721497,3.2642318,3.9721497,1.2326147,0,2.3511719-.7762186,2.7848303-2.0545901.1142421-.3421327.1598005-.730242.1598005-1.0728234v-1.9860772Z"/>
                                                <path d="M87.6891742,8.009291c1.2098585-.1825566,2.6482475-.319601,4.2232192-.319601,2.8533755,0,4.8849925.6621888,6.2318493,1.9175596,1.3694282,1.2553708,2.1681998,3.0359322,2.1681998,5.5241484,0,2.5107646-.7757847,4.5653548-2.2141736,5.9807615-1.4379273,1.4379412-3.8121322,2.2141598-6.8025059,2.2141598-1.4149404,0-2.6022737-.068513-3.6065887-.1825566v-15.1344718ZM89.6752791,21.6143124c.5021575.0910521,1.2328454.1140436,2.008584.1140436,4.2457906,0,6.5514502-2.3741846,6.5514502-6.5284451.0229869-3.6295434-2.031617-5.9352492-6.2318493-5.9352492-1.027302,0-1.8030405.0915322-2.3281849.2055435v12.1441072Z"/>
                                                <path d="M105.0617293,9.036593c.0225253.6847141-.4796322,1.2323839-1.2784038,1.2323839-.707701,0-1.2098585-.5476698-1.2098585-1.2323839,0-.707701.5246828-1.2553708,1.2554186-1.2553708.7532116,0,1.2328438.5476698,1.2328438,1.2553708ZM102.8245688,23.1892888v-11.0482645h2.008584v11.0482645h-2.008584Z"/>
                                                <path d="M108.9428222,12.1410243l2.1681537,6.2088395c.3655747,1.0043077.6621888,1.9175596.8902595,2.8308133h.0685434c.2510557-.9132537.5706566-1.8265056.9362314-2.8308133l2.1456283-6.2088395h2.1001181l-4.3372786,11.0482645h-1.9175134l-4.2002784-11.0482645h2.1461361Z"/>
                                            </g>
                                            <path d="M31.777084,33.835236c-.3957863,0-.7232364-.1318107-.9996802-.4020032l-5.8476231-5.696064-5.8496825,5.696064c-.2766214.2701925-.6035376.4020032-.9996802.4020032-.3948994,0-.7216381-.1318107-.9987923-.4020032L1.8280928,18.5773699c-.2603182-.2539248-.4049513-.5908929-.4049513-.9483554,0-.3570718.1446331-.6942175.4049513-.9483199L17.0809508,1.8246553c.2778291-.2705477.6045677-.4018269.9994671-.4018269.3954322,0,.722526.1312792.9996802.401152l5.8496825,5.6968808,5.8469128-5.696206c.2778646-.2705477.6046043-.4018269,1.0003906-.4018269.3947218,0,.7224905.1312792.9996447.401152l15.25268,14.8567142c.2601406.2541024.4047737.5912481.4047737.9483199,0,.3574625-.1446331.6944306-.4047737.9483554l-15.25268,14.8558629c-.2764438.2701925-.6038928.4020032-.9996447.4020032M28.3871575,24.3687667l2.5432263,2.4755983c.2313348.2268239.5168004.3416566.8467002.3416566.3298654,0,.6139447-.1148327.847021-.342367l8.6081531-8.384918c.2275356-.2206081.3534488-.5159835.3534488-.8297222,0-.3135611-.1259133-.6085458-.3534488-.8303615l-8.6088291-8.3854497c-.2327555-.2268605-.51719-.3420118-.846345-.3420118-.3291894,0-.6139802.1151513-.8467002.342509l-12.9213944,12.5835739-3.458265-3.36826,6.9196201-6.739396-2.5434039-2.4764152c-.2328976-.2268605-.5176884-.3420118-.8465226-.3420118-.3286566,0-.6137671.1151513-.846345.342509l-8.6091845,8.3849524c-.2282091.2218157-.3539461.5168004-.3539461.8303615,0,.3137387.125737.6091141.3539461.8297222l8.6091845,8.3856283c.2318676.2268239.5170135.3416566.846345.3416566.3295446,0,.6139447-.1148327.8470554-.342367l12.9200092-12.5837162,3.4599698,3.369076-6.9202948,6.7397522Z"/>
                                        </svg>
                                    </a>
                                    <a class="logo-nav-dropdown" href="https://control-acces.ro/?utm_source=app&utm_medium=header&utm_campaign=iflowapp" target="_blank" rel="noopener noreferrer" style="width: 70px;">
                                        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 106.8709677 40.4193535" fill="#395FC5">
                                            <g id="uuid-cee7a0cf-c18e-4480-8bc0-cd5730627742">
                                                <path class="cls-1" d="M4.267264,17.0755891c1.1870089.666676,2.4986808,1.000015,3.9350155,1.000015,1.6260395,0,3.0732147-.3956694,4.3415257-1.1870091,1.2683109-.7913398,2.1870231-1.9187261,2.7588471-3.3848727h-3.0108834c-.3956694.8048899-.9458134,1.4065238-1.6477206,1.8021942-.7046167.3956694-1.5176365.5935041-2.4390593.5935041-1.0108544,0-1.9133064-.2303552-2.7046456-.6910666s-1.4092342-1.1165469-1.8563952-1.9675084-.6693863-1.8374243-.6693863-2.9675223.2222253-2.1165613.6693863-2.9675223c.4471608-.8509605,1.065056-1.5013767,1.8563952-1.9566674.7913393-.4552912,1.691081-.6802266,2.7046456-.6802266.9241324,0,1.7371522.1978347,2.4390593.5935046s1.2520501.9973043,1.6477206,1.8021937h3.0108834c-.5718241-1.4661456-1.4905362-2.5962431-2.7588471-3.3957125-1.2683109-.7994694-2.7154861-1.1978491-4.3415257-1.1978491-1.4227846,0-2.7290363.3333382-3.9241753,1.0000142-1.195139.6666762-2.1382419,1.5935185-2.8347289,2.7805277-.6964869,1.1870091-1.0433753,2.5284914-1.0433753,4.0217378s.3468884,2.8347287,1.0433753,4.0217378c.6964868,1.1870091,1.6368798,2.1138512,2.8238887,2.7805282Z"/>
                                                <polygon class="cls-1" points="41.8233572 6.5388527 49.3627583 17.94552 51.8668607 17.94552 51.8668607 2.6471979 49.3627583 2.6471979 49.3627583 14.0321842 41.8233572 2.6471979 39.3192548 2.6471979 39.3192548 17.94552 41.8233572 17.94552 41.8233572 6.5388527"/>
                                                <polygon class="cls-1" points="54.3736716 4.7149782 58.4631601 4.7149782 58.4631601 17.94552 60.9672624 17.94552 60.9672624 4.7149782 65.0323612 4.7149782 65.0323612 2.6688784 54.3736716 2.6688784 54.3736716 4.7149782"/>
                                                <path class="cls-1" d="M77.3740036,9.9562459c.5799581-.8130198.8672244-1.7181818.8672244-2.7154861,0-.8509605-.2005422-1.6179091-.6043477-2.3062661-.4037972-.6883567-1.0108576-1.2385-1.8238773-1.64772s-1.8049049-.6151851-2.9783598-.6151851h-5.2737859v15.2739315h2.5068109v-6.1111984h1.9133058l3.5176685,6.1111984h2.9892023l-3.7805452-6.3307141c1.2032699-.2926876,2.0921712-.8455403,2.6694165-1.65856h-.0027127ZM70.0649556,9.8342927v-5.1193145h2.7696877c.9512358,0,1.6639844.2222256,2.1328205.6693863.4688444.4471608.7046188,1.065056.7046188,1.8563952s-.2384871,1.4227846-.7154614,1.8916259-1.1842975.7019071-2.1219779.7019071h-2.7696877Z"/>
                                                <path class="cls-1" d="M92.3633773,3.473768c-1.19514-.6666762-2.5095237-1.0000143-3.9458553-1.0000143s-2.7290383.3333381-3.9241784,1.0000143-2.1382459,1.5935188-2.8347266,2.7805279c-.6964889,1.1870091-1.043377,2.5284914-1.043377,4.0217378s.3468881,2.8401489,1.043377,4.0325783c.6964889,1.195139,1.6395865,2.1246917,2.8347266,2.7913676s2.5013938,1.0000139,3.9241784,1.0000139,2.7507152-.333338,3.9458553-1.0000139,2.1355332-1.5962286,2.8238923-2.7913676,1.0325344-2.5393314,1.0325344-4.0325783-.3441754-2.8347287-1.0325344-4.0217378-1.6314567-2.1138514-2.8238923-2.7805279ZM92.9785593,13.251686c-.4471592.8563808-1.0650539,1.5176365-1.8563968,1.9783479s-1.6937912.6910666-2.7046487.6910666-1.9133058-.2303552-2.7046487-.6910666-1.4092376-1.1219671-1.8563968-1.9783479-.6693866-1.8482648-.6693866-2.9783618.2222274-2.1165613.6693866-2.9675223c.4471592-.8509605,1.0650539-1.5013767,1.8563968-1.9566674.7913429-.4552912,1.6910785-.6802266,2.7046487-.6802266s1.9133058.2276456,2.7046487.6802266c.7913429.4552912,1.4092376,1.1057069,1.8563968,1.9566674s.6720993,1.840135.6720993,2.9675223-.2249318,2.1219821-.6720993,2.9783618Z"/>
                                                <polygon class="cls-1" points="101.1873511 15.9238111 101.1873511 2.6688784 98.6832529 2.6688784 98.6832529 17.94552 106.352736 17.94552 106.352736 15.9238111 101.1873511 15.9238111"/>
                                                <path class="cls-1" d="M6.3811154,24.9293589L.9880844,39.8401404h3.8022222l.8916119-2.6341844h5.5637649l.8916119,2.6341844h3.8455831l-5.3957411-14.9107836s-4.2060224,0-4.2060219.0000021ZM6.6358618,34.4010404l1.8265843-5.4580725,1.8482654,5.4580725h-3.6748497Z"/>
                                                <path class="cls-1" d="M24.4572546,28.0730369c.6937762,0,1.3143815.1626035,1.8591054.4878127.5447238.3252071.9674934.7994686,1.2628917,1.4227846h3.9946365c-.4254803-1.615199-1.2683109-2.8889292-2.528492-3.8239031-1.260181-.9349719-2.7751069-1.4011036-4.5447796-1.4011036-1.4444656,0-2.7371661.3224985-3.875395.9674934-1.1409375.6449949-2.0271302,1.5447367-2.6667038,2.6965147-.6368651,1.1544886-.9566529,2.4661595-.9566529,3.940436s.3197879,2.7832367.9566529,3.9295935,1.5257663,2.0433879,2.6667038,2.6856763c1.1409375.644997,2.4309294.9674955,3.875395.9674955,1.7696727,0,3.2846006-.4634231,4.5447816-1.3902651s2.1030117-2.1978636,2.528492-3.8130626h-3.9946365c-.2981068.6233139-.7181679,1.0975754-1.2628896,1.4227825-.5447238.3252071-1.1653292.4878127-1.8591054.4878127-1.1192565,0-2.0244195-.3902501-2.7181957-1.1680377-.6937762-.7777897-1.0406643-1.818454-1.0406643-3.1219971s.3468881-2.3442074,1.0406643-3.1219971,1.5989393-1.1680377,2.7181957-1.1680377l-.0000041.0000021Z"/>
                                                <path class="cls-1" d="M40.6417683,28.0730369c.6937762,0,1.3143836.1626035,1.8591054.4878127.5447218.3252071.9674955.7994686,1.2628917,1.4227846h3.9919259c-.4254823-1.615199-1.2683088-2.8889292-2.528492-3.8239031-1.260179-.9349719-2.7751089-1.4011036-4.5447816-1.4011036-1.4444656,0-2.7371682.3224985-3.875395.9674934-1.1409396.6449949-2.0271302,1.5447367-2.6667038,2.6965147-.6368651,1.1544886-.9566529,2.4661595-.9566529,3.940436s.3170772,2.7832367.9566529,3.9295935c.6368651,1.1463567,1.5257684,2.0433879,2.6667038,2.6856763,1.1409396.644997,2.4309294.9674955,3.875395.9674955,1.7696727,0,3.2845985-.4634231,4.5447816-1.3902651,1.260179-.926842,2.1030096-2.1978636,2.528492-3.8130626h-3.9919259c-.2981089.6233139-.7181658,1.0975754-1.2628917,1.4227825-.5447218.3252071-1.1653292.4878127-1.8591054.4878127-1.1192585,0-2.0244195-.3902501-2.7181957-1.1680377-.6937762-.7777897-1.0406643-1.818454-1.0406643-3.1219971s.3468881-2.3442074,1.0406643-3.1219971,1.5989372-1.1680377,2.7181957-1.1680357Z"/>
                                                <polygon class="cls-1" points="49.988787 39.8401404 59.1217082 39.8401404 59.1217082 36.9295323 53.6202737 36.9295323 53.6202737 33.6584808 58.4848411 33.6584808 58.4848411 30.853563 53.6202737 30.853563 53.6202737 27.8372605 59.1217082 27.8372605 59.1217082 24.9293589 49.988787 24.9293589 49.988787 39.8401404"/>
                                                <path class="cls-1" d="M70.0920579,31.9159104c-.601635-.2981068-1.3848438-.6097648-2.346918-.9349719-.9620742-.311658-1.6721102-.601635-2.1246907-.8699309s-.680225-.6449949-.680225-1.1246778c0-.4390314.1355033-.775079.4038013-1.0081448s.623316-.3495987,1.0623453-.3495987c.5094937,0,.926842.1382139,1.2520491.4146397s.5013638.6558354.5311747,1.1355183h3.9295955c-.0704644-1.4011036-.6097648-2.4959704-1.6151969-3.2818899-1.0054363-.7859195-2.3306583-1.1788782-3.9729576-1.1788782s-2.9241593.3929587-3.9295955,1.1788782-1.506796,1.8726544-1.506796,3.2602089c0,.9349719.2195147,1.6910805.658544,2.2737451.4390293.5799539.9620742,1.0189853,1.571839,1.3170922s1.3956823.5935051,2.3577565.8916119c.666678.1978357,1.1788803.3739883,1.5393154.5311727.3604393.1571843.666678.355018.9132909.5935051.246617.2411957.3712777.5447238.3712777.9132929,0,.4390293-.1571843.7832089-.4661317,1.0298259-.3116559.246617-.7371383.3712777-1.2737301.3712777s-.9485231-.1463417-1.2737301-.4363208-.5176236-.7127486-.5745326-1.2628917h-3.8645525c.0271023.9783339.3008175,1.8130347.8184411,2.5068109s1.2059785,1.2168211,2.0704902,1.571839,1.8401329.5311747,2.9322891.5311747,2.0894626-.2059635,2.9106081-.6151861c.8211496-.4092185,1.4471742-.9620742,1.8807864-1.6558504.4308995-.6937762.6477097-1.4661466.6477097-2.3143944,0-.8916119-.2195147-1.6206203-.658544-2.1870231s-.9593656-.9973043-1.5610006-1.2954112l-.0027127-.0054234Z"/>
                                                <path class="cls-1" d="M20.3894451,10.7502953c-.3252071-.0731719-.6477056.1327937-.7208785.4580008-.2195147.9810436-.3143686,1.9160165-.3143686,2.7940783,0,.8672213.0921412,1.6775304.246617,2.4282188.0677516.3252081.3848289.5365929.7127466.4688413.3252071-.0677516.536594-.3848289.4688423-.7127476h0c-.1382139-.6748069-.2222253-1.4038142-.2222253-2.1870231,0-.7913398.0840114-1.63688.2845577-2.5312016.0731709-.3252081-.1327926-.6477056-.4580018-.7208775l.0027106.0027106Z"/>
                                                <path class="cls-1" d="M23.4003284,6.072721h.0027106l.0027106-.0081304c1.0244046-1.0813162,2.3658884-1.5826785,3.7100809-1.5826785,1.0704752,0,2.1355312.322498,3.013594.9268426.8780608.6070547,1.571839,1.485116,1.9241464,2.6260535h0v.0081304c.1598929.495942.2384851,1.0162747.2384851,1.5420276,0,.5365929-.0813028,1.0758965-.2330658,1.5989393v.0081299h0c-.1002732.3577286-.2195147.7262977-.3197879,1.1219671-.0975625.3929598-.1761547.8130198-.1842846,1.2656013-.0054192.333338.2628767.6070552.5962137.6097648.333339.0054203.6070542-.2628767.6097648-.5962147.0027106-.3197879.0596218-.6422853.1463438-.9864638.086722-.3414678.2005443-.6991965.3089473-1.0813167h0v-.0054203h0c.1815739-.6233149.2791365-1.2764408.2791365-1.9295666,0-.6395757-.0948519-1.2845712-.2953962-1.9051765h0v-.0081304h0c-.4336101-1.4011041-1.3062517-2.5095211-2.390278-3.2547892-1.086737-.7479782-2.3848588-1.1409377-3.6965297-1.1409377-1.6422993,0-3.3171201.6233152-4.5800118,1.9539575h0s-.0027106.0027101-.0054192.0054203h0c-.5826646.5962147-1.0542155,1.2764413-1.441755,1.9973188-.1571843.2926871-.0487813.6585461.246617.8157299.2926876.1571838.6585461.0487813.8157304-.246616h0c.3468881-.6449955.7561086-1.2303696,1.2466299-1.7317319l.0054172-.0027101Z"/>
                                                <path class="cls-1" d="M27.4572974,9.1378059c-.2872663-.1707339-.6558354-.075882-.8265709.2113848h0c-.9512337,1.5989393-1.4525955,3.1355461-1.4553061,4.6044014,0,.7344276.1273734,1.4471752.3794096,2.1246917.2520362.6802261.6314458,1.3225124,1.1246778,1.9295666.2113848.2574554.5907944.2981068.8482499.086722s.2981068-.5907944.086722-.8482509c-.420061-.5149129-.7262977-1.043375-.9295527-1.5880988-.2032549-.5447228-.3035281-1.108417-.3035281-1.7046317,0-1.1870091.4092205-2.5149408,1.2845706-3.9865067.1707334-.2872674.0758815-.6558365-.2113848-.8265699l.0027127-.0027086Z"/>
                                                <polygon class="cls-1" points="36.1295103 12.8885371 36.1295103 12.8831169 36.1295103 12.8885371 36.1295103 12.8885371"/>
                                                <path class="cls-1" d="M36.3788359,9.5632862c-.0135512-1.430915-.3008175-2.723616-.8021813-3.853714-.753398-1.6965013-1.9864788-3.0217234-3.4580446-3.913335-1.4742744-.8943216-3.1843253-1.3604529-4.9187679-1.3604529-1.688372,0-3.3984229.4444508-4.9241892,1.3740034-1.5203471.9268424-2.8509884,2.3414971-3.7778325,4.2520934h0s-.0027106.0081304-.0054192.0135501c0,0,0,.0027101-.0027106.0054203h0c-.4363208.8319901-.7913387,1.6992114-1.0813167,2.5772727l-.0298109.0921423v.0975625c0,.333338.2710066.6043446.6043446.6043446.2682959,0,.4932319-.1761547.5718241-.42006h0c.2710066-.8265699.6043456-1.63688,1.0108555-2.4092484l.0054192-.0108405v-.0081304c.84012-1.7236021,2.0081598-2.9539717,3.3333819-3.7669915,1.3279327-.8103096,2.8184689-1.1978491,4.295454-1.1978491,2.0244195,0,4.0136069.7290077,5.4878834,2.0786206.7398489.6748063,1.3523223,1.5013767,1.7859345,2.477.4336101.9756238.6883549,2.1003011.6991975,3.3767418h0v.1355033c0,.9756233-.1192436,2.0515198-.2384851,3.0271431-.0677516.5149129-.1571843.9918841-.2953962,1.4038142-.1382139.4119301-.3252071.753398-.5826646,1.0352451l-.0054192.0054203-.0054192.0054203c-.4525805.5149129-1.1653292.8103102-1.8807864.8075995-.4227696,0-.8374094-.1002721-1.19514-.3008175h-.0081299l-.0081299-.0081299c-.3956694-.2086752-.7208785-.5365929-.9458124-.9349729-.224936-.39838-.3495987-.861801-.3495987-1.3225124,0-.1165329.0081299-.2303552.0243896-.3441785v-.0189704c.0460706-.4281909.2032549-.9024524.3794096-1.4146547.1707334-.5040724.3577286-1.0487952.4092205-1.6531398h0v-.0298109h0c.0135512-.1219532.021681-.2411957.021681-.3604393,0-.463421-.1056924-.9078722-.2872663-1.3035415-.2737172-.5962147-.7181679-1.0894466-1.2547598-1.441755-.536594-.3495982-1.1707484-.5582734-1.8347137-.5582734-.4227696,0-.8563818.086722-1.2710216.2737167h-.0108384c-.44174.1924144-.818439.4607114-1.1382268.7723689-.4823914.4715514-.8319901,1.0352451-1.1111266,1.6124894s-.4905213,1.173459-.6802271,1.7208914v.0054203l-.0027106.0081299c-.3712798,1.1463577-.550143,2.2439342-.550143,3.2954401,0,2.013579.6639653,3.8374543,1.8049028,5.4662024.1897038.2737172.5664028.3387582.84012.1490545s.3387582-.5664028.1490545-.84012h0c-1.0271152-1.4715659-1.5853881-3.0271431-1.5880988-4.7751368,0-.9132919.1544737-1.8807853.4905213-2.9187411.2493256-.7181679.5203322-1.4580157.8807714-2.0623603.1815739-.3035276.3848289-.5745337.6124755-.7967595.2303552-.2249354.485102-.4037998.7832089-.5338828h0l.0081299-.0054203c.2574554-.1165329.5176236-.1680243.7804982-.1680243.5447238,0,1.1002861.235776,1.5095066.6233149.2059656.1951246.3712798.4227701.485102.6720962s.1788653.5176231.1788653.7994691c0,.0785922-.0054192.1571843-.0162597.2411957v.0135501l-.0027106.0135501c-.0298109.4146397-.1788653.8780618-.3523094,1.3848438-.1707334.5040724-.3631478,1.0487952-.4336101,1.6558504h0v.0162608h0c-.021681.1626035-.0325215.3279177-.0325215.4932319,0,.6720962.1761547,1.3360626.5067831,1.9160165.3252071.5745337.8076005,1.0731858,1.4173654,1.4011046h0s.0054192.0027096.0081299.0054203c0,0,.0054192,0,.0054192.0027096h0c.550143.3062377,1.1626185.4498709,1.7723833.4498709,1.0298259,0,2.0596497-.4065099,2.7751069-1.2059795h0s0-.0027096.0027106-.0054203c0,0,.0027106-.0027096.0054192-.0054203h0c.3956694-.4309005.6558375-.9349729.8319901-1.4580157.1788653-.5284631.2764279-1.0786061.3495967-1.6341694v-.0054203c.1219521-.9891745.2493256-2.1057213.2493256-3.1789072v-.1463438l.0054172.0108436Z"/>
                                                <polygon class="cls-1" points="36.3788359 9.5632862 36.3788359 9.5632862 36.3788359 9.5632862 36.3788359 9.5632862"/>
                                            </g>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div v-else class="navbar-header">
                            <a v-if="!this.$store.getters.isLoggedIn" :class="{'navbar-brand': !$store.getters.isIphoneOrIpodState, 'navbar-brand-iphone': $store.getters.isIphoneOrIpodState}" :href="getHomePageLink()">
                                <img src="./assets/iflow-efactura-white.png" alt="logo-efactura" style="width: 100%; height: 100%"/>
                            </a>
                            <router-link v-else :to="{ name: 'mainEfacturaRoute', params: {}}" class="navbar-brand" active-class="active">
                                <img src="./assets/iflow-efactura-white.png" alt="logo-efactura" style="width: 100%; height: 100%"/>
                            </router-link>
                        </div>



                        <!-- logo button efactura with dropdown -->
                        <div id="navbar-efactura-main" class="navbar-collapse collapse">
                            <ul class="nav navbar-nav navbar-left">
                                <li v-if="$store.getters.isAdmin" class="nav-item dropdown td-logo-dropdown" @mouseenter="onMouseEnterNav" @mouseleave="onMouseLeaveNav">
                                    <a v-if="!this.$store.getters.isLoggedIn" :class="{'navbar-brand': !$store.getters.isIphoneOrIpodState, 'navbar-brand-iphone': $store.getters.isIphoneOrIpodState}" :href="getHomePageLink()" id="logo-dropdown" class="td-navbar-link dropdown-toggle nav-user td-navbar-dropdown" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                        <img src="./assets/iflow-efactura-white.png" alt="efactura_logo" style="margin-left: 10px;" />
                                    </a>
                                    <router-link v-else :to="{ name: 'mainEfacturaRoute', params: {}}" class="navbar-brand td-navbar-link dropdown-toggle nav-user td-navbar-dropdown" active-class="active">
                                        <a href="#" class="logo-nav-dropdown">
                                            <img src="./assets/iflow-efactura-white.png" alt="efactura_logo" style="margin-left: 10px;" />
                                        </a>
                                    </router-link>

                                    <ul class="dropdown-menu" style="left: 0">
                                        <router-link tag="li" class="td-navbar-link" active-class="active" exact :to="{name: 'dashboardRoute'}">
                                            <a href="#" class="logo-nav-dropdown logo-nav-dropdown-active">
                                                <!--                                            <img src="./assets/logos-all-apps-iflow.svg" alt="Logo" class="link-logo">-->
                                                <svg id="Layer_4" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 60 60" class="link-logo">
                                                    <circle cx="30" cy="30" r="30" fill="#f4f4f4" stroke-width="0"/>
                                                    <g>
                                                        <path d="M30.0014424,10.1557028c-10.9622423.0010042-19.8421608,8.8849098-19.8432634,19.8452322.0011027,10.9563846,8.8810211,19.8402806,19.8432634,19.8433622,10.9594561-.0030816,19.8403786-8.8869776,19.8403786-19.8433622,0-10.9603224-8.8809225-19.844228-19.8403786-19.8452322ZM30.0014424,47.807055c-4.9227313,0-9.3670372-1.9910872-12.5936065-5.2147747-.1888311-.190557-.3746336-.3832407-.5545707-.5812999h.2787273c.814502.0037511,1.6012628-.275936,2.1578115-.8353201.5596598-.5554361.8369938-1.3418149.8341091-2.1568438v-6.1179195c0-.6397616.5190476-1.155964,1.1602959-1.1588093.6411991.0028453,1.1593803.5190476,1.1603353,1.1588093v5.9102414c.0019297,1.7651459,1.4312797,3.1979222,3.1972921,3.199842,1.7665929-.0019198,3.1960414-1.4318114,3.1975379-3.199842v-11.0733377c.0017232-.6407166.5193824-1.1598627,1.1620681-1.1617334.639801.0018706,1.1593803.5210167,1.1607192,1.1617334v11.0733377c0,1.7651459,1.4285431,3.1979222,3.1951358,3.199842,1.7665833-.0019198,3.1963764-1.4318114,3.1973417-3.199842v-5.9102414c.0019193-.6397616.5206229-1.155964,1.1617328-1.1588093.6396533.0028453,1.1593212.5190476,1.1607685,1.1588093v6.1171516c-.0037511.8139754.2744986,1.6021756.8338728,2.1576117.556204.5593841,1.3425828.8390712,2.1571391.8353201h.2795887c-.180948.1980592-.3661196.3907428-.5555345.5812999-3.2250264,3.2236875-7.6717837,5.2147747-12.5907641,5.2147747ZM44.7534806,39.9738366h-1.8853282c-.3888131-.0037511-.5880335-.1120107-.717924-.2366137-.1253709-.1302837-.2335419-.3293964-.236909-.7191744v-6.1171516c-.000571-1.7651065-1.4322839-3.1940234-3.1969474-3.1940234-1.7655397,0-3.1968588,1.4289169-3.1968588,3.1940234v5.9102414c-.0014473.640628-.5218831,1.1626982-1.1622157,1.1626982-.6398601,0-1.1588486-.5220702-1.1602959-1.1626982v-11.0733377c0-1.7660123-1.4307477-3.1959036-3.1955592-3.1969078-1.7669279.0010042-3.197341,1.4308955-3.19931,3.1969078v11.0733377c0,.640628-.5205343,1.1626982-1.1602959,1.1626982-.6407166,0-1.1588979-.5220702-1.1602861-1.1626982v-5.9102414c-.0017328-1.7651065-1.4332488-3.1940234-3.1973413-3.1940234-1.7660123,0-3.195894,1.4297833-3.1972921,3.1940234v6.1179195c-.0034626.3890101-.1111463.5881227-.2361844.7184064-.1297974.1246029-.3303573.2328626-.7187401.2366137h-1.8848922c-1.9274468-2.8454483-3.0527916-6.2742541-3.0527916-9.9729016,0-4.9208607,1.9901814-9.3676673,5.2135273-12.5932745,3.2265692-3.2246916,7.6708752-5.215828,12.5936065-5.215828,4.9199452,0,9.3657377,1.9911364,12.5907641,5.215828,3.2243569,3.2256072,5.2145875,7.6724138,5.2145875,12.5932745,0,3.6986476-1.1262605,7.1274534-3.0533134,9.9729016Z" fill="#395fc5" stroke-width="0"/>
                                                        <path d="M32.6117636,19.8154034c0,1.4423361-1.1682706,2.6107544-2.6103212,2.6107544-1.4441673,0-2.6131567-1.1684183-2.6131567-2.6107544,0-1.4413712,1.1689894-2.6108036,2.6131567-2.6108036,1.4420505,0,2.6103212,1.1694324,2.6103212,2.6108036Z" fill="#395fc5" stroke-width="0"/>
                                                        <path d="M41.3271166,24.9804195c0,1.4413808-1.1673058,2.6127233-2.6107445,2.6127233-1.4421982,0-2.6106559-1.1713424-2.6106559-2.6127233,0-1.441322,1.1684577-2.6107445,2.6106559-2.6107445,1.4434387,0,2.6107445,1.1694226,2.6107445,2.6107445Z" fill="#395fc5" stroke-width="0"/>
                                                        <path d="M23.8948651,24.9804195c0,1.4413808-1.1687531,2.6127233-2.610656,2.6127233-1.4428677,0-2.6117587-1.1713424-2.6117587-2.6127233,0-1.441322,1.1688909-2.6107445,2.6117587-2.6107445,1.4419029,0,2.610656,1.1694226,2.610656,2.6107445Z" fill="#395fc5" stroke-width="0"/>
                                                    </g>
                                                </svg>
                                                {{$__('Pontaje & HR')}}
                                            </a>
                                        </router-link>
                                        <router-link tag="li" class="td-navbar-link" active-class="active" exact :to="{name: 'mainEfacturaRoute'}">
                                            <a href="#" class="logo-nav-dropdown logo-nav-dropdown-active">
                                                <!--                                            <img src="./assets/logos-all-apps-efactura.svg" alt="Logo" class="link-logo">-->
                                                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 60 60" class="link-logo">
                                                    <circle cx="30" cy="30" r="30" fill="#f4f4f4" stroke-width="0"/>
                                                    <g>
                                                        <circle cx="17.5464912" cy="35.4884916" r="3.1924721" fill="#395fc5" stroke-width="0"/>
                                                        <g>
                                                            <path d="M44.3597994,32.3544203c-1.1283869-.3715262-2.3442572.242062-2.7157525,1.3704489-.5218419,1.5851105-1.3731982,3.0572835-2.5061261,4.3044464-1.1337002,1.24741-2.5458828,2.2709219-4.2093021,2.9696148-1.5137832.6350265-3.0733777.9330013-4.6110706.9333719-2.6188783.0006796-5.1744918-.871559-7.2429076-2.4467227-.9452804-.7195444-2.2948779-.5365151-3.0143914.4087499-.7195289.945265-.5365151,2.2948624.4087653,3.0144068l-.0000154-.0000309c2.8157004,2.1425698,6.2764051,3.3248924,9.8485491,3.325572,2.0956772.0003707,4.2295975-.4093677,6.2760653-1.2686321,2.2499469-.9439985,4.1854233-2.34401,5.7287692-4.0438807,1.5440873-1.7001178,2.6990713-3.6989825,3.4078656-5.8515919.3714953-1.1283869-.2420929-2.3442572-1.3704489-2.7157525Z" fill="#395fc5" stroke-width="0"/>
                                                            <path d="M25.6946155,19.0011314c1.5135978-.6351192,3.0731924-.933063,4.6110088-.9334337,2.3268964-.0004325,4.6038112.6876339,6.5334801,1.9464427,1.358216.8867883,2.5414036,2.0513795,3.4593301,3.4609055l-16.8101941,7.0564031c-1.0953799.4597818-1.6106111,1.7205367-1.1507983,2.8159012.4597973,1.0953644,1.7205367,1.6105956,2.8159012,1.1508138v-.0000309l18.9730747-7.9643209c.5222744-.2192644.9443074-.6452824,1.1585983-1.1696264.2142601-.5243132.2114181-1.1240004-.0078154-1.6462747-1.3003881-3.1000985-3.4649522-5.5980384-6.0881244-7.3072382-2.6236664-1.7106207-5.7096168-2.6445178-8.8834521-2.6449503-2.0956772-.0003707-4.229721.409275-6.2762043,1.2687557-2.8097075,1.1786466-5.1263327,3.0678791-6.8069273,5.3646259-1.6817376,2.2972411-2.7358008,5.0025524-3.0481089,7.8382856-.129943,1.1808399.7219847,2.2434289,1.90284,2.3733565,1.1808399.1299276,2.2434289-.7219847,2.373372-1.9028246.2288252-2.0827956,1.0065836-4.0794054,2.2428729-5.7672285,1.2374322-1.6883483,2.9250237-3.0672922,5.0011468-3.9395617Z" fill="#395fc5" stroke-width="0"/>
                                                        </g>
                                                    </g>
                                                </svg>
                                                {{$__('Facturare & stocuri')}}
                                            </a>
                                        </router-link>
                                        <li class="td-navbar-link">
                                            <a class="logo-nav-dropdown" href="https://adeverintavechime.ro/?utm_source=app&utm_medium=header&utm_campaign=iflowapp" target="_blank" rel="noopener noreferrer">
                                                <!--                                            <img src="./assets/logos-all-apps-iR.svg" alt="Logo" class="link-logo">-->
                                                <svg id="Layer_3" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 60 60" class="link-logo">
                                                    <circle cx="30" cy="30" r="30" fill="#f4f4f4" stroke-width="0"/>
                                                    <g>
                                                        <path d="M35.9327872,27.4979248c1.2714787,0,2.3522361-1.0171832,2.3522361-2.3522361s-1.017182-2.3522355-2.3522361-2.3522355h-11.443308v18.6271624h4.6408975v-13.9226907h6.8024105Z" fill="#395fc5" stroke-width="0"/>
                                                        <rect x="17.2420508" y="22.7934538" width="4.6408973" height="18.6271618" fill="#395fc5" stroke-width="0"/>
                                                        <path d="M45.4688777,25.1456899h0c0-2.6701052-1.017182-5.0859149-2.7972542-6.8024111s-4.0687305-2.7972536-6.7388363-2.7972536h-11.4433086v4.7044711h11.4433086c1.3350517,0,2.6065304.5721652,3.4965665,1.3986265.9536091.9536091,1.3986271,2.09794,1.3986271,3.4965659h0c0,1.3350529-.5721664,2.6065316-1.3986271,3.4965665-.9536091.9536091-2.0979394,1.3986271-3.4965665,1.3986271h-4.1958801v4.6408969l7.6924466,9.2182208h6.039524l-7.8195937-9.3453668c1.9707911-.3814427,3.6872878-1.2714787,5.0859149-2.6701058,1.7164968-1.7164968,2.7336788-4.0687329,2.7336788-6.7388375Z" fill="#395fc5" stroke-width="0"/>
                                                        <circle cx="19.5942865" cy="17.8982607" r="2.6065312" fill="#395fc5" stroke-width="0"/>
                                                    </g>
                                                </svg>
                                                {{$__('Adeverință vechime')}}
                                            </a>
                                        </li>
                                        <li class="td-navbar-link">
                                            <a class="logo-nav-dropdown" href="https://tagdiv.ro/?utm_source=app&utm_medium=header&utm_campaign=iflowapp" target="_blank" rel="noopener noreferrer">
                                                <!--                                            <img src="./assets/logos-all-apps-tagdiv.svg" alt="Logo" class="link-logo">-->
                                                <svg id="Layer_2" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 60 60" class="link-logo">
                                                    <circle cx="30" cy="30" r="30" fill="#f4f4f4" stroke-width="0"/>
                                                    <path d="M35.8504717,43.8419995c-.3390982,0-.6184119-.1121081-.8556371-.3437853l-4.99292-4.8649357-4.9967488,4.8649357c-.2362687.2316773-.5155824.3437853-.8538197.3437853-.3371851,0-.6164988-.1121081-.8528632-.3437853l-13.0293116-12.6883003c-.2213465-.216755-.3456028-.5044863-.3456028-.8099139s.1242563-.5931589.3456028-.8099139l13.0284507-12.6883003c.2372253-.2316773.5165389-.3437853.853724-.3437853.3372808,0,.617551.1121081.8538197.3428288l4.9967488,4.8649357,4.99292-4.8639792c.2372253-.2316773.5165389-.3437853.8556371-.3437853.3363242,0,.6174553.1121081.8528631.3428288l13.0283548,12.6892568c.2214421.216755.3447419.5044863.3447419.8099139s-.1232998.5931589-.3447419.8099139l-13.0283548,12.6883003c-.2354078.2316773-.5165389.3437853-.8528631.3437853M32.9537407,35.7561567l2.1728113,2.1148443c.19705.194276.4418321.2914619.7239197.2914619.2812267,0,.5240957-.0971858.7221023-.2914619l7.3525487-7.16296c.194276-.1877715.3026564-.4408755.3026564-.7080409,0-.268122-.1083804-.5202695-.3026564-.709954l-7.3525487-7.1620034c-.1980066-.1933195-.4408755-.2924184-.7221023-.2924184-.2811311,0-.5249566.0990989-.7239197.2924184l-11.036808,10.7490793-2.9537417-2.8771218,5.911214-5.7561567-2.1728114-2.1158008c-.1989631-.1933195-.4427886-.2924184-.7230588-.2924184-.2811311,0-.524.0990989-.7229632.2924184l-7.3535055,7.1620034c-.194276.1896846-.301697.4418321-.301697.709954,0,.2671654.107421.5202695.301697.7080409l7.3535055,7.16296c.1980066.194276.4418321.2914619.7229632.2914619.2812267,0,.5240957-.0971858.7230588-.2914619l11.0358514-10.7490793,2.9546982,2.8780783-5.9112139,5.7561567Z" fill="#395fc5" fill-rule="evenodd" stroke-width="0"/>
                                                </svg>
                                                {{$__('Custom IT solutions')}}
                                            </a>
                                        </li>
                                        <li class="td-navbar-link">
                                            <a class="logo-nav-dropdown" href="https://control-acces.ro/?utm_source=app&utm_medium=header&utm_campaign=iflowapp" target="_blank" rel="noopener noreferrer">
                                                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 60 60" class="link-logo">
                                                    <circle class="cls-2" cx="30" cy="30" r="30" fill="#f4f4f4" stroke-width="0"/>
                                                    <g id="uuid-95d6ad2e-202a-4dab-bd3f-b5df70f5169e" fill="#395fc5" fill-rule="evenodd" stroke-width="0">
                                                        <path class="cls-1" d="M17.0648978,30.4034308c-.6207359-.1385886-1.2368128.2527196-1.3742365.8734555-.418094,1.8750185-.5974437,3.659196-.5974437,5.3362316,0,1.6549078.1758555,3.2038341.4693366,4.6374672.1281066.6230656.7360318,1.024853,1.3602614.8967491.6230647-.1281075,1.0248544-.7371949.8967477-1.3602605h0c-.2643659-1.2903851-.4227526-2.6832563-.4227526-4.1739522,0-1.5116598.1618803-3.1246417.542707-4.8354501.1385881-.6207359-.25272-1.2368124-.8746199-1.374237v-.0000036Z"/>
                                                        <path class="cls-1" d="M20.432942,24.778378h0c.661497-1.2321548,1.4452781-2.3525073,2.3816216-3.307485l.0069874-.0069874.0058234-.0069874c1.9577046-2.0636843,4.516347-3.0209917,7.0866363-3.0244854,2.0427222,0,4.0772896.6172422,5.7543252,1.7713676,1.6781996,1.15762,3.0011936,2.8358186,3.6766662,5.0147997v.0034937l.0046576.0128108c.3074563.9456606.4541961,1.9402362.4553619,2.9441272,0,1.0236891-.153729,2.056697-.4448808,3.0512708l-.0046576.0163044v-.0034937c-.1898316.6836239-.4180936,1.3893775-.6079252,2.1405488-.1886658.7511714-.3389012,1.5524218-.3493822,2.4153962-.0081531.6358764.5007815,1.1587839,1.1378218,1.1657713.6358764.0081531,1.1587839-.5007815,1.1657713-1.1378218.0069874-.6102549.1152968-1.2274953.2806708-1.8820059.1630443-.6498511.3819911-1.333475.589291-2.067178h0l.0034937-.0116468h0c.3482165-1.1925585.5345543-2.4363583.5345543-3.6871472,0-1.2240017-.1793505-2.4538285-.5625038-3.6393979h0l-.0034937-.0093171-.0023279-.0069874h0c-.8291998-2.6785968-2.4945887-4.7946881-4.5664243-6.2166744-2.0764951-1.4278088-4.557109-2.1766514-7.059849-2.1778158-3.1362867-.0034937-6.3342991,1.1913932-8.7450359,3.7290727h0l-.0046585.0046585-.0093171.0093171h0c-1.1122003,1.1378218-2.0124413,2.4363583-2.7531316,3.8164187-.3004689.5601758-.0908392,1.2589402.4693366,1.5594091s1.2589402.0908392,1.5594091-.4693366l.0011595.0000009Z"/>
                                                        <path class="cls-1" d="M30.5650257,27.3253745c-.5473651-.3249247-1.2531168-.1455759-1.5792072.4017892h0c-1.8167881,3.0547645-2.7764234,5.9872467-2.7775883,8.7927853,0,1.3998585.2422376,2.7612847.7267147,4.0586554.4833113,1.2973743,1.2053693,2.5283615,2.1487002,3.6848157.4017892.4926302,1.127339.5671632,1.6211332.1653758.4937941-.4017909.5671632-1.127339.165374-1.621135-.8012504-.9840946-1.3870477-1.9926414-1.7760262-3.0338024-.3878145-1.0411592-.5811397-2.117257-.5811397-3.2539131,0-2.2674906.7826163-4.8051692,2.4538267-7.6153672.3249247-.5473651.1455759-1.2531168-.4017892-1.5792072l.0000018.0000036Z"/>
                                                        <path class="cls-1" d="M47.6020672,28.1336123c-.0244558-2.7310038-.5741506-5.2011367-1.5326237-7.3603179-1.4382908-3.2411024-3.7919611-5.7694648-6.6033231-7.473285-2.8136917-1.7049861-6.0827453-2.5959107-9.394887-2.5959107-3.2224682,0-6.4915218.8466695-9.4042041,2.625025-2.9045309,1.7713676-5.4445392,4.4720923-7.2170717,8.1219712h0l-.0116461.0232918-.0058229.010481h0c-.8315296,1.5873595-1.5139895,3.2422664-2.0625195,4.9216299l-.0570658.1735271v.1886658c0,.6358764.515921,1.1517966,1.1517967,1.1517966.5124273,0,.9421672-.3365714,1.091237-.8000847h.0034939c.5159211-1.5792072,1.1552905-3.1281353,1.9285894-4.5990349l.0104815-.0197981.0069878-.0151396c1.5955121-3.2911805,3.8268997-5.643687,6.3610855-7.1926146,2.5353506-1.5477632,5.3828152-2.2872887,8.2046582-2.2872887,3.865332,0,7.6642805,1.3940351,10.4826316,3.968982,1.4103378,1.2880559,2.5807702,2.868428,3.4088043,4.7317997.8268719,1.8633717,1.3125112,4.0120719,1.334639,6.4484302v.0023297c0,.0861816.0011657.1711974.0011657.257379,0,1.8645357-.2247684,3.917739-.4576898,5.7811107-.1281075.9852586-.2981392,1.8948166-.5636695,2.6785968-.2655303.7872739-.6184062,1.4394547-1.1121986,1.9763388l-.0081531.0093171-.0081531.0093171c-.8618087.9829289-2.2267286,1.5454344-3.5916485,1.5431047-.8082378,0-1.6013351-.1933252-2.283795-.5764803l-.0128108-.0069874-.0139747-.0069874c-.7569948-.3994595-1.375401-1.0260188-1.8063053-1.7876729-.4309044-.7593245-.6673195-1.6479186-.6661555-2.5248696,0-.2212747.0151405-.4413854.0442556-.6591682l.0023297-.0186341v-.0128108c.0873455-.8198828.3901442-1.7224534.7267156-2.7007247.3249247-.9631308.681296-2.0007963.7826163-3.1560865h.0023297l.001164-.0256215.0034937-.0291152h-.0023297c.0267855-.2317575.0430899-.4623492.0430899-.6906113,0-.8874302-.2014766-1.7329363-.5496948-2.491095-.5240733-1.1378218-1.3730712-2.0823176-2.397926-2.7508028-1.0260188-.6673204-2.2383754-1.064451-3.5066327-1.0656159-.8082378,0-1.6362736.165374-2.4270412.5229084h0l-.010481.0046585-.0081531.0034937h0c-.8431763.3691803-1.5652325.8816077-2.1731577,1.4767221-.92004.9014058-1.5873595,1.9786676-2.1219147,3.0803869-.5345543,1.1040472-.9375092,2.2407051-1.3008662,3.287686l-.0023288.0081531-.0046585.0139747c-.7104103,2.1882981-1.0528051,4.2857553-1.0516403,6.2923732-.0034937,3.8455339,1.2670924,7.328873,3.4472375,10.4395417.3645218.5217454,1.0830852.6486871,1.6036639.2841645.5217436-.3645227.6486871-1.0830834.2841645-1.603663h0c-1.9600343-2.810198-3.027979-5.7822746-3.0314727-9.1188757,0-1.7422533.2958104-3.5904846.9363444-5.572645.47516-1.3730712.9910811-2.7822468,1.6828572-3.9387028.3458885-.5811397.7325381-1.0958959,1.1704298-1.5244706.4390575-.4274107.9246985-.7698055,1.4976851-1.0190314l.0046576-.0023288.0139747-.0058234c.4891347-.2224404.9887523-.3225958,1.4918617-.3225958,1.0376655-.0034937,2.1009508.4483736,2.8835671,1.1925576.3913081.3703452.7104112.8082369.9281922,1.2833969.2189467.476324.3389012.9887523.3389012,1.5279642,0,.1502336-.0093171.3027986-.0291152.4588556l-.0034937.0279512-.0023297.0256215c-.0582304.7896036-.3400651,1.6758699-.6731429,2.6436583-.3249247.9596371-.6952707,2.0007963-.8291998,3.1630739h-.001164l-.0023297.0209621-.0023297.0116468h0c-.0419259.3132797-.062888.6265593-.062888.9398372,0,1.2845617.3377354,2.5504893.9654587,3.66036.6230656,1.0993896,1.539611,2.0497096,2.708876,2.6739374h0l.0151405.0081531.0128108.0069874h0c1.0504763.5834694,2.2232349.8571493,3.3843486.858315,1.964692-.0023279,3.9363713-.7779568,5.3012912-2.3035931h0l.0081531-.0081531.0093153-.0093171h0c.7535011-.8245422,1.2507871-1.7853432,1.5861946-2.7834108.3389012-1.0073846.5264012-2.0601906.6649898-3.1199822v-.0081531l.0023279-.0069874v.0058234c.2340872-1.8878292.473996-4.0225529.4751582-6.0676031,0-.0943329,0-.1886658-.0011657-.2818348l.0000071-.0023297Z"/>
                                                        <polygon class="cls-1" points="47.6020672 28.1336123 47.6020672 28.1336123 47.6020672 28.1359402 47.6020672 28.1336123"/>
                                                    </g>
                                                </svg>
                                                {{$__('Control acces')}}
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                            <!-- conectare -->
                            <router-link id="dashboard-tab" v-if="$store.getters.isLoggedIn === true && allowRegistration" tag="li" class="td-navbar-link td-efactura-connection-status" active-class="active" to="/mainEfactura" style="display: flex">
                                <i v-if="$store.getters.accountIsConnectedEfactura === 'connected'" class="fa fa-circle" style="position: absolute; z-index: 1; left: 9px; top: 50%; transform: translateY(-50%); color: #9AC16E;"></i>
                                <a style="padding: 15px 17px;" href="#">{{isConnected}}</a>
                            </router-link>

                            <!-- companii -->
                            <router-link v-if="$store.getters.isLoggedIn === true && allowRegistration && $store.getters.accessToSpvCompaniesEfactura" tag="li" class="td-navbar-link" active-class="active" to="/companyEfactura">
                                <a href="#">{{$__('e-Factura SPV')}}</a>
                            </router-link>

                            <!-- facturare -->
                            <router-link v-if="$store.getters.isLoggedIn === true && allowRegistration && $store.getters.accessToSpvCompaniesEfactura" tag="li" class="td-navbar-link" active-class="active" to="/billingEfactura">
                                <a href="#">{{$__('Facturare')}}</a>
                            </router-link>

                                <!-- clienti -->
                            <router-link v-if="$store.getters.isLoggedIn === true && allowRegistration && $store.getters.accessToSpvCompaniesEfactura" tag="li" class="td-navbar-link" active-class="active" to="/clientsEfactura">
                                <a href="#">{{$__('Clienți')}}</a>
                            </router-link>

                            <!-- articole -->
                            <router-link v-if="$store.getters.isLoggedIn === true && allowRegistration && $store.getters.accessToSpvCompaniesEfactura" tag="li" class="td-navbar-link" active-class="active" to="/articlesEfactura">
                                <a href="#">{{$__('Articole')}}</a>
                            </router-link>

                            <!-- categorii articole -->
                            <router-link v-if="$store.getters.isLoggedIn === true && allowRegistration && $store.getters.accessToSpvCompaniesEfactura" tag="li" class="td-navbar-link" active-class="active" to="/categoriesEfactura">
                                <a href="#">{{$__('Categorii de articole')}}</a>
                            </router-link>

                            <!-- setari -->
                            <router-link v-if="$store.getters.isLoggedIn === true && allowRegistration && $store.getters.isAdmin && $store.getters.accessToSpvCompaniesEfactura" tag="li" class="td-navbar-link" active-class="active" to="/efacturaSettings">
                                <a href="#">{{$__('Setări')}}</a>
                            </router-link>

                            </ul>
                        </div><!--/.nav-collapse -->

                        <ul class="nav navbar-nav navbar-right">
                            <li v-if="this.$store.getters.isLoggedIn === true && allowRegistration" @mouseenter="onMouseEnterNav" @mouseleave="onMouseLeaveNav" @click="onClickNav" class="nav-item dropdown">

                                <a href="#" data-toggle="dropdown" class="dropdown-toggle nav-user td-navbar-dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                    <span class="nav-user-name-efactura" style="margin-right: 5px">{{$store.state.user.full_name}}</span>
                                </a>
                                <ul class="dropdown-menu" style="">

<!--                                    <li class="td-navbar-link"><a href="#" @click="logOutEfactura_onClick">{{$__('Logout')}}</a></li>-->
                                    <li><a href="#" @click="logOutEfactura_onClick">{{$__('Logout')}}</a></li>
                                </ul>
                            </li>
                        </ul>

                    </div>
                </div>

        </nav>


        <nav v-else-if="$route.name !== 'locationCheckInRoute' && $route.name !== 'loginEfacturaRoute' && $route.name !== 'passwordRecoverEfacturaRoute' && $route.name !== 'mainEfacturaRoute' && $route.name !== 'companyEfacturaRoute' && $route.name !== 'messagesCompanyEfacturaRoute' && $route.name !== 'registerCompanyEfacturaRoute' &&
        $route.name !== 'billingEfacturaRoute' && $route.name !== 'clientsEfacturaRoute' && $route.name !== 'articlesEfacturaRoute' && $route.name !== 'categoriesEfacturaRoute' && $route.name !== 'efacturaSettingsRoute' && $route.name !== 'teamInfoPageRoute' && $route.name !== 'teamInfoReportRoute' && $route.name !== 'loginRfid' && $route.name !== 'dashboardRfid' && $route.name !== 'myProfile'" key="3" class="navbar navbar-default navbar-fixed-top">
            <top-site-message
                    v-if="$store.getters.isTeamLederOrAdmin === true"
                    @tdTopSiteMessageHeight="setRouterViewTopMargin"
            ></top-site-message>
            <div class="container">
                <div class="col-md-12 td-navbar-wrap">
                    <div class ="td-login-menu" v-if="$store.getters.isLoggedIn === false && allowRegistration">
                        <!-- login -->
                        <router-link class="td-navbar-link td-navbar-login-register" active-class="active" :to="{ name: 'loginRoute', params:{language: language} }"><a href="#">{{$__('Log in')}}</a></router-link>
                        <!-- register company -->
                        <div v-if="!$store.getters.isIphoneOrIpodState && isLoginLanguage('ro_RO')" class="td-navbar-link td-navbar-login-register"><a href="https://iflow.ro/cont-nou-home">{{$__('Register your company')}}</a></div>
                        <div v-else-if="!$store.getters.isIphoneOrIpodState && isLoginLanguage('hu_HU')" class="td-navbar-link td-navbar-login-register"><a href="https://iflowapp.hu/uj-fiok/">{{$__('Register your company')}}</a></div>
                        <div v-else-if="!$store.getters.isIphoneOrIpodState && isLoginLanguage('en_US')" class="td-navbar-link td-navbar-login-register"><a href="https://iflow.ro/en/new-account">{{$__('Register your company')}}</a></div>
                        <div v-else-if="!$store.getters.isIphoneOrIpodState && isLoginLanguage('es_ES')" class="td-navbar-link td-navbar-login-register"><a href="https://app.iflow.ro/#/registerCompany/es_ES">{{$__('Register your company')}}</a></div>
                        <div v-else-if="!$store.getters.isIphoneOrIpodState" class="td-navbar-link td-navbar-login-register"><a href="https://iflow.ro/cont-nou-home">{{$__('Register your company')}}</a></div>
                    </div>
                    <button v-else type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar" ref="navbarToggle">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>


                    <!-- logo button with dropdown for mobile -->
                    <div v-if="$store.getters.isAdmin">
                        <div class="navbar-header button-logo-dropdown-mobile" :class="{ 'is-open': isDropdownOpen }">
                            <a @click="toggleLogoDropdown" v-if="!this.$store.getters.isLoggedIn"
                               :class="{
                                'navbar-brand': !$store.getters.isIphoneOrIpodState,
                                'navbar-brand-iphone': $store.getters.isIphoneOrIpodState,
                                'button-logo-dropdown-mobile-arrow': true
                            }"
                               :href="getHomePageLink()"
                               class="button-logo-dropdown-mobile-arrow"
                            >
                                <img src="./assets/logo-image2.png" alt="log-iflow"/>
                            </a>
                            <router-link v-else-if="$store.state.company.country_code === 'RO'" :to="{ name: 'dashboardRoute', params: {}}" class="navbar-brand  button-logo-dropdown-mobile-arrow" active-class="active">
                                <img @click="toggleLogoDropdown" src="./assets/logo-image2.png" alt="log-iflow"/>
                            </router-link>
                            <router-link v-else :to="{ name: 'dashboardRoute', params: {}}" class="navbar-brand" active-class="active">
                                <img src="./assets/logo-image2.png"/>
                            </router-link>
                        </div>
                        <div v-show="isDropdownOpen" class="logo-dropdown-container">
                            <div class="logo-swiper-container">
                                <router-link class="td-navbar-link" active-class="active" exact :to="{ name: 'dashboardRoute', params: {}}" style="width: 70px;">
                                    <!--                                        <img src="./assets/logo-all-apps-full-iflow.svg" alt="Logo" class="link-logo-mobil">-->
                                    <svg data-name="Layer 003" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 124.7422243 46.5729221" fill="#395FC5">
                                        <g>
                                            <path d="M24.4936368,1.7001233c-12.1503844.0010997-21.9925372,9.8465517-21.9936368,21.9947359.0010997,12.1426867,9.8432524,21.9881373,21.9936368,21.9925378,12.145986-.0044005,21.9925378-9.8498511,21.9925378-21.9925378,0-12.1481842-9.8465517-21.9936362-21.9925378-21.9947359ZM24.4936368,43.4286496c-5.4566212,0-10.3831964-2.2059623-13.9582614-5.7799283-.2100392-.2100413-.4156795-.4233757-.6147222-.6444119h.3090107c.9028389.0044005,1.7748868-.3057114,2.3918082-.9259311.6202207-.6158212.9270322-1.4867691.924832-2.3885099v-6.7817377c0-.7103944.5751333-1.2822294,1.2844286-1.2833285.7114945.0010991,1.2844286.5729341,1.2866278,1.2833285v6.5497044c.0021992,1.9563333,1.5857416,3.5442762,3.543174,3.5464744,1.9585335-.0021982,3.543175-1.5857406,3.5442741-3.5464744v-12.2724492c.0022003-.7092953.5751344-1.2855288,1.2888281-1.2866278.7092953.0010991,1.2855288.5773325,1.2855288,1.2866278v12.2735483c0,1.9563333,1.5835424,3.5442762,3.542076,3.5464744,1.9574344-.0021982,3.542076-1.5857406,3.543175-3.5464744v-6.5497044c.0022003-.7103944.5762335-1.2822294,1.2877269-1.2833285.7092953.0010991,1.2844276.5729341,1.2844276,1.2833285v6.7784405c-.0032993.903939.3057114,1.7759859.9259311,2.3918072.6158212.6191206,1.4878702.9303316,2.3907081.9259311h.3090087c-.2001412.2210363-.404683.4343748-.6158233.6444119-3.5717615,3.5728669-8.501635,5.7788293-13.9527587,5.7788293ZM40.8437065,34.7477621h-2.0893972c-.4310734-.0043984-.6510106-.1231638-.7961686-.2606241-.1385593-.145158-.2584259-.3650952-.2617231-.7994679v-6.7784405c-.0010991-1.9563333-1.5868418-3.542076-3.543175-3.542076-1.9574344,0-3.5442741,1.5846415-3.5442741,3.542076v6.5497044c0,.7103944-.5773325,1.2888281-1.2866278,1.2888281-.7103944,0-1.2855288-.5784316-1.2866278-1.2888281v-12.2735483c0-1.9563333-1.5857406-3.5409758-3.5409748-3.5409758-1.9585335,0-3.5442741,1.5835414-3.5464744,3.5409758v12.2735483c0,.7103944-.5773325,1.2888281-1.2866278,1.2888281-.7103944,0-1.2833285-.5784316-1.2855277-1.2888281v-6.5497044c-.0021992-1.9563333-1.5890399-3.542076-3.5442752-3.542076-1.9563343,0-3.5420749,1.5857406-3.5442741,3.542076v6.7817377c-.0032993.4310755-.1220648.6510106-.2617242.7961686-.1429588.1374602-.3661943.2562257-.7961696.2606241h-2.0893956c-2.1366816-3.1527885-3.3826213-6.9532882-3.3826213-11.0529008,0-5.4533219,2.2059616-10.3820963,5.7777283-13.9571624,3.5750651-3.573966,8.5005401-5.7799278,13.9582604-5.7799278,5.4522228,0,10.3809951,2.2059618,13.953862,5.7799278,3.5750651,3.5750661,5.7821265,8.5038405,5.7821265,13.9571624,0,4.0996146-1.248137,7.9001144-3.3859188,11.0529028Z"/>
                                            <circle cx="24.4914366" cy="12.4066258" r="2.8943626"/>
                                            <path d="M37.0465061,18.1315698c0,1.5945385-1.2932265,2.8932624-2.8932635,2.8932624-1.5989379,0-2.8943626-1.298724-2.8943626-2.8932635,0-1.600037,1.2954247-2.8943626,2.8943626-2.8943626,1.5989379.0011001,2.8932635,1.2943266,2.8932635,2.8943636Z"/>
                                            <path d="M17.7261945,18.1315698c0,1.5945385-1.2954257,2.8932624-2.8943626,2.8932624-1.5978378,0-2.8943626-1.298724-2.8943626-2.8932635,0-1.600037,1.2965248-2.8943626,2.8943626-2.8943626,1.5978378.0011001,2.8943626,1.2943266,2.8943626,2.8943636Z"/>
                                        </g>
                                        <g>
                                            <g>
                                                <path d="M57.8095995,34.102249c-.6587083,0-1.1755602-.5575387-1.1755602-1.267933v-12.5319742c0-.6851009.5267477-1.2701333,1.1524669-1.2701333.6609107,0,1.1788574.560838,1.1788574,1.2701333v12.5319742c0,.7213914-.4970558,1.267933-1.1557642,1.267933h0Z"/>
                                                <path d="M65.5953448,34.102249c-.6400156,0-1.1810597-.5960274-1.1810597-1.2954247V15.3636704c0-.7048958.5410441-1.2976249,1.1810597-1.2976249h11.0715977c.6125219,0,1.1029791.5289469,1.1029791,1.184357,0,.6686063-.4904572,1.2140489-1.1029791,1.2140489h-9.8674447v6.6156857h8.7171801c.6070265,0,1.1029791.530047,1.1029791,1.184357,0,.6565102-.4959526,1.1865572-1.1029791,1.1865572h-8.7171801v7.3546719c.0010991.715894-.5410441,1.2965258-1.204153,1.2965258h0Z"/>
                                                <path d="M82.2148353,34.102249c-.6609065,0-1.1777583-.5575387-1.1777583-1.267933V14.3585607c0-.7015976.5157527-1.267933,1.1513637-1.267933.6499157,0,1.1744611.5674356,1.1744611,1.267933v18.4757553c0,.7213914-.4904572,1.267933-1.1480664,1.267933h0Z"/>
                                                <path d="M93.7966903,34.2979918c-3.9445566,0-7.0335692-3.3617265-7.0335692-7.6581851,0-4.384431,3.1132007-7.77255,7.0841519-7.77255,3.9621502,0,7.0599554,3.3639268,7.0599554,7.6603833,0,4.3822328-3.1230924,7.7703519-7.1105382,7.7703519h0ZM93.7966903,21.1238038c-2.6513363,0-4.652757,2.3247278-4.652757,5.402737,0,3.0967041,2.0662998,5.4830137,4.7033397,5.4830137,2.66893,0,4.6813498-2.3115304,4.6813498-5.3708449-.0000084-3.115401-2.0773073-5.5149059-4.7319325-5.5149059h0Z"/>
                                                <path d="M116.9383936,34.1880232h-.0758783c-.6059274,0-1.0490991-.3936859-1.2481412-1.1106789l-3.1252989-9.9686165-3.1538834,9.9730149c-.1913486.6971991-.6477092,1.1062805-1.2426375,1.1062805-.6389166,0-1.10188-.4002845-1.3229205-1.1062805l-4.0160386-12.1910734c-.0703829-.2243356-.1374602-.436573-.1374602-.6433129,0-.6708066.5267435-1.2140489,1.1777583-1.2140489.5553363,0,.9842116.373892,1.1689657,1.0260038l3.1505861,10.2600315,3.180278-10.2919215c.1946458-.6400156.6015227-.9930126,1.141472-.9930126h.1066693c.5663355,0,1.0018136.363994,1.1953519.9952128l3.1505861,10.2908225,3.2000782-10.3227146c.1803494-.6191206.5740374-.9644219,1.1194736-.9644219.6400156,0,1.1579665.5311461,1.1579665,1.1887554,0,.1935447-.0670773.4024827-.1187675.5729341l-4.0600268,12.2889437c-.2210321.6906026-.6884002,1.1040823-1.2481328,1.1040823h0Z"/>
                                            </g>
                                            <path d="M57.785403,16.9428134c-1.0622922,0-1.9244432-.8654493-1.9244432-1.9277426s.862151-1.9255433,1.9244432-1.9255433c1.0611931,0,1.9255423.8632501,1.9255423,1.9255433s-.8643492,1.9277426-1.9255423,1.9277426h0Z"/>
                                        </g>
                                    </svg>
                                </router-link>
<!--                                <router-link class="td-navbar-link" active-class="active" exact :to="{name: 'mainEfacturaRoute'}" style="width: 70px;">-->
<!--                                    &lt;!&ndash;                                        <img src="./assets/logo-all-apps-full-efact.svg" alt="Logo" class="link-logo-mobil">&ndash;&gt;-->
<!--                                    <svg data-name="Layer 001" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 110 40.4193548" fill="#395FC5">-->
<!--                                        <g>-->
<!--                                            <circle cx="5.2250028" cy="26.4432585" r="3.6258658"/>-->
<!--                                            <g>-->
<!--                                                <path d="M35.6783484,22.8837218c-1.2815709-.4219627-2.6625015.2749231-3.0844291,1.556494-.5926845,1.800297-1.5596165,3.4723247-2.8463449,4.888796-1.2876055,1.416752-2.8914988,2.5792106-4.7807354,3.3727545-1.7192866.7212345-3.4906038,1.0596607-5.2370459,1.0600817-2.9744038.0007719-5.8769543-.9898774-8.2261677-2.7788772-1.0736069-.817226-2.6064188-.6093497-3.4236097.4642397-.8172085,1.0735893-.6093497,2.6064012.4642572,3.4236272l-.0000175-.0000351c3.1979454,2.433434,7.1284577,3.7762627,11.1855377,3.7770346,2.3801756.000421,4.803786-.4649414,7.1280718-1.4408551,2.5553882-1.0721509,4.753615-2.6622208,6.5064776-4.5928572,1.7537047-1.9309171,3.0654835-4.2011375,3.8705-6.645974.4219276-1.2815709-.2749582-2.6625015-1.556494-3.0844291Z"/>-->
<!--                                                <path d="M14.4792747,7.7176587c1.7190761-.7213398,3.4903933-1.0597309,5.2369757-1.0601519,2.642784-.0004912,5.228801.7809836,7.4204319,2.2106818,1.5426005,1.0071741,2.8864116,2.3298643,3.928951,3.9307403l-19.0922599,8.0143443c-1.244083.5221995-1.8292594,1.954108-1.3070248,3.1981735.522217,1.2440655,1.954108,1.8292418,3.1981735,1.3070424v-.0000351l21.5487621-9.0455163c.5931756-.2490306,1.0725017-.7328826,1.3158837-1.3284089.2433469-.5954912.2401191-1.2765889-.0088764-1.8697646-1.4769221-3.520952-3.9353364-6.3579995-6.9146169-8.2992314-2.9798419-1.9428458-6.4847251-3.003524-10.0894241-3.0040152-2.3801756-.000421-4.8039263.4648361-7.1282296,1.4409954-3.191139,1.3386536-5.8222573,3.4843587-7.7310009,6.0929001-1.9100417,2.6091027-3.1071991,5.6816733-3.4619046,8.9023711-.1475834,1.3411446.8199977,2.5479853,2.1611599,2.6955512,1.3411446.1475659,2.5479853-.8199977,2.6955688-2.1611423.2598893-2.3655453,1.1432323-4.6332045,2.5473538-6.5501579,1.4054196-1.9175498,3.3221099-3.4836921,5.6800769-4.4743765Z"/>-->
<!--                                            </g>-->
<!--                                        </g>-->
<!--                                        <g>-->
<!--                                            <path d="M50.5388841,34.3442948c-2.2453159,0-3.9049947-1.5759779-3.9049947-3.8631442v-.02796c0-2.1337446,1.5201474-3.8911043,3.6958321-3.8911043,2.4964185,0,3.5981513,2.050223,3.5981513,3.5982409,0,.6136868-.4323051,1.0180319-.9901615,1.0180319h-4.1978581c.2091625.9622911.8785902,1.4644962,1.8269012,1.4644962.5858164,0,1.0739519-.1813817,1.506257-.5022052.1534217-.1114817.2928634-.1672225.516006-.1672225.4741555,0,.8228494.3625842.8228494.8366501,0,.2790626-.1255513.4882252-.2788834.6276668-.6555373.5577668-1.506257.9065502-2.5940994.9065502ZM51.9056098,29.8534837c-.1254617-.948311-.6833181-1.5899579-1.5758883-1.5899579-.8786798,0-1.4504266.6276668-1.6178283,1.5899579h3.1937166Z"/>-->
<!--                                            <path d="M55.7678579,25.4883135c0-.5997068.4742451-1.0739519,1.0739519-1.0739519h5.4669029c.543966,0,.9762711.4323051.9762711.9762711s-.4323051.9762711-.9762711.9762711h-4.3931302v2.0780038h3.7656426c.5437868,0,.9762711.4323051.9762711.9762711s-.4324843.9762711-.9762711.9762711h-3.7656426v2.7891923c0,.5997068-.4740659,1.0739519-1.0737727,1.0739519s-1.0739519-.4742451-1.0739519-1.0739519v-7.6983284Z"/>-->
<!--                                            <path d="M63.8977745,32.0291684v-.02796c0-1.6317187,1.2413537-2.3848472,3.0125141-2.3848472.7531285,0,1.2969153.1256409,1.8269012.3068434v-.1254617c0-.8785902-.5437868-1.3668153-1.6037587-1.3668153-.5857268,0-1.0599719.0837009-1.4644962.2091625-.1254617.04194-.2091625.0559201-.3066642.0559201-.4882252,0-.8787694-.3765643-.8787694-.8647894,0-.3765643.2371226-.6972085.571926-.8228494.6694277-.2509234,1.3945961-.390365,2.3848472-.390365,1.1574736,0,1.994303.3066642,2.5242889.8366501.5577668.557946.8088693,1.3807954.8088693,2.3848472v3.4030583c0,.5717468-.4602651,1.0180319-1.0320119,1.0180319-.6136868,0-1.0182111-.4323051-1.0182111-.8785902v-.01398c-.516006.5717468-1.2271944.948311-2.2592063.948311-1.4085762,0-2.566229-.8088693-2.566229-2.2871664ZM68.7651498,31.5409432v-.376385c-.3625842-.1674017-.8368294-.2790626-1.3528353-.2790626-.9065502,0-1.464317.3625842-1.464317,1.0320119v.02796c0,.5717468.4740659.9065502,1.1574736.9065502.9902511,0,1.6596787-.543966,1.6596787-1.3110745Z"/>-->
<!--                                            <path d="M72.2370329,30.4811505v-.02796c0-2.1337446,1.6317187-3.8911043,3.9188851-3.8911043,1.1296928,0,1.9247613.3068434,2.552249.8368294.1394417.1116609.3348034.3625842.3348034.7251685,0,.529986-.4324843.9484903-.9622911.9484903-.2790626,0-.4882252-.1116609-.6136868-.2093418-.3765643-.2928634-.7671085-.4740659-1.3248753-.4740659-1.0599719,0-1.8131005.934331-1.8131005,2.0360638v.02796c0,1.1436728.7391485,2.0640238,1.8968013,2.0640238.5577668,0,.9900719-.1951825,1.3945961-.516006.1114817-.0837009.3206442-.1951825.5717468-.1951825.5020259,0,.8925702.4043451.8925702.9065502,0,.2788834-.1254617.5020259-.3068434.6694277-.6274876.5717468-1.4225562.9622911-2.6497506.9622911-2.2454055,0-3.8911043-1.7293996-3.8911043-3.8631442Z"/>-->
<!--                                            <path d="M80.9110947,32.0571284v-3.5425h-.0697208c-.5022052,0-.9065502-.4043451-.9065502-.9065502,0-.5020259.4043451-.906371.9065502-.906371h.0697208v-.9345103c0-.5857268.4740659-1.0599719,1.0597927-1.0599719s1.0599719.4742451,1.0599719,1.0599719v.9345103h.9345103c.5020259,0,.906371.4043451.906371.906371,0,.5022052-.4043451.9065502-.906371.9065502h-.9345103v3.1937166c0,.4882252.2091625.7251685.6834077.7251685.0697208,0,.2091625-.0138008.2511026-.0138008.4740659,0,.8785902.390365.8785902.8785902,0,.3765643-.2511026.6834077-.543966.7948893-.3905443.1534217-.7531285.2091625-1.2133936.2091625-1.2969153,0-2.1755055-.516006-2.1755055-2.2452263Z"/>-->
<!--                                            <path d="M93.1414573,33.200622c0,.5857268-.4742451,1.0599719-1.0599719,1.0599719s-1.0599719-.4742451-1.0599719-1.0599719v-.0837009c-.4880459.6276668-1.1157128,1.1994136-2.1894855,1.1994136-1.6039379,0-2.5382689-1.0599719-2.5382689-2.7753915v-3.8631442c0-.5857268.4742451-1.0597927,1.0599719-1.0597927s1.0597927.4740659,1.0597927,1.0597927v3.1937166c0,1.0042311.4742451,1.5202371,1.2831145,1.5202371s1.3248753-.516006,1.3248753-1.5202371v-3.1937166c0-.5857268.4742451-1.0597927,1.0599719-1.0597927s1.0599719.4740659,1.0599719,1.0597927v5.522823Z"/>-->
<!--                                            <path d="M95.037004,27.677799c0-.5857268.4742451-1.0597927,1.0599719-1.0597927s1.0599719.4740659,1.0599719,1.0597927v.3348034c.3068434-.7251685.8088693-1.3945961,1.436357-1.3945961.6556269,0,1.0321911.4323051,1.0321911,1.0320119,0,.5577668-.3627635.8925702-.7950686.9900719-1.0737727.2511026-1.6734795,1.0739519-1.6734795,2.580209v1.9803229c0,.5857268-.4742451,1.0599719-1.0599719,1.0599719s-1.0599719-.4742451-1.0599719-1.0599719v-5.522823Z"/>-->
<!--                                            <path d="M100.0712434,32.0291684v-.02796c0-1.6317187,1.2413537-2.3848472,3.0125141-2.3848472.7531285,0,1.2969153.1256409,1.8269012.3068434v-.1254617c0-.8785902-.5437868-1.3668153-1.6037587-1.3668153-.5857268,0-1.0599719.0837009-1.4644962.2091625-.1254617.04194-.2091625.0559201-.3066642.0559201-.4882252,0-.8787694-.3765643-.8787694-.8647894,0-.3765643.2371226-.6972085.571926-.8228494.6694277-.2509234,1.3945961-.390365,2.3848472-.390365,1.1574736,0,1.994303.3066642,2.5242889.8366501.5577668.557946.8088693,1.3807954.8088693,2.3848472v3.4030583c0,.5717468-.4602651,1.0180319-1.0320119,1.0180319-.6136868,0-1.0182111-.4323051-1.0182111-.8785902v-.01398c-.516006.5717468-1.2271944.948311-2.2592063.948311-1.4085762,0-2.566229-.8088693-2.566229-2.2871664ZM104.9386187,31.5409432v-.376385c-.3625842-.1674017-.8368294-.2790626-1.3528353-.2790626-.9065502,0-1.464317.3625842-1.464317,1.0320119v.02796c0,.5717468.4740659.9065502,1.1574736.9065502.9902511,0,1.6596787-.543966,1.6596787-1.3110745Z"/>-->
<!--                                            <path d="M47.6780541,12.4052382c0-.963564.7802819-1.7435652,1.7438459-1.7435652.9638446,0,1.7438459.7800012,1.7438459,1.7435652v8.2297816c0,.963564-.7800012,1.7435652-1.7438459,1.7435652-.963564,0-1.7438459-.7800012-1.7438459-1.7435652v-8.2297816Z"/>-->
<!--                                            <path d="M54.8137041,7.9461764c0-.9868601.7800012-1.7668614,1.7668614-1.7668614h8.9945735c.8947981,0,1.6060335.7112354,1.6060335,1.6063142,0,.8947981-.7112354,1.6060335-1.6060335,1.6060335h-7.2279928v3.4189259h6.1953823c.8947981,0,1.6063142.7112354,1.6063142,1.6060335,0,.8950788-.7115161,1.6063142-1.6063142,1.6063142h-6.1953823v4.5890681c0,.9865795-.7800012,1.7665807-1.7665807,1.7665807-.9868601,0-1.7668614-.7800012-1.7668614-1.7665807V7.9461764Z"/>-->
<!--                                            <path d="M69.6589886,7.0971286c0-.963564.7802819-1.7438459,1.7438459-1.7438459.9638446,0,1.7438459.7802819,1.7438459,1.7438459v13.5378912c0,.963564-.7800012,1.7435652-1.7438459,1.7435652-.963564,0-1.7438459-.7800012-1.7438459-1.7435652V7.0971286Z"/>-->
<!--                                            <path d="M75.8310746,16.1604679v-.0457503c0-3.5337228,2.8449415-6.4019605,6.6770239-6.4019605,3.8087862,0,6.6309929,2.8224874,6.6309929,6.3559295v.046031c0,3.5334421-2.8449415,6.4016798-6.6770239,6.4016798-3.8087862,0-6.6309929-2.8222067-6.6309929-6.3559295ZM85.6974307,16.1604679v-.0457503c0-1.8128924-1.3079546-3.3959104-3.2353632-3.3959104-1.9961745,0-3.1893322,1.5372676-3.1893322,3.3498794v.046031c0,1.8126117,1.3079546,3.3959104,3.2353632,3.3959104,1.9961745,0,3.1893322-1.5375483,3.1893322-3.35016Z"/>-->
<!--                                            <path d="M93.6363782,20.9100832l-3.0057694-8.6731984c-.0687659-.2065782-.1605472-.5506882-.1605472-.8490478,0-.8030167.6424695-1.583018,1.67508-1.583018.8717826,0,1.4454863.5506882,1.6978149,1.3537049l1.8813776,6.2411326,1.9276893-6.2183978c.2523286-.8257516.8947981-1.3994553,1.7895962-1.3994553h.2065782c.8947981,0,1.5372676.5737037,1.7895962,1.3994553l1.9504241,6.2411326,1.9274086-6.2868829c.2295937-.7342509.7572664-1.3306894,1.67508-1.3306894.963564,0,1.629049.7342509,1.629049,1.6060335,0,.2295937-.0687659.5506882-.1147969.7112354l-3.0975508,8.7879952c-.3671254,1.0786415-1.0783608,1.5605638-1.9274086,1.5605638h-.1147969c-.8490478,0-1.5602832-.4819223-1.8813776-1.4915173l-1.9504241-6.1953823-1.9734396,6.1953823c-.3210944,1.009595-1.0323298,1.4915173-1.8813776,1.4915173h-.1147969c-.8487671,0-1.5602832-.4819223-1.9274086-1.5605638Z"/>-->
<!--                                            <circle cx="49.4219" cy="7.4554353" r="2.1021526"/>-->
<!--                                        </g>-->
<!--                                    </svg>-->
<!--                                </router-link>-->
                                <a class="logo-nav-dropdown" href="https://adeverintavechime.ro/?utm_source=app&utm_medium=header&utm_campaign=iflowapp" target="_blank" rel="noopener noreferrer" style="width: 70px;">
                                    <!--                                        <img src="./assets/logo-all-apps-full-irevisal.svg" alt="Logo" class="link-logo-mobil">-->
                                    <svg data-name="Layer 004" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 110 40.4193548" fill="#395FC5">
                                        <path d="M21.9201313,17.829111c1.2785701,0,2.3653551-1.0228563,2.3653551-2.3653551s-1.0228551-2.3653545-2.3653551-2.3653545h-11.5071301v18.7310505h4.6667809v-14.0003409h6.8403492Z"/>
                                        <rect x="3.1251522" y="13.098402" width="4.6667807" height="18.7310499"/>
                                        <path d="M31.5094068,15.4637571h0c0-2.684997-1.0228551-5.1142803-2.8128551-6.8403498s-4.0914228-2.8128545-6.7764204-2.8128545h-11.5071307v4.730709h11.5071307c1.3424976,0,2.6210677.5753563,3.5160677,1.406427.9589276.9589276,1.4064276,2.1096407,1.4064276,3.5160671h0c0,1.3424988-.5753575,2.6210689-1.4064276,3.5160677-.9589276.9589276-2.1096401,1.4064276-3.5160677,1.4064276h-4.2192815v4.6667803l7.7353492,9.269633h6.0732079l-7.8632055-9.3974881c1.9817826-.38357,3.7078527-1.2785701,5.1142803-2.6849976,1.7260701-1.7260701,2.7489252-4.0914252,2.7489252-6.7764216Z"/>
                                        <circle cx="5.4905068" cy="8.1759072" r="2.6210685"/>
                                        <path d="M46.6604652,25.4366039h-10.3564205c.0639275.9589276.38357,1.6621401.895,2.1096401.5114275.5114275,1.1507126.7671425,1.9178551.7671425,1.1507126,0,1.9178551-.5114275,2.3653551-1.4703551h4.8585678c-.255715.9589276-.7032126,1.8539276-1.3424976,2.6849976-.639285.7671425-1.4703575,1.4064276-2.4292851,1.8539276s-2.1096401.639285-3.3242827.639285c-1.4703551,0-2.7489252-.3196425-3.8996378-.9589276s-2.0457126-1.5342851-2.6849976-2.6849976-.9589276-2.4932126-.9589276-4.091424.3196425-2.9407114.9589276-4.091424,1.5342851-2.0457126,2.6849976-2.6849976,2.4292827-.9589276,3.9635677-.9589276c1.4703551,0,2.7489252.3196425,3.8357102.8949988,1.150715.639285,1.9817826,1.4703551,2.6210677,2.6210689.639285,1.1507126.9589276,2.4292827.9589276,3.9635677,0,.5114251,0,.9589251-.0639275,1.4064251ZM42.05761,22.8794638c0-.7671425-.255715-1.4064276-.8310701-1.8539264-.5114275-.4475-1.2146425-.7032138-1.9817826-.7032138-.7671425,0-1.4064276.191785-1.9178551.639285s-.8310701,1.0867851-.9589276,1.9178551h5.6896354Z"/>
                                        <path d="M55.0990257,27.5462441l3.1964252-10.6760606h4.8585653l-5.3060678,14.9592684h-5.6257103l-5.3060678-14.9592696h4.9224928l3.2603625,10.6760618Z"/>
                                        <path d="M68.9075815,16.8701835v14.9592684h-4.6028503v-14.9592684h4.6028503Z"/>
                                        <path d="M74.0218618,31.3819543c-1.0228551-.4475-1.8539276-1.0867851-2.4292851-1.8539276s-.895-1.6621401-1.0228551-2.6210677h4.5389228c.0639275.5114275.3196425.9589276.7032126,1.2785701s.9589276.5114275,1.5982126.5114275c.5753575,0,1.0228551-.1278575,1.3424976-.3196425s.4474976-.5114275.4474976-.895c0-.4475-.1917875-.7671425-.639285-.9589276s-1.150715-.4475-2.1735701-.7032126c-1.0867826-.255715-1.9817826-.5114275-2.6849952-.7671425s-1.3424976-.7032138-1.8539276-1.3424988c-.51143-.5753563-.7671401-1.4064276-.7671401-2.4292827,0-.8310701.255715-1.6621413.7032126-2.3653551s1.150715-1.2785701,2.1096426-1.6621413c.895-.3835713,2.0457102-.639285,3.2603527-.639285,1.8539276,0,3.3242802.4475,4.4110677,1.4064276,1.0867826.9589276,1.7260677,2.1735689,1.8539227,3.7078527h-4.2192803c-.0639275-.5114275-.3196425-.9589276-.7032126-1.2146413-.38357-.3196425-.895-.4475-1.5342851-.4475-.51143,0-.9589276.1278575-1.2146425.3196425s-.4474976.5114275-.4474976.8310701c0,.4475.255715.7671425.7032126.9589276s1.150715.4475,2.1096426.639285c1.0867826.2557138,1.9817826.5753563,2.6849952.8310701s1.2785701.7032138,1.8539276,1.3424988c.51143.639285.8310725,1.4703551.8310725,2.4932126,0,.895-.255715,1.6621401-.7671401,2.3653551-.51143.7032126-1.2146425,1.2146425-2.1096426,1.5982126s-1.9817826.5753575-3.1964252.5753575c-1.2146377,0-2.3653527-.191785-3.3882078-.639285Z"/>
                                        <path d="M85.5289974,20.2583949c.5753526-1.1507126,1.3425025-2.0457126,2.3653527-2.6849964,1.02286-.639285,2.1096426-.9589276,3.3242802-.9589276,1.02286,0,1.9817875.191785,2.7489276.639285s1.4064251,1.0228563,1.8539227,1.6621413v-2.1096401h4.6028503v14.9592696h-4.6028503v-2.1096401c-.4474976.7032126-1.0867826,1.2785701-1.8539227,1.6621401s-1.7260677.639285-2.7489276.639285c-1.2146377,0-2.30143-.3196425-3.3242802-.9589276-1.02286-.639285-1.7900001-1.5342851-2.3653527-2.6849976s-.8949952-2.4932126-.8949952-4.091424c.0639227-1.4703563.3196328-2.8128551.8949952-3.9635677ZM94.9264855,21.6008937c-.639285-.639285-1.4064251-1.0228563-2.30143-1.0228563s-1.662145.3196425-2.30143.9589276-.9589276,1.5342838-.9589276,2.6849964.3196425,2.0457126.9589276,2.7489252c.639285.639285,1.4064251,1.0228551,2.30143,1.0228551s1.662145-.3196425,2.30143-1.0228551c.639285-.639285.9589276-1.5342851.9589276-2.6849976,0-1.0867826-.3196425-1.9817826-.9589276-2.6849952Z"/>
                                        <path d="M107.5843312,11.9476894v19.817835h-4.6028503V11.9476882s4.6028503,0,4.6028503.0000012Z"/>
                                        <circle cx="66.6061564" cy="12.2673319" r="2.6210683"/>
                                    </svg>
                                </a>
                                <a class="logo-nav-dropdown" href="https://tagdiv.ro/?utm_source=app&utm_medium=header&utm_campaign=iflowapp" target="_blank" rel="noopener noreferrer" style="width: 70px;">
                                    <!--                                        <img src="./assets/logo-all-apps-full-tagdiv.svg" alt="Logo" class="link-logo-mobil">-->
                                    <svg data-name="Layer 002" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 118.7096774 35.2580645" fill="#395FC5">
                                        <g>
                                            <path d="M58.719361,9.4932383v2.6477859h2.8763625v1.5294595h-2.8763625v5.9577515c0,1.3694283.3881001,2.1456469,1.5067034,2.1456469.5479005,0,.8675015-.0455261,1.1640694-.1370305l.0913014,1.5069111c-.3878693.1595697-1.0043151.2966002-1.7805152.2966002-.935816,0-1.6890292-.3195917-2.1684307-.8672707-.5706567-.593662-.7762001-1.5754287-.7762001-2.8763394v-6.026269h-1.7120161v-1.5294595h1.7120161v-2.0316171l1.9630718-.6161689Z"/>
                                            <path d="M71.6171337,20.541489c0,.9587798.045743,1.8945681.1825566,2.6477998h-1.8260274l-.1598005-1.3924152h-.0685453c-.6163997.8672707-1.8032713,1.6434893-3.3784739,1.6434893-2.2369298,0-3.3782892-1.5749764-3.3782892-3.1729396,0-2.6707867,2.3739741-4.1317194,6.6427518-4.1087325v-.228535c0-.9128014-.2511019-2.5562861-2.5110185-2.5562861-1.027302,0-2.1001162.319601-2.8763163.8217585l-.4564145-1.3243776c.9130137-.593182,2.2369298-.9813282,3.6293449-.9813282,3.3784739,0,4.2002324,2.3057058,4.2002324,4.5198472v4.1317194ZM69.676818,17.551106c-2.1914176-.0459784-4.679403.3421355-4.679403,2.4882301,0,1.3009107.8672707,1.9171072,1.8945727,1.9171072,1.4381582,0,2.3511719-.9128014,2.6707728-1.8485897.0685453-.2055527.1140575-.4340877.1140575-.6391876v-1.9175601Z"/>
                                            <path d="M84.2872531,21.5913209c0,2.53377-.5021575,4.0862164-1.5752025,5.0449732-1.0728142,1.0043151-2.6250298,1.3239161-4.017445,1.3239161-1.3241007,0-2.7850611-.319601-3.6750879-.9132445l.5021575-1.5294595c.7304571.4565992,1.8718166.8677323,3.2414295.8677323,2.0543732,0,3.5610766-1.0728604,3.5610766-3.8581246v-1.2323931h-.045743c-.6164458,1.0272928-1.8033175,1.849042-3.5153336,1.849042-2.7392719,0-4.7023899-2.3286604-4.7023899-5.3871041,0-3.7440486,2.4424733-5.8667363,4.9762479-5.8667363,1.9175596,0,2.9676177,1.0043151,3.4467883,1.9175596h.045743l.0913014-1.6664578h1.7577591c-.0457892.7987254-.0913014,1.6890292-.0913014,3.0358999v6.4143968ZM82.3011944,16.5008217c0-.3421309-.0227561-.6391835-.1140575-.9128014-.365344-1.1643279-1.3469029-2.1231262-2.8078172-2.1231262-1.9173288,0-3.2869879,1.6209732-3.2869879,4.1772686,0,2.1686338,1.0955703,3.9721497,3.2642318,3.9721497,1.2326147,0,2.3511719-.7762186,2.7848303-2.0545901.1142421-.3421327.1598005-.730242.1598005-1.0728234v-1.9860772Z"/>
                                            <path d="M87.6891742,8.009291c1.2098585-.1825566,2.6482475-.319601,4.2232192-.319601,2.8533755,0,4.8849925.6621888,6.2318493,1.9175596,1.3694282,1.2553708,2.1681998,3.0359322,2.1681998,5.5241484,0,2.5107646-.7757847,4.5653548-2.2141736,5.9807615-1.4379273,1.4379412-3.8121322,2.2141598-6.8025059,2.2141598-1.4149404,0-2.6022737-.068513-3.6065887-.1825566v-15.1344718ZM89.6752791,21.6143124c.5021575.0910521,1.2328454.1140436,2.008584.1140436,4.2457906,0,6.5514502-2.3741846,6.5514502-6.5284451.0229869-3.6295434-2.031617-5.9352492-6.2318493-5.9352492-1.027302,0-1.8030405.0915322-2.3281849.2055435v12.1441072Z"/>
                                            <path d="M105.0617293,9.036593c.0225253.6847141-.4796322,1.2323839-1.2784038,1.2323839-.707701,0-1.2098585-.5476698-1.2098585-1.2323839,0-.707701.5246828-1.2553708,1.2554186-1.2553708.7532116,0,1.2328438.5476698,1.2328438,1.2553708ZM102.8245688,23.1892888v-11.0482645h2.008584v11.0482645h-2.008584Z"/>
                                            <path d="M108.9428222,12.1410243l2.1681537,6.2088395c.3655747,1.0043077.6621888,1.9175596.8902595,2.8308133h.0685434c.2510557-.9132537.5706566-1.8265056.9362314-2.8308133l2.1456283-6.2088395h2.1001181l-4.3372786,11.0482645h-1.9175134l-4.2002784-11.0482645h2.1461361Z"/>
                                        </g>
                                        <path d="M31.777084,33.835236c-.3957863,0-.7232364-.1318107-.9996802-.4020032l-5.8476231-5.696064-5.8496825,5.696064c-.2766214.2701925-.6035376.4020032-.9996802.4020032-.3948994,0-.7216381-.1318107-.9987923-.4020032L1.8280928,18.5773699c-.2603182-.2539248-.4049513-.5908929-.4049513-.9483554,0-.3570718.1446331-.6942175.4049513-.9483199L17.0809508,1.8246553c.2778291-.2705477.6045677-.4018269.9994671-.4018269.3954322,0,.722526.1312792.9996802.401152l5.8496825,5.6968808,5.8469128-5.696206c.2778646-.2705477.6046043-.4018269,1.0003906-.4018269.3947218,0,.7224905.1312792.9996447.401152l15.25268,14.8567142c.2601406.2541024.4047737.5912481.4047737.9483199,0,.3574625-.1446331.6944306-.4047737.9483554l-15.25268,14.8558629c-.2764438.2701925-.6038928.4020032-.9996447.4020032M28.3871575,24.3687667l2.5432263,2.4755983c.2313348.2268239.5168004.3416566.8467002.3416566.3298654,0,.6139447-.1148327.847021-.342367l8.6081531-8.384918c.2275356-.2206081.3534488-.5159835.3534488-.8297222,0-.3135611-.1259133-.6085458-.3534488-.8303615l-8.6088291-8.3854497c-.2327555-.2268605-.51719-.3420118-.846345-.3420118-.3291894,0-.6139802.1151513-.8467002.342509l-12.9213944,12.5835739-3.458265-3.36826,6.9196201-6.739396-2.5434039-2.4764152c-.2328976-.2268605-.5176884-.3420118-.8465226-.3420118-.3286566,0-.6137671.1151513-.846345.342509l-8.6091845,8.3849524c-.2282091.2218157-.3539461.5168004-.3539461.8303615,0,.3137387.125737.6091141.3539461.8297222l8.6091845,8.3856283c.2318676.2268239.5170135.3416566.846345.3416566.3295446,0,.6139447-.1148327.8470554-.342367l12.9200092-12.5837162,3.4599698,3.369076-6.9202948,6.7397522Z"/>
                                    </svg>
                                </a>
                                <a class="logo-nav-dropdown" href="https://control-acces.ro/?utm_source=app&utm_medium=header&utm_campaign=iflowapp" target="_blank" rel="noopener noreferrer" style="width: 70px;">
                                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 106.8709677 40.4193535" fill="#395FC5">
                                        <g id="uuid-cee7a0cf-c18e-4480-8bc0-cd5730627742">
                                            <path class="cls-1" d="M4.267264,17.0755891c1.1870089.666676,2.4986808,1.000015,3.9350155,1.000015,1.6260395,0,3.0732147-.3956694,4.3415257-1.1870091,1.2683109-.7913398,2.1870231-1.9187261,2.7588471-3.3848727h-3.0108834c-.3956694.8048899-.9458134,1.4065238-1.6477206,1.8021942-.7046167.3956694-1.5176365.5935041-2.4390593.5935041-1.0108544,0-1.9133064-.2303552-2.7046456-.6910666s-1.4092342-1.1165469-1.8563952-1.9675084-.6693863-1.8374243-.6693863-2.9675223.2222253-2.1165613.6693863-2.9675223c.4471608-.8509605,1.065056-1.5013767,1.8563952-1.9566674.7913393-.4552912,1.691081-.6802266,2.7046456-.6802266.9241324,0,1.7371522.1978347,2.4390593.5935046s1.2520501.9973043,1.6477206,1.8021937h3.0108834c-.5718241-1.4661456-1.4905362-2.5962431-2.7588471-3.3957125-1.2683109-.7994694-2.7154861-1.1978491-4.3415257-1.1978491-1.4227846,0-2.7290363.3333382-3.9241753,1.0000142-1.195139.6666762-2.1382419,1.5935185-2.8347289,2.7805277-.6964869,1.1870091-1.0433753,2.5284914-1.0433753,4.0217378s.3468884,2.8347287,1.0433753,4.0217378c.6964868,1.1870091,1.6368798,2.1138512,2.8238887,2.7805282Z"/>
                                            <polygon class="cls-1" points="41.8233572 6.5388527 49.3627583 17.94552 51.8668607 17.94552 51.8668607 2.6471979 49.3627583 2.6471979 49.3627583 14.0321842 41.8233572 2.6471979 39.3192548 2.6471979 39.3192548 17.94552 41.8233572 17.94552 41.8233572 6.5388527"/>
                                            <polygon class="cls-1" points="54.3736716 4.7149782 58.4631601 4.7149782 58.4631601 17.94552 60.9672624 17.94552 60.9672624 4.7149782 65.0323612 4.7149782 65.0323612 2.6688784 54.3736716 2.6688784 54.3736716 4.7149782"/>
                                            <path class="cls-1" d="M77.3740036,9.9562459c.5799581-.8130198.8672244-1.7181818.8672244-2.7154861,0-.8509605-.2005422-1.6179091-.6043477-2.3062661-.4037972-.6883567-1.0108576-1.2385-1.8238773-1.64772s-1.8049049-.6151851-2.9783598-.6151851h-5.2737859v15.2739315h2.5068109v-6.1111984h1.9133058l3.5176685,6.1111984h2.9892023l-3.7805452-6.3307141c1.2032699-.2926876,2.0921712-.8455403,2.6694165-1.65856h-.0027127ZM70.0649556,9.8342927v-5.1193145h2.7696877c.9512358,0,1.6639844.2222256,2.1328205.6693863.4688444.4471608.7046188,1.065056.7046188,1.8563952s-.2384871,1.4227846-.7154614,1.8916259-1.1842975.7019071-2.1219779.7019071h-2.7696877Z"/>
                                            <path class="cls-1" d="M92.3633773,3.473768c-1.19514-.6666762-2.5095237-1.0000143-3.9458553-1.0000143s-2.7290383.3333381-3.9241784,1.0000143-2.1382459,1.5935188-2.8347266,2.7805279c-.6964889,1.1870091-1.043377,2.5284914-1.043377,4.0217378s.3468881,2.8401489,1.043377,4.0325783c.6964889,1.195139,1.6395865,2.1246917,2.8347266,2.7913676s2.5013938,1.0000139,3.9241784,1.0000139,2.7507152-.333338,3.9458553-1.0000139,2.1355332-1.5962286,2.8238923-2.7913676,1.0325344-2.5393314,1.0325344-4.0325783-.3441754-2.8347287-1.0325344-4.0217378-1.6314567-2.1138514-2.8238923-2.7805279ZM92.9785593,13.251686c-.4471592.8563808-1.0650539,1.5176365-1.8563968,1.9783479s-1.6937912.6910666-2.7046487.6910666-1.9133058-.2303552-2.7046487-.6910666-1.4092376-1.1219671-1.8563968-1.9783479-.6693866-1.8482648-.6693866-2.9783618.2222274-2.1165613.6693866-2.9675223c.4471592-.8509605,1.0650539-1.5013767,1.8563968-1.9566674.7913429-.4552912,1.6910785-.6802266,2.7046487-.6802266s1.9133058.2276456,2.7046487.6802266c.7913429.4552912,1.4092376,1.1057069,1.8563968,1.9566674s.6720993,1.840135.6720993,2.9675223-.2249318,2.1219821-.6720993,2.9783618Z"/>
                                            <polygon class="cls-1" points="101.1873511 15.9238111 101.1873511 2.6688784 98.6832529 2.6688784 98.6832529 17.94552 106.352736 17.94552 106.352736 15.9238111 101.1873511 15.9238111"/>
                                            <path class="cls-1" d="M6.3811154,24.9293589L.9880844,39.8401404h3.8022222l.8916119-2.6341844h5.5637649l.8916119,2.6341844h3.8455831l-5.3957411-14.9107836s-4.2060224,0-4.2060219.0000021ZM6.6358618,34.4010404l1.8265843-5.4580725,1.8482654,5.4580725h-3.6748497Z"/>
                                            <path class="cls-1" d="M24.4572546,28.0730369c.6937762,0,1.3143815.1626035,1.8591054.4878127.5447238.3252071.9674934.7994686,1.2628917,1.4227846h3.9946365c-.4254803-1.615199-1.2683109-2.8889292-2.528492-3.8239031-1.260181-.9349719-2.7751069-1.4011036-4.5447796-1.4011036-1.4444656,0-2.7371661.3224985-3.875395.9674934-1.1409375.6449949-2.0271302,1.5447367-2.6667038,2.6965147-.6368651,1.1544886-.9566529,2.4661595-.9566529,3.940436s.3197879,2.7832367.9566529,3.9295935,1.5257663,2.0433879,2.6667038,2.6856763c1.1409375.644997,2.4309294.9674955,3.875395.9674955,1.7696727,0,3.2846006-.4634231,4.5447816-1.3902651s2.1030117-2.1978636,2.528492-3.8130626h-3.9946365c-.2981068.6233139-.7181679,1.0975754-1.2628896,1.4227825-.5447238.3252071-1.1653292.4878127-1.8591054.4878127-1.1192565,0-2.0244195-.3902501-2.7181957-1.1680377-.6937762-.7777897-1.0406643-1.818454-1.0406643-3.1219971s.3468881-2.3442074,1.0406643-3.1219971,1.5989393-1.1680377,2.7181957-1.1680377l-.0000041.0000021Z"/>
                                            <path class="cls-1" d="M40.6417683,28.0730369c.6937762,0,1.3143836.1626035,1.8591054.4878127.5447218.3252071.9674955.7994686,1.2628917,1.4227846h3.9919259c-.4254823-1.615199-1.2683088-2.8889292-2.528492-3.8239031-1.260179-.9349719-2.7751089-1.4011036-4.5447816-1.4011036-1.4444656,0-2.7371682.3224985-3.875395.9674934-1.1409396.6449949-2.0271302,1.5447367-2.6667038,2.6965147-.6368651,1.1544886-.9566529,2.4661595-.9566529,3.940436s.3170772,2.7832367.9566529,3.9295935c.6368651,1.1463567,1.5257684,2.0433879,2.6667038,2.6856763,1.1409396.644997,2.4309294.9674955,3.875395.9674955,1.7696727,0,3.2845985-.4634231,4.5447816-1.3902651,1.260179-.926842,2.1030096-2.1978636,2.528492-3.8130626h-3.9919259c-.2981089.6233139-.7181658,1.0975754-1.2628917,1.4227825-.5447218.3252071-1.1653292.4878127-1.8591054.4878127-1.1192585,0-2.0244195-.3902501-2.7181957-1.1680377-.6937762-.7777897-1.0406643-1.818454-1.0406643-3.1219971s.3468881-2.3442074,1.0406643-3.1219971,1.5989372-1.1680377,2.7181957-1.1680357Z"/>
                                            <polygon class="cls-1" points="49.988787 39.8401404 59.1217082 39.8401404 59.1217082 36.9295323 53.6202737 36.9295323 53.6202737 33.6584808 58.4848411 33.6584808 58.4848411 30.853563 53.6202737 30.853563 53.6202737 27.8372605 59.1217082 27.8372605 59.1217082 24.9293589 49.988787 24.9293589 49.988787 39.8401404"/>
                                            <path class="cls-1" d="M70.0920579,31.9159104c-.601635-.2981068-1.3848438-.6097648-2.346918-.9349719-.9620742-.311658-1.6721102-.601635-2.1246907-.8699309s-.680225-.6449949-.680225-1.1246778c0-.4390314.1355033-.775079.4038013-1.0081448s.623316-.3495987,1.0623453-.3495987c.5094937,0,.926842.1382139,1.2520491.4146397s.5013638.6558354.5311747,1.1355183h3.9295955c-.0704644-1.4011036-.6097648-2.4959704-1.6151969-3.2818899-1.0054363-.7859195-2.3306583-1.1788782-3.9729576-1.1788782s-2.9241593.3929587-3.9295955,1.1788782-1.506796,1.8726544-1.506796,3.2602089c0,.9349719.2195147,1.6910805.658544,2.2737451.4390293.5799539.9620742,1.0189853,1.571839,1.3170922s1.3956823.5935051,2.3577565.8916119c.666678.1978357,1.1788803.3739883,1.5393154.5311727.3604393.1571843.666678.355018.9132909.5935051.246617.2411957.3712777.5447238.3712777.9132929,0,.4390293-.1571843.7832089-.4661317,1.0298259-.3116559.246617-.7371383.3712777-1.2737301.3712777s-.9485231-.1463417-1.2737301-.4363208-.5176236-.7127486-.5745326-1.2628917h-3.8645525c.0271023.9783339.3008175,1.8130347.8184411,2.5068109s1.2059785,1.2168211,2.0704902,1.571839,1.8401329.5311747,2.9322891.5311747,2.0894626-.2059635,2.9106081-.6151861c.8211496-.4092185,1.4471742-.9620742,1.8807864-1.6558504.4308995-.6937762.6477097-1.4661466.6477097-2.3143944,0-.8916119-.2195147-1.6206203-.658544-2.1870231s-.9593656-.9973043-1.5610006-1.2954112l-.0027127-.0054234Z"/>
                                            <path class="cls-1" d="M20.3894451,10.7502953c-.3252071-.0731719-.6477056.1327937-.7208785.4580008-.2195147.9810436-.3143686,1.9160165-.3143686,2.7940783,0,.8672213.0921412,1.6775304.246617,2.4282188.0677516.3252081.3848289.5365929.7127466.4688413.3252071-.0677516.536594-.3848289.4688423-.7127476h0c-.1382139-.6748069-.2222253-1.4038142-.2222253-2.1870231,0-.7913398.0840114-1.63688.2845577-2.5312016.0731709-.3252081-.1327926-.6477056-.4580018-.7208775l.0027106.0027106Z"/>
                                            <path class="cls-1" d="M23.4003284,6.072721h.0027106l.0027106-.0081304c1.0244046-1.0813162,2.3658884-1.5826785,3.7100809-1.5826785,1.0704752,0,2.1355312.322498,3.013594.9268426.8780608.6070547,1.571839,1.485116,1.9241464,2.6260535h0v.0081304c.1598929.495942.2384851,1.0162747.2384851,1.5420276,0,.5365929-.0813028,1.0758965-.2330658,1.5989393v.0081299h0c-.1002732.3577286-.2195147.7262977-.3197879,1.1219671-.0975625.3929598-.1761547.8130198-.1842846,1.2656013-.0054192.333338.2628767.6070552.5962137.6097648.333339.0054203.6070542-.2628767.6097648-.5962147.0027106-.3197879.0596218-.6422853.1463438-.9864638.086722-.3414678.2005443-.6991965.3089473-1.0813167h0v-.0054203h0c.1815739-.6233149.2791365-1.2764408.2791365-1.9295666,0-.6395757-.0948519-1.2845712-.2953962-1.9051765h0v-.0081304h0c-.4336101-1.4011041-1.3062517-2.5095211-2.390278-3.2547892-1.086737-.7479782-2.3848588-1.1409377-3.6965297-1.1409377-1.6422993,0-3.3171201.6233152-4.5800118,1.9539575h0s-.0027106.0027101-.0054192.0054203h0c-.5826646.5962147-1.0542155,1.2764413-1.441755,1.9973188-.1571843.2926871-.0487813.6585461.246617.8157299.2926876.1571838.6585461.0487813.8157304-.246616h0c.3468881-.6449955.7561086-1.2303696,1.2466299-1.7317319l.0054172-.0027101Z"/>
                                            <path class="cls-1" d="M27.4572974,9.1378059c-.2872663-.1707339-.6558354-.075882-.8265709.2113848h0c-.9512337,1.5989393-1.4525955,3.1355461-1.4553061,4.6044014,0,.7344276.1273734,1.4471752.3794096,2.1246917.2520362.6802261.6314458,1.3225124,1.1246778,1.9295666.2113848.2574554.5907944.2981068.8482499.086722s.2981068-.5907944.086722-.8482509c-.420061-.5149129-.7262977-1.043375-.9295527-1.5880988-.2032549-.5447228-.3035281-1.108417-.3035281-1.7046317,0-1.1870091.4092205-2.5149408,1.2845706-3.9865067.1707334-.2872674.0758815-.6558365-.2113848-.8265699l.0027127-.0027086Z"/>
                                            <polygon class="cls-1" points="36.1295103 12.8885371 36.1295103 12.8831169 36.1295103 12.8885371 36.1295103 12.8885371"/>
                                            <path class="cls-1" d="M36.3788359,9.5632862c-.0135512-1.430915-.3008175-2.723616-.8021813-3.853714-.753398-1.6965013-1.9864788-3.0217234-3.4580446-3.913335-1.4742744-.8943216-3.1843253-1.3604529-4.9187679-1.3604529-1.688372,0-3.3984229.4444508-4.9241892,1.3740034-1.5203471.9268424-2.8509884,2.3414971-3.7778325,4.2520934h0s-.0027106.0081304-.0054192.0135501c0,0,0,.0027101-.0027106.0054203h0c-.4363208.8319901-.7913387,1.6992114-1.0813167,2.5772727l-.0298109.0921423v.0975625c0,.333338.2710066.6043446.6043446.6043446.2682959,0,.4932319-.1761547.5718241-.42006h0c.2710066-.8265699.6043456-1.63688,1.0108555-2.4092484l.0054192-.0108405v-.0081304c.84012-1.7236021,2.0081598-2.9539717,3.3333819-3.7669915,1.3279327-.8103096,2.8184689-1.1978491,4.295454-1.1978491,2.0244195,0,4.0136069.7290077,5.4878834,2.0786206.7398489.6748063,1.3523223,1.5013767,1.7859345,2.477.4336101.9756238.6883549,2.1003011.6991975,3.3767418h0v.1355033c0,.9756233-.1192436,2.0515198-.2384851,3.0271431-.0677516.5149129-.1571843.9918841-.2953962,1.4038142-.1382139.4119301-.3252071.753398-.5826646,1.0352451l-.0054192.0054203-.0054192.0054203c-.4525805.5149129-1.1653292.8103102-1.8807864.8075995-.4227696,0-.8374094-.1002721-1.19514-.3008175h-.0081299l-.0081299-.0081299c-.3956694-.2086752-.7208785-.5365929-.9458124-.9349729-.224936-.39838-.3495987-.861801-.3495987-1.3225124,0-.1165329.0081299-.2303552.0243896-.3441785v-.0189704c.0460706-.4281909.2032549-.9024524.3794096-1.4146547.1707334-.5040724.3577286-1.0487952.4092205-1.6531398h0v-.0298109h0c.0135512-.1219532.021681-.2411957.021681-.3604393,0-.463421-.1056924-.9078722-.2872663-1.3035415-.2737172-.5962147-.7181679-1.0894466-1.2547598-1.441755-.536594-.3495982-1.1707484-.5582734-1.8347137-.5582734-.4227696,0-.8563818.086722-1.2710216.2737167h-.0108384c-.44174.1924144-.818439.4607114-1.1382268.7723689-.4823914.4715514-.8319901,1.0352451-1.1111266,1.6124894s-.4905213,1.173459-.6802271,1.7208914v.0054203l-.0027106.0081299c-.3712798,1.1463577-.550143,2.2439342-.550143,3.2954401,0,2.013579.6639653,3.8374543,1.8049028,5.4662024.1897038.2737172.5664028.3387582.84012.1490545s.3387582-.5664028.1490545-.84012h0c-1.0271152-1.4715659-1.5853881-3.0271431-1.5880988-4.7751368,0-.9132919.1544737-1.8807853.4905213-2.9187411.2493256-.7181679.5203322-1.4580157.8807714-2.0623603.1815739-.3035276.3848289-.5745337.6124755-.7967595.2303552-.2249354.485102-.4037998.7832089-.5338828h0l.0081299-.0054203c.2574554-.1165329.5176236-.1680243.7804982-.1680243.5447238,0,1.1002861.235776,1.5095066.6233149.2059656.1951246.3712798.4227701.485102.6720962s.1788653.5176231.1788653.7994691c0,.0785922-.0054192.1571843-.0162597.2411957v.0135501l-.0027106.0135501c-.0298109.4146397-.1788653.8780618-.3523094,1.3848438-.1707334.5040724-.3631478,1.0487952-.4336101,1.6558504h0v.0162608h0c-.021681.1626035-.0325215.3279177-.0325215.4932319,0,.6720962.1761547,1.3360626.5067831,1.9160165.3252071.5745337.8076005,1.0731858,1.4173654,1.4011046h0s.0054192.0027096.0081299.0054203c0,0,.0054192,0,.0054192.0027096h0c.550143.3062377,1.1626185.4498709,1.7723833.4498709,1.0298259,0,2.0596497-.4065099,2.7751069-1.2059795h0s0-.0027096.0027106-.0054203c0,0,.0027106-.0027096.0054192-.0054203h0c.3956694-.4309005.6558375-.9349729.8319901-1.4580157.1788653-.5284631.2764279-1.0786061.3495967-1.6341694v-.0054203c.1219521-.9891745.2493256-2.1057213.2493256-3.1789072v-.1463438l.0054172.0108436Z"/>
                                            <polygon class="cls-1" points="36.3788359 9.5632862 36.3788359 9.5632862 36.3788359 9.5632862 36.3788359 9.5632862"/>
                                        </g>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div v-else class="navbar-header">
                        <a v-if="!this.$store.getters.isLoggedIn" :class="{'navbar-brand': !$store.getters.isIphoneOrIpodState, 'navbar-brand-iphone': $store.getters.isIphoneOrIpodState}" :href="getHomePageLink()">
                            <img src="./assets/logo-image2.png"/>
                        </a>
                        <router-link v-else :to="{ name: 'dashboardRoute', params: {}}" class="navbar-brand" active-class="active">
                            <img src="./assets/logo-image2.png"/>
                        </router-link>
                    </div>







                    <!-- left navigation -->
                    <div id="navbar" class="navbar-collapse collapse">
                        <ul class="nav navbar-nav navbar-left">

                            <li v-if="$store.getters.isAdmin" :class="{'td-not-ro': $store.state.company.country_code !== 'RO'}" class="nav-item dropdown td-logo-dropdown" @mouseenter="onMouseEnterNav" @mouseleave="onMouseLeaveNav">
                                <a v-if="!this.$store.getters.isLoggedIn" :class="{'navbar-brand': !$store.getters.isIphoneOrIpodState, 'navbar-brand-iphone': $store.getters.isIphoneOrIpodState}" :href="getHomePageLink()" id="dashboard-tab" class="td-navbar-link dropdown-toggle nav-user td-navbar-dropdown" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                    <img src="./assets/logo-image2.png" alt="iflow_logo" style="margin-left: 10px;" />
                                </a>
                                <router-link v-else-if="$store.state.company.country_code === 'RO'" :to="{ name: 'dashboardRoute', params: {}}" class="navbar-brand td-navbar-link dropdown-toggle nav-user td-navbar-dropdown" active-class="active">
                                    <a href="#" class="logo-nav-dropdown">
                                        <img src="./assets/logo-image2.png" alt="iflow_logo" style="margin-left: 10px;" />
                                    </a>
                                </router-link>
                                <router-link v-else :to="{ name: 'dashboardRoute', params: {}}" class="navbar-brand" active-class="active">
                                    <img src="./assets/logo-image2.png"/>
                                </router-link>


                                <ul class="dropdown-menu" style="left: 0">
                                    <router-link tag="li" class="td-navbar-link" active-class="active" exact :to="{name: 'dashboardRoute'}">
                                        <a href="#" class="logo-nav-dropdown logo-nav-dropdown-active">
<!--                                            <img src="./assets/logos-all-apps-iflow.svg" alt="Logo" class="link-logo">-->
                                            <svg id="Layer_4" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 60 60" class="link-logo">
                                                <circle cx="30" cy="30" r="30" fill="#f4f4f4" stroke-width="0"/>
                                                <g>
                                                    <path d="M30.0014424,10.1557028c-10.9622423.0010042-19.8421608,8.8849098-19.8432634,19.8452322.0011027,10.9563846,8.8810211,19.8402806,19.8432634,19.8433622,10.9594561-.0030816,19.8403786-8.8869776,19.8403786-19.8433622,0-10.9603224-8.8809225-19.844228-19.8403786-19.8452322ZM30.0014424,47.807055c-4.9227313,0-9.3670372-1.9910872-12.5936065-5.2147747-.1888311-.190557-.3746336-.3832407-.5545707-.5812999h.2787273c.814502.0037511,1.6012628-.275936,2.1578115-.8353201.5596598-.5554361.8369938-1.3418149.8341091-2.1568438v-6.1179195c0-.6397616.5190476-1.155964,1.1602959-1.1588093.6411991.0028453,1.1593803.5190476,1.1603353,1.1588093v5.9102414c.0019297,1.7651459,1.4312797,3.1979222,3.1972921,3.199842,1.7665929-.0019198,3.1960414-1.4318114,3.1975379-3.199842v-11.0733377c.0017232-.6407166.5193824-1.1598627,1.1620681-1.1617334.639801.0018706,1.1593803.5210167,1.1607192,1.1617334v11.0733377c0,1.7651459,1.4285431,3.1979222,3.1951358,3.199842,1.7665833-.0019198,3.1963764-1.4318114,3.1973417-3.199842v-5.9102414c.0019193-.6397616.5206229-1.155964,1.1617328-1.1588093.6396533.0028453,1.1593212.5190476,1.1607685,1.1588093v6.1171516c-.0037511.8139754.2744986,1.6021756.8338728,2.1576117.556204.5593841,1.3425828.8390712,2.1571391.8353201h.2795887c-.180948.1980592-.3661196.3907428-.5555345.5812999-3.2250264,3.2236875-7.6717837,5.2147747-12.5907641,5.2147747ZM44.7534806,39.9738366h-1.8853282c-.3888131-.0037511-.5880335-.1120107-.717924-.2366137-.1253709-.1302837-.2335419-.3293964-.236909-.7191744v-6.1171516c-.000571-1.7651065-1.4322839-3.1940234-3.1969474-3.1940234-1.7655397,0-3.1968588,1.4289169-3.1968588,3.1940234v5.9102414c-.0014473.640628-.5218831,1.1626982-1.1622157,1.1626982-.6398601,0-1.1588486-.5220702-1.1602959-1.1626982v-11.0733377c0-1.7660123-1.4307477-3.1959036-3.1955592-3.1969078-1.7669279.0010042-3.197341,1.4308955-3.19931,3.1969078v11.0733377c0,.640628-.5205343,1.1626982-1.1602959,1.1626982-.6407166,0-1.1588979-.5220702-1.1602861-1.1626982v-5.9102414c-.0017328-1.7651065-1.4332488-3.1940234-3.1973413-3.1940234-1.7660123,0-3.195894,1.4297833-3.1972921,3.1940234v6.1179195c-.0034626.3890101-.1111463.5881227-.2361844.7184064-.1297974.1246029-.3303573.2328626-.7187401.2366137h-1.8848922c-1.9274468-2.8454483-3.0527916-6.2742541-3.0527916-9.9729016,0-4.9208607,1.9901814-9.3676673,5.2135273-12.5932745,3.2265692-3.2246916,7.6708752-5.215828,12.5936065-5.215828,4.9199452,0,9.3657377,1.9911364,12.5907641,5.215828,3.2243569,3.2256072,5.2145875,7.6724138,5.2145875,12.5932745,0,3.6986476-1.1262605,7.1274534-3.0533134,9.9729016Z" fill="#395fc5" stroke-width="0"/>
                                                    <path d="M32.6117636,19.8154034c0,1.4423361-1.1682706,2.6107544-2.6103212,2.6107544-1.4441673,0-2.6131567-1.1684183-2.6131567-2.6107544,0-1.4413712,1.1689894-2.6108036,2.6131567-2.6108036,1.4420505,0,2.6103212,1.1694324,2.6103212,2.6108036Z" fill="#395fc5" stroke-width="0"/>
                                                    <path d="M41.3271166,24.9804195c0,1.4413808-1.1673058,2.6127233-2.6107445,2.6127233-1.4421982,0-2.6106559-1.1713424-2.6106559-2.6127233,0-1.441322,1.1684577-2.6107445,2.6106559-2.6107445,1.4434387,0,2.6107445,1.1694226,2.6107445,2.6107445Z" fill="#395fc5" stroke-width="0"/>
                                                    <path d="M23.8948651,24.9804195c0,1.4413808-1.1687531,2.6127233-2.610656,2.6127233-1.4428677,0-2.6117587-1.1713424-2.6117587-2.6127233,0-1.441322,1.1688909-2.6107445,2.6117587-2.6107445,1.4419029,0,2.610656,1.1694226,2.610656,2.6107445Z" fill="#395fc5" stroke-width="0"/>
                                                </g>
                                            </svg>
                                            {{$__('Pontaje & HR')}}
                                        </a>
                                    </router-link>
<!--                                    <router-link tag="li" class="td-navbar-link" active-class="active" exact :to="{name: 'mainEfacturaRoute'}">-->
<!--                                        <a href="#" class="logo-nav-dropdown logo-nav-dropdown-active">-->
<!--&lt;!&ndash;                                            <img src="./assets/logos-all-apps-efactura.svg" alt="Logo" class="link-logo">&ndash;&gt;-->
<!--                                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 60 60" class="link-logo">-->
<!--                                                <circle cx="30" cy="30" r="30" fill="#f4f4f4" stroke-width="0"/>-->
<!--                                                <g>-->
<!--                                                    <circle cx="17.5464912" cy="35.4884916" r="3.1924721" fill="#395fc5" stroke-width="0"/>-->
<!--                                                    <g>-->
<!--                                                        <path d="M44.3597994,32.3544203c-1.1283869-.3715262-2.3442572.242062-2.7157525,1.3704489-.5218419,1.5851105-1.3731982,3.0572835-2.5061261,4.3044464-1.1337002,1.24741-2.5458828,2.2709219-4.2093021,2.9696148-1.5137832.6350265-3.0733777.9330013-4.6110706.9333719-2.6188783.0006796-5.1744918-.871559-7.2429076-2.4467227-.9452804-.7195444-2.2948779-.5365151-3.0143914.4087499-.7195289.945265-.5365151,2.2948624.4087653,3.0144068l-.0000154-.0000309c2.8157004,2.1425698,6.2764051,3.3248924,9.8485491,3.325572,2.0956772.0003707,4.2295975-.4093677,6.2760653-1.2686321,2.2499469-.9439985,4.1854233-2.34401,5.7287692-4.0438807,1.5440873-1.7001178,2.6990713-3.6989825,3.4078656-5.8515919.3714953-1.1283869-.2420929-2.3442572-1.3704489-2.7157525Z" fill="#395fc5" stroke-width="0"/>-->
<!--                                                        <path d="M25.6946155,19.0011314c1.5135978-.6351192,3.0731924-.933063,4.6110088-.9334337,2.3268964-.0004325,4.6038112.6876339,6.5334801,1.9464427,1.358216.8867883,2.5414036,2.0513795,3.4593301,3.4609055l-16.8101941,7.0564031c-1.0953799.4597818-1.6106111,1.7205367-1.1507983,2.8159012.4597973,1.0953644,1.7205367,1.6105956,2.8159012,1.1508138v-.0000309l18.9730747-7.9643209c.5222744-.2192644.9443074-.6452824,1.1585983-1.1696264.2142601-.5243132.2114181-1.1240004-.0078154-1.6462747-1.3003881-3.1000985-3.4649522-5.5980384-6.0881244-7.3072382-2.6236664-1.7106207-5.7096168-2.6445178-8.8834521-2.6449503-2.0956772-.0003707-4.229721.409275-6.2762043,1.2687557-2.8097075,1.1786466-5.1263327,3.0678791-6.8069273,5.3646259-1.6817376,2.2972411-2.7358008,5.0025524-3.0481089,7.8382856-.129943,1.1808399.7219847,2.2434289,1.90284,2.3733565,1.1808399.1299276,2.2434289-.7219847,2.373372-1.9028246.2288252-2.0827956,1.0065836-4.0794054,2.2428729-5.7672285,1.2374322-1.6883483,2.9250237-3.0672922,5.0011468-3.9395617Z" fill="#395fc5" stroke-width="0"/>-->
<!--                                                    </g>-->
<!--                                                </g>-->
<!--                                            </svg>-->
<!--                                            {{$__('Facturare & stocuri')}}-->
<!--                                        </a>-->
<!--                                    </router-link>-->
                                    <li class="td-navbar-link">
                                        <a class="logo-nav-dropdown" href="https://adeverintavechime.ro/?utm_source=app&utm_medium=header&utm_campaign=iflowapp" target="_blank" rel="noopener noreferrer">
<!--                                            <img src="./assets/logos-all-apps-iR.svg" alt="Logo" class="link-logo">-->
                                            <svg id="Layer_3" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 60 60" class="link-logo">
                                                <circle cx="30" cy="30" r="30" fill="#f4f4f4" stroke-width="0"/>
                                                <g>
                                                    <path d="M35.9327872,27.4979248c1.2714787,0,2.3522361-1.0171832,2.3522361-2.3522361s-1.017182-2.3522355-2.3522361-2.3522355h-11.443308v18.6271624h4.6408975v-13.9226907h6.8024105Z" fill="#395fc5" stroke-width="0"/>
                                                    <rect x="17.2420508" y="22.7934538" width="4.6408973" height="18.6271618" fill="#395fc5" stroke-width="0"/>
                                                    <path d="M45.4688777,25.1456899h0c0-2.6701052-1.017182-5.0859149-2.7972542-6.8024111s-4.0687305-2.7972536-6.7388363-2.7972536h-11.4433086v4.7044711h11.4433086c1.3350517,0,2.6065304.5721652,3.4965665,1.3986265.9536091.9536091,1.3986271,2.09794,1.3986271,3.4965659h0c0,1.3350529-.5721664,2.6065316-1.3986271,3.4965665-.9536091.9536091-2.0979394,1.3986271-3.4965665,1.3986271h-4.1958801v4.6408969l7.6924466,9.2182208h6.039524l-7.8195937-9.3453668c1.9707911-.3814427,3.6872878-1.2714787,5.0859149-2.6701058,1.7164968-1.7164968,2.7336788-4.0687329,2.7336788-6.7388375Z" fill="#395fc5" stroke-width="0"/>
                                                    <circle cx="19.5942865" cy="17.8982607" r="2.6065312" fill="#395fc5" stroke-width="0"/>
                                                </g>
                                            </svg>
                                            {{$__('Adeverință vechime')}}
                                        </a>
                                    </li>
                                    <li class="td-navbar-link">
                                        <a class="logo-nav-dropdown" href="https://tagdiv.ro/?utm_source=app&utm_medium=header&utm_campaign=iflowapp" target="_blank" rel="noopener noreferrer">
<!--                                            <img src="./assets/logos-all-apps-tagdiv.svg" alt="Logo" class="link-logo">-->
                                            <svg id="Layer_2" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 60 60" class="link-logo">
                                                <circle cx="30" cy="30" r="30" fill="#f4f4f4" stroke-width="0"/>
                                                <path d="M35.8504717,43.8419995c-.3390982,0-.6184119-.1121081-.8556371-.3437853l-4.99292-4.8649357-4.9967488,4.8649357c-.2362687.2316773-.5155824.3437853-.8538197.3437853-.3371851,0-.6164988-.1121081-.8528632-.3437853l-13.0293116-12.6883003c-.2213465-.216755-.3456028-.5044863-.3456028-.8099139s.1242563-.5931589.3456028-.8099139l13.0284507-12.6883003c.2372253-.2316773.5165389-.3437853.853724-.3437853.3372808,0,.617551.1121081.8538197.3428288l4.9967488,4.8649357,4.99292-4.8639792c.2372253-.2316773.5165389-.3437853.8556371-.3437853.3363242,0,.6174553.1121081.8528631.3428288l13.0283548,12.6892568c.2214421.216755.3447419.5044863.3447419.8099139s-.1232998.5931589-.3447419.8099139l-13.0283548,12.6883003c-.2354078.2316773-.5165389.3437853-.8528631.3437853M32.9537407,35.7561567l2.1728113,2.1148443c.19705.194276.4418321.2914619.7239197.2914619.2812267,0,.5240957-.0971858.7221023-.2914619l7.3525487-7.16296c.194276-.1877715.3026564-.4408755.3026564-.7080409,0-.268122-.1083804-.5202695-.3026564-.709954l-7.3525487-7.1620034c-.1980066-.1933195-.4408755-.2924184-.7221023-.2924184-.2811311,0-.5249566.0990989-.7239197.2924184l-11.036808,10.7490793-2.9537417-2.8771218,5.911214-5.7561567-2.1728114-2.1158008c-.1989631-.1933195-.4427886-.2924184-.7230588-.2924184-.2811311,0-.524.0990989-.7229632.2924184l-7.3535055,7.1620034c-.194276.1896846-.301697.4418321-.301697.709954,0,.2671654.107421.5202695.301697.7080409l7.3535055,7.16296c.1980066.194276.4418321.2914619.7229632.2914619.2812267,0,.5240957-.0971858.7230588-.2914619l11.0358514-10.7490793,2.9546982,2.8780783-5.9112139,5.7561567Z" fill="#395fc5" fill-rule="evenodd" stroke-width="0"/>
                                            </svg>
                                            {{$__('Custom IT solutions')}}
                                        </a>
                                    </li>
                                    <li class="td-navbar-link">
                                        <a class="logo-nav-dropdown" href="https://control-acces.ro/?utm_source=app&utm_medium=header&utm_campaign=iflowapp" target="_blank" rel="noopener noreferrer">
                                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 60 60" class="link-logo">
                                                <circle class="cls-2" cx="30" cy="30" r="30" fill="#f4f4f4" stroke-width="0"/>
                                                <g id="uuid-95d6ad2e-202a-4dab-bd3f-b5df70f5169e" fill="#395fc5" fill-rule="evenodd" stroke-width="0">
                                                    <path class="cls-1" d="M17.0648978,30.4034308c-.6207359-.1385886-1.2368128.2527196-1.3742365.8734555-.418094,1.8750185-.5974437,3.659196-.5974437,5.3362316,0,1.6549078.1758555,3.2038341.4693366,4.6374672.1281066.6230656.7360318,1.024853,1.3602614.8967491.6230647-.1281075,1.0248544-.7371949.8967477-1.3602605h0c-.2643659-1.2903851-.4227526-2.6832563-.4227526-4.1739522,0-1.5116598.1618803-3.1246417.542707-4.8354501.1385881-.6207359-.25272-1.2368124-.8746199-1.374237v-.0000036Z"/>
                                                    <path class="cls-1" d="M20.432942,24.778378h0c.661497-1.2321548,1.4452781-2.3525073,2.3816216-3.307485l.0069874-.0069874.0058234-.0069874c1.9577046-2.0636843,4.516347-3.0209917,7.0866363-3.0244854,2.0427222,0,4.0772896.6172422,5.7543252,1.7713676,1.6781996,1.15762,3.0011936,2.8358186,3.6766662,5.0147997v.0034937l.0046576.0128108c.3074563.9456606.4541961,1.9402362.4553619,2.9441272,0,1.0236891-.153729,2.056697-.4448808,3.0512708l-.0046576.0163044v-.0034937c-.1898316.6836239-.4180936,1.3893775-.6079252,2.1405488-.1886658.7511714-.3389012,1.5524218-.3493822,2.4153962-.0081531.6358764.5007815,1.1587839,1.1378218,1.1657713.6358764.0081531,1.1587839-.5007815,1.1657713-1.1378218.0069874-.6102549.1152968-1.2274953.2806708-1.8820059.1630443-.6498511.3819911-1.333475.589291-2.067178h0l.0034937-.0116468h0c.3482165-1.1925585.5345543-2.4363583.5345543-3.6871472,0-1.2240017-.1793505-2.4538285-.5625038-3.6393979h0l-.0034937-.0093171-.0023279-.0069874h0c-.8291998-2.6785968-2.4945887-4.7946881-4.5664243-6.2166744-2.0764951-1.4278088-4.557109-2.1766514-7.059849-2.1778158-3.1362867-.0034937-6.3342991,1.1913932-8.7450359,3.7290727h0l-.0046585.0046585-.0093171.0093171h0c-1.1122003,1.1378218-2.0124413,2.4363583-2.7531316,3.8164187-.3004689.5601758-.0908392,1.2589402.4693366,1.5594091s1.2589402.0908392,1.5594091-.4693366l.0011595.0000009Z"/>
                                                    <path class="cls-1" d="M30.5650257,27.3253745c-.5473651-.3249247-1.2531168-.1455759-1.5792072.4017892h0c-1.8167881,3.0547645-2.7764234,5.9872467-2.7775883,8.7927853,0,1.3998585.2422376,2.7612847.7267147,4.0586554.4833113,1.2973743,1.2053693,2.5283615,2.1487002,3.6848157.4017892.4926302,1.127339.5671632,1.6211332.1653758.4937941-.4017909.5671632-1.127339.165374-1.621135-.8012504-.9840946-1.3870477-1.9926414-1.7760262-3.0338024-.3878145-1.0411592-.5811397-2.117257-.5811397-3.2539131,0-2.2674906.7826163-4.8051692,2.4538267-7.6153672.3249247-.5473651.1455759-1.2531168-.4017892-1.5792072l.0000018.0000036Z"/>
                                                    <path class="cls-1" d="M47.6020672,28.1336123c-.0244558-2.7310038-.5741506-5.2011367-1.5326237-7.3603179-1.4382908-3.2411024-3.7919611-5.7694648-6.6033231-7.473285-2.8136917-1.7049861-6.0827453-2.5959107-9.394887-2.5959107-3.2224682,0-6.4915218.8466695-9.4042041,2.625025-2.9045309,1.7713676-5.4445392,4.4720923-7.2170717,8.1219712h0l-.0116461.0232918-.0058229.010481h0c-.8315296,1.5873595-1.5139895,3.2422664-2.0625195,4.9216299l-.0570658.1735271v.1886658c0,.6358764.515921,1.1517966,1.1517967,1.1517966.5124273,0,.9421672-.3365714,1.091237-.8000847h.0034939c.5159211-1.5792072,1.1552905-3.1281353,1.9285894-4.5990349l.0104815-.0197981.0069878-.0151396c1.5955121-3.2911805,3.8268997-5.643687,6.3610855-7.1926146,2.5353506-1.5477632,5.3828152-2.2872887,8.2046582-2.2872887,3.865332,0,7.6642805,1.3940351,10.4826316,3.968982,1.4103378,1.2880559,2.5807702,2.868428,3.4088043,4.7317997.8268719,1.8633717,1.3125112,4.0120719,1.334639,6.4484302v.0023297c0,.0861816.0011657.1711974.0011657.257379,0,1.8645357-.2247684,3.917739-.4576898,5.7811107-.1281075.9852586-.2981392,1.8948166-.5636695,2.6785968-.2655303.7872739-.6184062,1.4394547-1.1121986,1.9763388l-.0081531.0093171-.0081531.0093171c-.8618087.9829289-2.2267286,1.5454344-3.5916485,1.5431047-.8082378,0-1.6013351-.1933252-2.283795-.5764803l-.0128108-.0069874-.0139747-.0069874c-.7569948-.3994595-1.375401-1.0260188-1.8063053-1.7876729-.4309044-.7593245-.6673195-1.6479186-.6661555-2.5248696,0-.2212747.0151405-.4413854.0442556-.6591682l.0023297-.0186341v-.0128108c.0873455-.8198828.3901442-1.7224534.7267156-2.7007247.3249247-.9631308.681296-2.0007963.7826163-3.1560865h.0023297l.001164-.0256215.0034937-.0291152h-.0023297c.0267855-.2317575.0430899-.4623492.0430899-.6906113,0-.8874302-.2014766-1.7329363-.5496948-2.491095-.5240733-1.1378218-1.3730712-2.0823176-2.397926-2.7508028-1.0260188-.6673204-2.2383754-1.064451-3.5066327-1.0656159-.8082378,0-1.6362736.165374-2.4270412.5229084h0l-.010481.0046585-.0081531.0034937h0c-.8431763.3691803-1.5652325.8816077-2.1731577,1.4767221-.92004.9014058-1.5873595,1.9786676-2.1219147,3.0803869-.5345543,1.1040472-.9375092,2.2407051-1.3008662,3.287686l-.0023288.0081531-.0046585.0139747c-.7104103,2.1882981-1.0528051,4.2857553-1.0516403,6.2923732-.0034937,3.8455339,1.2670924,7.328873,3.4472375,10.4395417.3645218.5217454,1.0830852.6486871,1.6036639.2841645.5217436-.3645227.6486871-1.0830834.2841645-1.603663h0c-1.9600343-2.810198-3.027979-5.7822746-3.0314727-9.1188757,0-1.7422533.2958104-3.5904846.9363444-5.572645.47516-1.3730712.9910811-2.7822468,1.6828572-3.9387028.3458885-.5811397.7325381-1.0958959,1.1704298-1.5244706.4390575-.4274107.9246985-.7698055,1.4976851-1.0190314l.0046576-.0023288.0139747-.0058234c.4891347-.2224404.9887523-.3225958,1.4918617-.3225958,1.0376655-.0034937,2.1009508.4483736,2.8835671,1.1925576.3913081.3703452.7104112.8082369.9281922,1.2833969.2189467.476324.3389012.9887523.3389012,1.5279642,0,.1502336-.0093171.3027986-.0291152.4588556l-.0034937.0279512-.0023297.0256215c-.0582304.7896036-.3400651,1.6758699-.6731429,2.6436583-.3249247.9596371-.6952707,2.0007963-.8291998,3.1630739h-.001164l-.0023297.0209621-.0023297.0116468h0c-.0419259.3132797-.062888.6265593-.062888.9398372,0,1.2845617.3377354,2.5504893.9654587,3.66036.6230656,1.0993896,1.539611,2.0497096,2.708876,2.6739374h0l.0151405.0081531.0128108.0069874h0c1.0504763.5834694,2.2232349.8571493,3.3843486.858315,1.964692-.0023279,3.9363713-.7779568,5.3012912-2.3035931h0l.0081531-.0081531.0093153-.0093171h0c.7535011-.8245422,1.2507871-1.7853432,1.5861946-2.7834108.3389012-1.0073846.5264012-2.0601906.6649898-3.1199822v-.0081531l.0023279-.0069874v.0058234c.2340872-1.8878292.473996-4.0225529.4751582-6.0676031,0-.0943329,0-.1886658-.0011657-.2818348l.0000071-.0023297Z"/>
                                                    <polygon class="cls-1" points="47.6020672 28.1336123 47.6020672 28.1336123 47.6020672 28.1359402 47.6020672 28.1336123"/>
                                                </g>
                                            </svg>
                                            {{$__('Control acces')}}
                                        </a>
                                    </li>
                                </ul>
                            </li>








                            <!-- Dashboard -->
                            <router-link id="dashboard-tab" v-if="$store.getters.isLoggedIn === true" tag="li" class="td-navbar-link" active-class="active" to="/dashboard">
                                <a href="#">{{$__('Dashboard')}}</a>
                            </router-link>




                            <!-- Activity -->
                            <router-link v-if="$store.getters.isLoggedIn === true" tag="li" class="td-navbar-link" active-class="active" to="/activity">
                                <a href="#">{{$__('Requests')}}</a>
                            </router-link>


                            <!-- Program de lucru -->
                            <router-link id="work_schedule" v-if="$store.getters.isLoggedIn === true" tag="li" to="/workSchedule" class="td-navbar-link" active-class="active">
                                <a href="#">{{$__('Work schedule')}}</a>
                            </router-link>

                            <!-- Angajati dropdown -->
                            <li v-if="userHasWorkspacePermissions || $store.getters.useProjects || $store.getters.getReviewsSessionsPermission" @mouseenter="onMouseEnterNav" @mouseleave="onMouseLeaveNav" @click="onClickNav"
                                :class="{
                                        'nav-item': true,
                                        'dropdown': true,
                                        active: (
                                        	$route.name === 'importerRoute' ||
                                        	$route.name === 'usersIndex' ||
                                        	$route.name === 'disabledUsersRoute' ||
                                        	$route.name === 'teamsListRoute' ||
                                        	$route.name === 'locationsListRoute' ||
                                        	$route.name === 'disabledLocationsListRoute' ||
                                        	$route.name === 'projects' ||
                                        	$route.name === 'employmentEndMotivationsListRoute' ||
                                        	$route.name === 'contractSuspensionReasonsListRoute' ||
                                        	$route.name === 'contractTypesListRoute'
										)
                                    }
                                ">

                                <router-link
									v-if="userHasWorkspacePermissions && userHasUserEditPermissions"
									:to="{name: 'usersIndex' , params:{user: 'All', teamIds: 'All', selectedUsers: 'None'} }"
									id="employees-tab"
									class="td-navbar-dropdown dropdown-toggle"
									exact
									data-toggle="dropdown"
									role="button"
									aria-haspopup="true"
									aria-expanded="false"
								>
                                    {{$__('Workspace')}}
                                </router-link>

								<router-link
									v-else-if="$store.getters.useProjects"
									:to="{name: 'projects'}"
									id="employees-tab"
									class="td-navbar-dropdown dropdown-toggle"
									exact
									data-toggle="dropdown"
									role="button"
									aria-haspopup="true"
									aria-expanded="false"
								>
									{{$__('Workspace')}}
								</router-link>

                                <router-link
                                    v-else-if="$store.getters.getReviewsSessionsPermission"
                                    :to="{name: 'employeeReviewSessionsRoute'}"
                                    id="employees-tab"
                                    class="td-navbar-dropdown dropdown-toggle"
                                    exact
                                    data-toggle="dropdown"
                                    role="button"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    {{$__('Workspace')}}
                                </router-link>

                                <ul class="dropdown-menu td-organization-menu">

                                    <!-- Angajati -->
                                    <router-link v-if="userHasWorkspacePermissions" tag="li" :to="{name: 'usersIndex' , params:{user: 'All', teamIds: 'All', selectedUsers: 'None'} }" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Employees')}}</a>
                                    </router-link>

                                    <!-- Job titles -->
                                    <router-link v-if="userHasWorkspacePermissions" tag="li" :to="{name: 'jobTitlesListRoute'}" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Job titles')}}</a>
                                    </router-link>



                                    <!-- teams -->
                                    <router-link v-if="userHasWorkspacePermissions" tag="li" :to="{name: 'teamsListRoute'}" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Teams')}}</a>
                                    </router-link>

                                    <!-- locations -->
                                    <router-link v-if="userHasWorkspacePermissions" tag="li" :to="{name: 'locationsListRoute'}" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Locations')}}</a>
                                    </router-link>

                                    <!-- projects -->
                                    <router-link  v-if="$store.getters.useProjects" tag="li" :to="{name: 'projects'}" class="td-reports-btn td-navbar-link td-extra-sub-type" active-class="active" exact>
                                        <a href="#">{{$store.getters.getProjectsNameNew('Projects')}}</a>
                                        <div class="td-sub-type-info-box" v-if="!$store.getters.isIphoneOrIpodState && !$store.getters.getAvailableFeatures.features_settings.full_projects.unlock">
                                            <div class="td-sub-type-value">Business</div>
                                            <span class="td-sub-type-info">
                                                {{$__('This feature is part of the Business plan.')}}
                                                <a v-if="$store.getters.getCompanyLanguage === 'ro_RO'" class="td-contact-mail" href="mailto:contact@iflow.ro">contact@iflow.ro</a>
                                                {{$__('Soon, you will need to upgrade your subscription to use it.')}}
                                            </span>
                                        </div>
                                    </router-link>

                                    <router-link v-if="userHasWorkspacePermissions && userHasUserEditPermissions" :to="{name: 'generalDocumentsRoute', params: { subTab: 'view_all'}}" tag="li" class="td-reports-btn td-navbar-link td-extra-sub-type" active-class="active">
                                        <a href="#">{{$__('Documents')}}</a>
                                        <div class="td-sub-type-info-box" v-if="!$store.getters.isIphoneOrIpodState && !$store.getters.getAvailableFeatures.features_settings.documents.unlock">
                                            <div class="td-sub-type-value">Business</div>
                                            <span class="td-sub-type-info">
                                                {{$__('This feature is part of the Business plan.')}}
                                                <a v-if="$store.getters.getCompanyLanguage === 'ro_RO'" class="td-contact-mail" href="mailto:contact@iflow.ro">contact@iflow.ro</a>
                                                {{$__('Soon, you will need to upgrade your subscription to use it.')}}
                                            </span>
                                        </div>
                                    </router-link>

                                    <router-link v-if="(this.$store.getters.isAdmin || this.$store.getters.getReviewsSessionsPermission)"  tag="li" :to="{name: 'employeeReviewSessionsRoute'}" class="td-navbar-link td-extra-sub-type" active-class="active" exact>
                                        <a href="#">{{$__('Review sessions')}}</a>
                                        <div class="td-sub-type-info-box" v-if="!$store.getters.isIphoneOrIpodState  && parseInt($store.state.company.reviews_limit) < 6">
                                            <div class="td-sub-type-value">Business</div>
                                            <span class="td-sub-type-info">
                                                {{$__('This feature is part of the Business plan.')}}
                                                <a v-if="$store.getters.getCompanyLanguage === 'ro_RO'" class="td-contact-mail" href="mailto:contact@iflow.ro">contact@iflow.ro</a>
                                                {{$__('Soon, you will need to upgrade your subscription to use it.')}}
                                            </span>
                                        </div>
                                    </router-link>

                                    <router-link v-if="userHasWorkspacePermissions && userHasUserEditPermissions" :to="{name: 'generalRemindersRoute', params: { subTab: 'view_all'}}" tag="li" class="td-reports-btn td-navbar-link td-extra-sub-type" active-class="active">
                                        <a href="#">{{$__('Reminders')}}</a>
                                        <div class="td-sub-type-info-box" v-if="!$store.getters.isIphoneOrIpodState && !$store.getters.getAvailableFeatures.features_settings.reminders.unlock">
                                            <div class="td-sub-type-value">Business</div>
                                            <span class="td-sub-type-info">
                                                {{$__('This feature is part of the Business plan.')}}
                                                <a v-if="$store.getters.getCompanyLanguage === 'ro_RO'" class="td-contact-mail" href="mailto:contact@iflow.ro">contact@iflow.ro</a>
                                                {{$__('Soon, you will need to upgrade your subscription to use it.')}}
                                            </span>
                                        </div>
                                    </router-link>

									<!-- employment end motivations -->
									<router-link v-if="userHasWorkspacePermissions && userHasUserEditPermissions" tag="li" :to="{name: 'employmentEndMotivationsListRoute'}" class="td-navbar-link" active-class="active" exact>
										<a href="#">{{$__('Terminated contract reasons')}}</a>
									</router-link>

                                    <!-- contract suspension reasons -->
									<router-link v-if="userHasWorkspacePermissions && userHasUserEditPermissions" tag="li" :to="{name: 'contractSuspensionReasonsListRoute'}" class="td-navbar-link" active-class="active" exact>
										<a href="#">{{$__('Contract suspension reasons')}}</a>
									</router-link>

                                    <!-- contract types -->
                                    <router-link v-if="userHasWorkspacePermissions && userHasUserEditPermissions" tag="li" :to="{name: 'contractTypesListRoute'}" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Contract types')}}</a>
                                    </router-link>


                                    <li v-if="userHasWorkspacePermissions && $store.getters.isAdmin && $store.getters.getAvailableFeatures.features_settings.import.unlock" class="divider"></li>

                                    <li v-if="userHasWorkspacePermissions && $store.getters.isAdmin && $store.getters.getAvailableFeatures.features_settings.import.unlock" @mouseenter="isRendering = true" @mouseleave="isRendering = false" class="td-navbar-link td-import-menu">
                                        <a href="#">{{$__('Import')}}</a>
                                        <!-- import -->
                                        <div v-show="isRendering === true" class="td-import-list-wrap">
                                            <router-link v-if="$store.getters.isAdmin" tag="li" to="/importer/employees"  class="td-navbar-link" active-class="active" exact>
                                                <a href="#">{{$__('Import Employees')}}</a>
                                            </router-link>

                                            <!-- import -->
                                            <router-link v-if="$store.getters.isAdmin" tag="li" to="/importer/revisal"  class="td-navbar-link" active-class="active" exact>
                                                <a href="#">{{$__('Import Revisal')}}</a>
                                            </router-link>

									        <router-link v-if="($store.getters.isAdmin && $store.getters.useProjects) || ($store.getters.useProjects && userHasProjectsPermissions)" tag="li" to="/importer/projects" class="td-navbar-link" active-class="active" exact>
                                                <a href="#">{{$store.getters.getProjectsNameNew('Import projects', 'Import $0')}}</a>
                                            </router-link>

                                            <router-link v-if="$store.getters.isAdmin" tag="li" to="/importer/locations" class="td-navbar-link" active-class="active" exact>
                                                <a class="td-import-location-display" href="#">{{$__('Import locations')}}</a>
                                            </router-link>

                                            <router-link v-if="$store.getters.isAdmin" tag="li" to="/importer/real_attendance" class="td-navbar-link" active-class="active" exact>
                                                <a href="#">{{$__('Import real attendance')}}</a>
                                            </router-link>

                                            <!-- import -->
                                            <router-link v-if="$store.getters.isAdmin" tag="li" to="/importer/bamboo"  class="td-navbar-link" active-class="active" exact>
                                                <a href="#">{{$__('Import BambooHR')}}</a>
                                            </router-link>
                                        </div>
                                    </li>

<!--                                    <router-link v-if="$store.getters.useProjects && $store.getters.isAdmin" tag="li" to="/importer/projects" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Import projects')}}</a>
                                    </router-link>-->

                                </ul>
                            </li>







                            <!-- Reports -->
                            <!-- add the active class only on foodCouponsRoute && clockingRoute routs - bp in el vue router ca nu am reusit asta -->
                            <li v-if="hasReviewsPermission || $store.getters.hasEnabledReports === true" @mouseenter="onMouseEnterNav" @mouseleave="onMouseLeaveNav" @click="onClickNav" :class="{'nav-item': true, 'dropdown': true, active: $route.path.indexOf('reports') !== -1 }">
                                <router-link v-if="getFirstEnabledReport !== false" id="reports-tab" :to="getFirstEnabledReport" class="td-navbar-dropdown dropdown-toggle" exact data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                    {{$__('Reports')}}
                                </router-link>

                                <ul class="dropdown-menu td-reports-dropdown">
                                    <router-link v-if="$store.getters.reportIsDisabled('clocking') === false" exact to="/reports/clocking" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Timesheet')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.reportIsDisabled('food_coupons') === false" to="/reports/foodCoupons" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Food coupons')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.reportIsDisabled('paid_leave') === false" to="/reports/paidLeave" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Paid leave')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.reportIsDisabled('medical') === false" to="/reports/medical" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Sick leave')}}</a>
                                    </router-link>

                                    <router-link v-if="($store.getters.getUiDynamicSettings.overtime_is_enabled || $store.getters.getUiDynamicSettings.time_off_is_enabled) && $store.getters.reportIsDisabled('overtime') === false" to="/reports/overtime" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Overtime and time off')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.reportIsDisabled('employees') === false" to="/reports/employees" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Employees')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.reportIsDisabled('employees_contracts') === false" to="/reports/employeeContracts" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Employees - contracts')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.reportIsDisabled('custom_fields') === false" to="/reports/customFields" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                      <a href="#">{{$__('Custom fields')}}</a>
                                    </router-link>

                                    <router-link  v-if="this.$store.getters.isAdmin || this.$store.getters.getReviewsViewReportPermission" to="/reports/reviews" tag="li" class="td-reports-btn td-navbar-link td-extra-sub-type" active-class="active">
                                        <a href="#">{{$__('Reviews')}}</a>
                                        <div class="td-sub-type-info-box" v-if="!$store.getters.isIphoneOrIpodState && parseInt($store.state.company.reviews_limit) < 6">
                                            <div class="td-sub-type-value">Business</div>
                                            <span class="td-sub-type-info">
                                                {{$__('This feature is part of the Business plan.')}}
                                                <a v-if="$store.getters.getCompanyLanguage === 'ro_RO'" class="td-contact-mail" href="mailto:contact@iflow.ro">contact@iflow.ro</a>
                                                {{$__('Soon, you will need to upgrade your subscription to use it.')}}
                                            </span>
                                        </div>
                                    </router-link>

                                    <li
                                        v-if="
                                            (
                                                $store.getters.reportIsDisabled('attendance_schedule') === false ||
                                                $store.getters.reportIsDisabled('attendance_live') === false
                                            )"
                                        @mouseenter="attendanceScheduleSubMenuIsOpen = true"
                                        @mouseleave="attendanceScheduleSubMenuIsOpen = false"
                                        class="td-navbar-link td-monthly-attendance-menu"
                                    >
                                        <a href="#">{{$__('Work time record')}}</a>
                                        <div v-show="attendanceScheduleSubMenuIsOpen === true" class="td-attendance-list-wrap">
                                            <router-link v-if="$store.getters.reportIsDisabled('attendance_schedule') === false" to="/reports/attendance/schedule" tag="li" class="td-reports-btn td-navbar-link" active-class="active" exact>
                                                <a href="#">{{$__('Monthly attendance')}}</a>
                                            </router-link>

                                            <router-link v-if="$store.getters.reportIsDisabled('attendance_schedule') === false" to="/reports/attendanceDetailed/schedule" tag="li" class="td-reports-btn td-navbar-link" active-class="active" exact>
                                                <a href="#">{{$__('Monthly attendance detailed')}}</a>
                                            </router-link>

                                            <router-link v-if="$store.getters.useCheckInOut && $store.getters.reportIsDisabled('attendance_live') === false" to="/reports/attendance/live" tag="li" class="td-reports-btn td-navbar-link" active-class="active" exact>
                                                <a href="#">{{$__('Real registry')}}</a>
                                            </router-link>

                                            <router-link v-if="$store.getters.useCheckInOut && $store.getters.reportIsDisabled('attendance_live') === false" to="/reports/attendanceDetailed/live" tag="li" class="td-reports-btn td-navbar-link" active-class="active" exact>
                                                <a href="#">{{$__('Real registry detailed')}}</a>
                                            </router-link>
                                        </div>
                                    </li>

                                    <router-link v-if="$store.getters.useCheckInOut && $store.getters.reportIsDisabled('real_attendance') === false" to="/reports/realAttendance" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                      <a href="#">{{$__('Real attendance')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.reportIsDisabled('files') === false" to="/reports/files" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Files')}}</a>
                                    </router-link>


                                    <router-link v-if="$store.getters.getUiDynamicSettings.compensatory_time_is_enabled && $store.getters.reportIsDisabled('compensatory_time') === false" to="/reports/compensatoryTime" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Compensatory Time')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.reportIsDisabled('organizational_chart') === false" to="/reports/organizationalChart" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Organizational Chart')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.reportIsDisabled('vacation_planner') === false" to="/reports/vacationPlanner/event" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Events planner')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.reportIsDisabled('data_export') === false" to="/reports/dataExport" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Data export')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.reportIsDisabled('schedule_changes') === false" to="/reports/scheduleChanges" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Work schedule changes')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.reportIsDisabled('worked_hours') === false" to="/reports/workedHours" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Planned hours')}}</a>
                                    </router-link>

                                    <router-link  v-if="$store.getters.reportIsDisabled('activity_overview') === false" to="/reports/activityOverview" tag="li" class="td-reports-btn td-navbar-link td-extra-sub-type" active-class="active">
                                        <a href="#">{{$__('Activity overview')}}</a>
                                        <div class="td-sub-type-info-box" v-if="!$store.getters.isIphoneOrIpodState && !$store.getters.getAvailableFeatures.features_settings.full_projects.unlock">
                                            <div class="td-sub-type-value">Business</div>
                                            <span class="td-sub-type-info">
                                                {{$__('This feature is part of the Business plan.')}}
                                                <a v-if="$store.getters.getCompanyLanguage === 'ro_RO'" class="td-contact-mail" href="mailto:contact@iflow.ro">contact@iflow.ro</a>
                                                {{$__('Soon, you will need to upgrade your subscription to use it.')}}
                                            </span>
                                        </div>
                                    </router-link>

                                    <router-link v-if="$store.getters.reportIsDisabled('overtime_compensation') === false && $store.getters.businessEventTypeIsDisabled('overtime_compensation') === false" to="/reports/overtimeCompensation" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Overtime compensation')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.reportIsDisabled('overtime_compensation_detailed') === false && $store.getters.businessEventTypeIsDisabled('overtime_compensation') === false" to="/reports/overtimeCompensationDetailed" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Overtime compensation detailed')}}</a>
                                    </router-link>

                                </ul>
                            </li>






                            <!-- settings -->
                            <li id="settings_menu"
                                @mouseenter="onMouseEnterNav"
                                @mouseleave="onMouseLeaveNav"
                                @click="onClickNav"
                                :class="{
                                    'nav-item': true,
                                    'dropdown': true,
                                    active: ($route.path.indexOf('settings') !== -1 && $route.path.indexOf('users') === -1 && $route.path.indexOf('user') === -1  && $route.path.indexOf('teams') === -1)
                                }"
                            >

                                <router-link :to="settingsRoutes" v-if="this.$store.getters.isAdmin || this.$store.getters.isTeamLeaderHr || this.$store.getters.getReviewsTemplatesPermission" class="td-navbar-dropdown dropdown-toggle" exact data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                    <span>{{$__('Settings')}}</span>
                                </router-link>

                                <ul class="dropdown-menu td-settings-menu">
                                    <router-link v-if="this.$store.getters.isAdmin" tag="li" to="/settings/company" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Company')}}</a>
                                    </router-link>

                                    <router-link v-if="this.$store.getters.isAdmin && this.$store.getters.getTdDeployType !== 'portable' && !$store.getters.isIphoneOrIpodState" tag="li" to="/settings/billing" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Billing Settings')}}</a>
                                    </router-link>

                                    <li v-if="this.$store.getters.isAdmin" class="divider"></li>


                                    <router-link v-if="this.$store.getters.isAdmin"  tag="li" to="/settings/leaveDaysTypes" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Paid leave')}}</a>
                                    </router-link>


                                    <router-link v-if="this.$store.getters.isAdmin" tag="li" to="/settings/companyFreeDays" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Public holidays')}}</a>
                                    </router-link>
                                    <router-link v-if="this.$store.getters.isAdmin"  tag="li" to="/settings/customFields/user" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Custom fields')}}</a>
                                    </router-link>


                                    <router-link v-if="(this.$store.getters.isAdmin || this.$store.getters.getReviewsTemplatesPermission)"  tag="li" to="/settings/employeeReviews/templates" class="td-navbar-link td-extra-sub-type" active-class="active" exact>
                                        <a href="#">{{$__('Employee reviews')}}</a>
                                        <div class="td-sub-type-info-box" v-if="!$store.getters.isIphoneOrIpodState  && parseInt($store.state.company.reviews_limit) < 6">
                                            <div class="td-sub-type-value">Business</div>
                                            <span class="td-sub-type-info">
                                                {{$__('This feature is part of the Business plan.')}}
                                                <a v-if="$store.getters.getCompanyLanguage === 'ro_RO'" class="td-contact-mail" href="mailto:contact@iflow.ro">contact@iflow.ro</a>
                                                {{$__('Soon, you will need to upgrade your subscription to use it.')}}
                                            </span>
                                        </div>
                                    </router-link>

                                    <li v-if="this.$store.getters.isAdmin" @mouseenter="isRendering = true" @mouseleave="isRendering = false" class="td-navbar-link td-documents-menu td-extra-sub-type">
                                        <router-link to="/settings/templates" class="td-navbar-link" active-class="active" exact>
                                            {{$__('Documents')}}
                                        </router-link>
                                            <div class="td-sub-type-info-box" v-if="!$store.getters.isIphoneOrIpodState && !$store.getters.getAvailableFeatures.features_settings.documents.unlock">
                                                <div class="td-sub-type-value">Business</div>
                                                <span class="td-sub-type-info">
                                                {{$__('This feature is part of the Business plan.')}}
                                                <a v-if="$store.getters.getCompanyLanguage === 'ro_RO'" class="td-contact-mail" href="mailto:contact@iflow.ro">contact@iflow.ro</a>
                                                {{$__('Soon, you will need to upgrade your subscription to use it.')}}
                                            </span>
                                            </div>

                                        <!-- import -->
                                        <div v-if="isRendering === true" class="td-documents-list-wrap">
                                            <router-link v-if="this.$store.getters.isAdmin" to="/settings/templates" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                                <a href="#">{{$__('Document templates')}}</a>
                                            </router-link>

                                            <router-link v-if="this.$store.getters.isAdmin" to="/settings/series" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                                <a href="#">{{$__('Document series')}}</a>
                                            </router-link>

                                            <router-link v-if="this.$store.getters.isAdmin" to="/settings/document_folders" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                                <a href="#">{{$__('Document folders')}}</a>
                                            </router-link>
                                        </div>
                                    </li>

                                    <router-link v-if="this.$store.getters.isSuperAdmin && this.$store.getters.getTdDeployType !== 'portable' && !$store.getters.isIphoneOrIpodState" tag="li" to="/settings/efactura" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Efactura')}}</a>
                                    </router-link>



                                    <router-link v-if="this.$store.getters.isAdmin" tag="li" to="/settings/eventTypes" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Event Types')}}</a>
                                    </router-link>

                                    <router-link v-if="this.$store.getters.isAdmin || this.$store.getters.isTeamLeaderHr" tag="li" to="/settings/predefinedShifts" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Predefined shifts')}}</a>
                                    </router-link>

									<router-link v-if="this.$store.getters.isAdmin" tag="li" to="/settings/schedulePatterns" class="td-navbar-link" active-class="active" exact>
										<a href="#">{{$__('Schedule patterns')}}</a>
									</router-link>

                                    <router-link v-if="this.$store.getters.isAdmin" tag="li" to="/settings/tools" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Tools')}}</a>
                                    </router-link>


                                    <router-link v-if="this.$store.getters.isAdmin" tag="li" to="/settings/healthInsuranceCompanies" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('Health insurance companies')}}</a>
                                    </router-link>

                                    <li v-if="this.$store.getters.isAdmin" class="divider"></li>

                                    <router-link v-if="this.$store.getters.isAdmin" tag="li" to="/settings/rfidDevices" class="td-navbar-link" active-class="active" exact>
                                      <a href="#">{{$__('RFID Devices')}}</a>
                                    </router-link>

                                    <router-link v-if="this.$store.getters.isAdmin" tag="li" to="/settings/apiKeys" class="td-navbar-link" active-class="active" exact>
                                        <a href="#">{{$__('API Access')}}</a>
                                    </router-link>


<!--                                    <router-link v-if="this.$store.getters.isAdmin" tag="li" to="/settings/integrations/slack" class="td-navbar-link" active-class="active" exact>-->
<!--                                        <a href="#">{{$__('Integrations')}}</a>-->
<!--                                    </router-link>-->
                                </ul>
                            </li>


                            <li :class="{'td-navbar-link': true, active: $route.path.indexOf('premiumModules') !== -1}" v-if="$store.getters.isLoggedIn === true && $store.getters.isTeamLederOrAdmin" @click="onClickNav">
                                <router-link id="modules-tab" :to="{ name: 'premiumModulesRoute' }">
                                    {{$__('iFlow modules')}}
                                </router-link>
                            </li>


                            <!-- Superadmin-->
                            <li v-if="$store.getters.isLoggedIn && $store.getters.isSuperAdmin" @mouseenter="onMouseEnterNav" @mouseleave="onMouseLeaveNav" @click="onClickNav" :class="{'nav-item': true, 'dropdown': true, active: $route.path.indexOf('superadmin') !== -1 }">
                                <a href="#" data-toggle="dropdown" class="td-navbar-dropdown dropdown-toggle" role="button" aria-haspopup="true" aria-expanded="false">{{$__('S')}}</a>
                                <ul class="dropdown-menu">
                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/templates" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Document Templates')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/linkedAccounts" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Linked accounts')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/companiesMessages" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Companies messages')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/freeDays" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                      <a href="#">{{$__('Global Free Days')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/emailTesting" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Email testing')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/companiesAndUsersList" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Companies and users')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel('restricted') || $store.getters.checkSuperAdminLevel('billing')" to="/superadmin/companiesList/fast" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Companies list FAST')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/companiesList/campaigns" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Companies list CAMPAIGNS')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel('restricted')" to="/superadmin/companiesList/active" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Companies list ACTIVE')}}</a>
                                    </router-link>

									<router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/disableCompanies" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
										<a href="#">{{$__('Disable companies')}}</a>
									</router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel('restricted') || $store.getters.checkSuperAdminLevel('billing')" to="/superadmin/companiesList/all" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Companies list')}}</a>
                                    </router-link>

									<router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/adminsActiveDisabledList" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
										<a href="#">{{$__('Active-Blocked list')}}</a>
									</router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/importCsv" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Import CSV')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel('restricted')" to="/superadmin/tracking" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Tracking')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel('billing')" to="/superadmin/billing/subscriptions" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Subscriptions')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel('billing')" to="/superadmin/billingV2" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Billing V2')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/testApi" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Test API')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/apiLog/1/All/All/All/All" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Api Log')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/cronJobs" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Cron Jobs')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/cronJobs/log/1" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Cron Jobs Log')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/addDefaultLocation" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Default location')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/contactReport" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Contact report')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel('billing')" to="/superadmin/salesReport" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Amortized sales report')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel('billing')" to="/superadmin/revenueReport" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Revenue report')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/addUserLocation" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('User - add location')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/addRfidLocation" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('RFID - add location')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/addCompanyFreeDays" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Add company free days')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/addCompanyOtherLeaveDaysTypes" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Add company other leave days types')}}</a>
                                    </router-link>



                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/customerReports" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Customer Reports')}}</a>
                                    </router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/dataModification" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Data Modification')}}</a>
                                    </router-link>

<!--                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/liveAttendanceToIntervals" tag="li" class="td-reports-btn td-navbar-link" active-class="active">-->
<!--                                        <a href="#">{{$__('Live attendance to intervals')}}</a>-->
<!--                                    </router-link>-->

<!--									<router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/addCovid" tag="li" class="td-reports-btn td-navbar-link" active-class="active">-->
<!--										<a href="#">{{$__('Add Covid')}}</a>-->
<!--									</router-link>-->

<!--									<router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/moveUnlockCheckInOutDatetime" tag="li" class="td-reports-btn td-navbar-link" active-class="active">-->
<!--										<a href="#">{{$__('Move unlock_check_in_out_datetime')}}</a>-->
<!--									</router-link>-->

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/syncArticles" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Sync Articles')}}</a>
                                    </router-link>

									<router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/addHalfDayPaidLeave" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
										<a href="#">{{$__('Add half day paid leave')}}</a>
									</router-link>

									<router-link v-if="$store.getters.checkSuperAdminLevel() || $store.getters.checkSuperAdminLevel('billing')" to="/superadmin/companiesDuplicateUsers" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
										<a href="#">{{$__('Companies duplicate users')}}</a>
									</router-link>

									<router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/companiesGroups" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
										<a href="#">{{$__('Companies groups')}}</a>
									</router-link>

									<router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/addEventTypesOnAlertSettings" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
										<a href="#">{{$__('Add event types on allert settings')}}</a>
									</router-link>

<!--									<router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/createDemoCompany" tag="li" class="td-reports-btn td-navbar-link" active-class="active">-->
<!--										<a href="#">{{$__('Create demo company')}}</a>-->
<!--									</router-link>-->

									<router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/addWorkScheduleDefaultLocation" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
										<a href="#">{{$__('Add work schedule default location id')}}</a>
									</router-link>

									<router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/addDaysOnLeaveDaysTypes" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
										<a href="#">{{$__('Add days on leave_days_types')}}</a>
									</router-link>

                                    <router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/debugTeamsDepartments" tag="li" class="td-reports-btn td-navbar-link" active-class="active">
                                        <a href="#">{{$__('Debug teams and departments')}}</a>
                                    </router-link>

<!--									<router-link v-if="$store.getters.checkSuperAdminLevel()" to="/superadmin/migrateOldApproveSettings" tag="li" class="td-reports-btn td-navbar-link" active-class="active">-->
<!--										<a href="#">{{$__('Migrate old approve settings')}}</a>-->
<!--									</router-link>-->


                                </ul>
                            </li>

                        </ul>
                    </div><!--/.nav-collapse -->

                    <!-- search -->
                    <div class="td-menu-element search search-touch" v-if="$store.getters.isLoggedIn === true" >
                        <a class="search search-touch" href="#" v-on:click="onSearchClick">
                            <span class="glyphicon glyphicon-search search-touch"></span>
                        </a>
                    </div>

                    <!-- emag promotion -->
<!--                    <div class="td-menu-element emag-promotion" v-if="$store.getters.isLoggedIn === true && $store.state.companyLanguage === 'ro_RO'" @click="onClickNav">-->
<!--                        <router-link id="notifications-tab" :to="{ name: 'emagPromotionRoute' }">-->
<!--                                <span class="fa fa-gift"> </span>-->
<!--                        </router-link>-->
<!--                    </div>-->

                    <!-- user notifications -->
                    <div class="td-menu-element notifications" v-if="$store.getters.isLoggedIn === true" @click="onClickNav">
                        <router-link id="notifications-tab" v-if="!haveUnreadReminders" :to="{ name: 'userNotificationsRoute' , params:{
                            page: '1',
                            isRead: 'unread'
                        }}">
                            <span class="glyphicon glyphicon-bell">
                                <span v-if="haveUnreadNotifications || haveUnreadReminders || haveUnreadComments" class="unread">
                                    <span v-if="haveUnreadNotifications || haveUnreadReminders || haveUnreadComments"  class="td-unread-count">{{unreadNotifications+unreadReminders+unreadComments}}</span>
                                </span>
                            </span>
                        </router-link>
                        <router-link id="notifications-tab" v-else :to="{ name: 'userRemindersRoute' , params:{
                            page: '1',
                            status: 'unread'
                        }}">
                            <span class="glyphicon glyphicon-bell">
                                <span v-if="haveUnreadNotifications || haveUnreadReminders || haveUnreadComments" class="unread">
                                    <span v-if="haveUnreadNotifications || haveUnreadReminders || haveUnreadComments"  class="td-unread-count">{{unreadNotifications+unreadReminders+unreadComments}}</span>
                                </span>
                            </span>
                        </router-link>
                    </div>

                    <!-- Right navigation -->
                    <ul class="nav navbar-nav navbar-right">

                        <!-- normal user menu -->
                        <li v-if="this.$store.getters.isLoggedIn === true" @mouseenter="onMouseEnterNav" @mouseleave="onMouseLeaveNav" @click="onClickNav" class="nav-item dropdown">
                            <a href="#" data-toggle="dropdown" class="dropdown-toggle nav-user td-navbar-dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                <span class="nav-user-name">{{$store.state.user.full_name}}</span>
                                <span class="nav-user-type">{{getUserTypeMeta}}</span>
                                <span v-if="$store.getters.linkedCompanies > 1" class="nav-user-company">{{$store.state.company.company_name}}</span>
                                <img class="td-user-avatar nav-user-avatar" :src="getAvatarUrl()" />
                            </a>
                            <ul class="dropdown-menu">
                                <router-link tag="li" :to="'/user/' + $store.state.user.ID" class="td-navbar-link" active-class="active" exact>
                                    <div class="td-margin-space"></div>
                                    <a href="#" class="td-nav-account">{{$__('My Account')}}</a>
                                </router-link>

                                <router-link v-if="this.$store.state.company.use_check_in_out === '1'" tag="li" :to="'/user/' + $store.state.user.ID + '/attendance'" class="td-navbar-link" active-class="active" exact>
                                    <a href="#">{{$__('My attendance')}}</a>
                                </router-link>

                                <router-link :to="'/user/' + $store.state.user.ID + '/documents/view_all'" tag="li" class="td-reports-btn td-navbar-link td-extra-sub-type" active-class="active">
                                    <a href="#">{{$__('Documents')}}</a>
                                    <div class="td-sub-type-info-box" v-if="!$store.getters.isIphoneOrIpodState && !$store.getters.getAvailableFeatures.features_settings.documents.unlock">
                                        <div class="td-sub-type-value">Business</div>
                                        <span class="td-sub-type-info">
                                                {{$__('This feature is part of the Business plan.')}}
                                                <a v-if="$store.getters.getCompanyLanguage === 'ro_RO'" class="td-contact-mail" href="mailto:contact@iflow.ro">contact@iflow.ro</a>
                                                {{$__('Soon, you will need to upgrade your subscription to use it.')}}
                                            </span>
                                    </div>
                                </router-link>

                                <router-link tag="li" :to="{name: 'loginCompaniesListRoute'}" class="td-navbar-link" active-class="active" exact>
                                    <a href="#">{{$__('Companies list')}}</a>
                                </router-link>

                                <router-link
                                     v-if="$store.getters.isLoggedIn === true && $store.state.companyLanguage === 'ro_RO'"
                                     :to="{ name: 'emagPromotionRoute' }"
                                     tag="li" class="td-navbar-link td-emag-promotion-link" active-class="active" exact
                                >
                                    <a href="#"> Vouchere eMAG <i class="fa fa-gift"></i></a>
                                </router-link>

                                <div class="no-margin-hr"></div>


                                <!-- multi user login -->
                                <router-link
                                    v-if="isMultiUserEnabled" v-for="(multiUserLoginObj, index) in multiUserLogin"
                                    tag="li"
                                    :class="{'td-multi-user-wrap': true, 'td-multi-user-active': (multiUserLoginObj.session_token === $store.state.user.session_token && multiUserLoginObj.session_company_id === $store.state.user.session_company_id)}"
                                    active-class="active"
                                    :to="{
                                        name: 'loginMultiUserRoute',
                                        params:{language: $store.getters.getUserLanguage, sessionToken: multiUserLoginObj.session_token, sessionCompanyId: multiUserLoginObj.session_company_id, prevUrl: $router.currentRoute.path}
                                    }"
                                    :key="index"
                                >
                                    <a href="#" @touchend="logout_onTouchend" @click="logout_onClick" :title="multiUserLoginObj.fullName">
                                        <div class="td-multi-user-full-name">{{multiUserLoginObj.fullName}}</div>
                                        <div class="td-multi-user-company-name">{{multiUserLoginObj.companyName}}</div>
                                        <div class="td-multi-user-email">{{multiUserLoginObj.email}}</div>
                                    </a>

                                    <!-- delete user -->
                                    <div class="td-multi-user-delete" @click="multiUserDelete(index)" :title="$__('Delete')">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </div>

                                    <div class="no-margin-hr"></div>
                                </router-link>

                                <li><a href="#" @touchend="logout_onTouchend" @click="logout_onClick">{{$__('Logout')}}</a></li>

                            </ul>
                        </li>
                    </ul>

                </div>
            </div>
        </nav>

        <!--show simple navbar with logo on locationCheckInRoute // it was a v else, restricted it to qr checkin page only so it doesn't show on rfid devices-->
        <nav v-else-if="$route.name === 'locationCheckInRoute' || $route.name === 'teamInfoPageRoute'" key="4" class="navbar navbar-default">
            <img src="./assets/logo-image2.png" class="navbar-brand td-fake-navbar-brand"/>
        </nav>

        <div class="td-router-view" :style="tdRouterViewTopMargin ? ('margin-top:' + tdRouterViewTopMargin + 'px;') : ''">
            <router-view
                    :logout="logout"
                    @setLanguage="setLanguage"
                    @logoutCompany="logoutProcessing"
                    @logoutReset="logoutReset"
            ></router-view>
        </div>

        <!-- hide footer on location check-in link + rfid devices + iphone APP-->
        <div v-if="(!$store.getters.isIphoneOrIpodState && !this.$store.getters.isLoggedIn && $route.name !== 'locationCheckInRoute' && $route.name !== 'loginEfacturaRoute' && $route.name !== 'registerCompanyEfacturaRoute' && $route.name !== 'messagesCompanyEfacturaRoute' && $route.name !== 'teamInfoPageRoute' &&
        $route.name !== 'billingEfacturaRoute' && $route.name !== 'clientsEfacturaRoute' && $route.name !== 'articlesEfacturaRoute' && $route.name !== 'categoriesEfacturaRoute' && $route.name !== 'efacturaSettingsRoute' && $route.name !== 'teamInfoReportRoute') && $route.name !== 'loginRfid' && $route.name !== 'dashboardRfid' && $route.name !== 'myProfile'" key="5" class="td-app-footer-wrap">
            <div class="container">
                <div class="td-app-footer-text col-md-8">

                    <div v-if="isLoginLanguage('ro_RO')" class="td-app-footer-links">
                        <a class="td-footer-link" :href="$__('https://iflow.ro/en/terms-and-conditions')" target="_blank">{{$__('Terms and conditions')}}</a><i class="td-icon-point-round"></i>
                        <a class="td-footer-link" :href="$__('https://iflow.ro/en/privacy-policy')" target="_blank">{{$__('Privacy policy')}}</a><i class="td-icon-point-round"></i>
                        <a class="td-footer-link" :href="$__('https://iflow.ro/en/contact-us')" >{{$__('Feedback')}}</a>
                    </div>

                    <div v-else-if="isLoginLanguage('hu_HU')" class="td-app-footer-links">
                        <a class="td-footer-link" :href="$__('https://iflowapp.hu/felhasznalasi-feltetelek/')" target="_blank">{{$__('Terms and conditions')}}</a><i class="td-icon-point-round"></i>
                        <a class="td-footer-link" :href="$__('https://iflowapp.hu/kapcsolatba-lepni-iflow/')" >{{$__('Feedback')}}</a>
                    </div>


                    <div v-else-if="isLoginLanguage('es_ES')" class="td-app-footer-links">
                        <a class="td-footer-link" :href="$__('https://iflowapp.es/terminos-y-condiciones/')" target="_blank">{{$__('Terms and conditions')}}</a><i class="td-icon-point-round"></i>
                        <a class="td-footer-link" :href="$__('https://iflowapp.es/contacto-iflow/')" >{{$__('Feedback')}}</a>
                    </div>

                    <div v-else class="td-app-footer-links">
                        <a class="td-footer-link" :href="$__('https://iflow.ro/en/terms-and-conditions')" target="_blank">{{$__('Terms and conditions')}}</a><i class="td-icon-point-round"></i>
                        <a class="td-footer-link" :href="$__('https://iflow.ro/en/privacy-policy')" target="_blank">{{$__('Privacy policy')}}</a><i class="td-icon-point-round"></i>
                        <a class="td-footer-link" :href="$__('https://iflow.ro/en/contact-us')" >{{$__('Feedback')}}</a>
                    </div>




                    <div class="td-app-footer-copy">
                        © {{new Date().getFullYear()}} iFlow - {{$__('All rights reserved')}}.
                    </div>
                </div>

                <div class="td-app-footer-socials col-md-4">
                    <a v-if="isLoginLanguage('ro_RO')" class="td-footer-social" href="https://www.facebook.com/iflowapp/"><i class="td-icons-social td-icon-facebook"></i></a>
                    <a class="td-footer-social td-footer-social-email" href="mailto:contact@iflow.ro"><i class="td-icons-social td-icon-mail"></i></a>
                </div>
            </div>
        </div>


<!--        <div class="td-contact-us-corner" v-if="$store.getters.getUserLanguage !== 'en_US'">-->
<!--            <a href="https://iflow.ro/contact-iflow" target="_blank">{{$__("Contact us")}}</a>-->
<!--        </div>-->
<!--        <div class="td-contact-us-corner" v-else>-->
<!--            <a href="https://iflow.ro/en/contact-us" target="_blank">{{$__("Contact us")}}</a>-->
<!--        </div>-->
    </div>




</template>

<script>
    import tdDialogMix from './tdDialogMix.js';
    import tdApi from './tdApi.js';
    import companiesMessages from './components/companiesMessages.vue';
    import messageBanner from './components/messageBanner.vue';
    import topSiteMessage from './components/topSiteMessage.vue';
    import tdDeploy from './tdDeploy.js';
    import tdLocalStorage from './tdLocalStorage';
    import tdMobileNotificationsUtil from './components/userNotifications/components/tdMobileNotificationsUtil.js';

    import topSearch from './components/topSearch/topSearch';
    import appLoader from './components/appLoader/appLoader.vue';

    import tdMultiUserLogin from "./tdMultiUserLogin";
    import tdSupportChat from "./tdSupportChat";

    import tdHotJar from "./tdHotJar.js";


    export default {
    mixins: [tdDialogMix.getControllerMix()],
    name: 'app',
    data() {
        /**
         * The menu (nav) has position fixed
         * When <top-site-message> is displayed the menu height increases making it extend over the content displayed by <router-view>
         * tdRouterViewTopMargin heps setting a dynamic margin-top for <router-view> and message banner
         * - <top-site-message> is off tdRouterViewTopMargin = 0
         * - <top-site-message> is on tdRouterViewTopMargin = 50
         */
        return {
            navTouchmove: false,
            tdRouterViewTopMargin: 0,
            tdTopBanner36: false, //we use this to fix the damn sticky menus by adding aditional classes to the #app
            tdTopBanner72: false, //we use this to fix the damn sticky menus by adding aditional classes to the #app

            language: null,
            allowRegistration: true,
            logout: false,
            isRendering: false,
            multiUserLogin: [],
            attendanceScheduleSubMenuIsOpen: false,
            isDropdownOpen: false
        }
    },
    mounted() {
        let vm = this;

        if (vm.$route.name !== 'locationCheckInRoute' && vm.$route.name !== 'teamInfoPageRoute' && vm.$route.name !== 'teamInfoReportRoute' && vm.$route.name !== 'loginRfid' && vm.$route.name !== 'dashboardRfid' && vm.$route.name !== 'myProfile' && vm.$route.name !== 'mainEfacturaRoute' &&
            vm.$route.name !== 'detailsCompanyEfacturaRoute' &&  vm.$route.name !== 'companyEfacturaRoute' && vm.$route.name !== 'messagesCompanyEfacturaRoute' && vm.$route.name !== 'efacturaSettingsRoute' && vm.$route.name !== 'billingEfacturaRoute' && vm.$route.name !== 'articlesEfacturaRoute' && vm.$route.name !== 'categoriesEfacturaRoute' && vm.$route.name !== 'clientsEfacturaRoute' && vm.$route.name !== 'loginEfacturaRoute') {
            vm.$nextTick(function(){
                window.addEventListener('touchend', vm.onTouchOutsideNav);
                document.getElementById('navbar').addEventListener('touchmove', vm.onTouchmoveInsideNav);
                document.getElementById('navbar').addEventListener('touchend', vm.onTouchInsideNav);
                document.getElementById('navbar').addEventListener('click', vm.onClickInsideNav);
            });
        }

        if (vm.$route.name === 'mainEfacturaRoute' && vm.$route.name === 'messagesCompanyEfacturaRoute' && vm.$route.name === 'billingEfacturaRoute' && vm.$route.name === 'clientsEfacturaRoute' && vm.$route.name === 'articlesEfacturaRoute'  && vm.$route.name === 'categoriesEfacturaRoute' && vm.$route.name === 'companyEfacturaRoute' && vm.$route.name === 'efacturaSettingsRoute') {
            vm.$nextTick(function(){
                window.addEventListener('touchend', vm.onTouchOutsideNavEfactura);
                document.getElementById('navbar-efactura-main').addEventListener('touchmove', vm.onTouchmoveInsideNav);
                document.getElementById('navbar-efactura-main').addEventListener('touchend', vm.onTouchInsideNav);
                document.getElementById('navbar-efactura-main').addEventListener('click', vm.onClickInsideNav);
            });
        }


    },
    created() {

        let vm = this;

        // vm.allowRegister();

        //Set an $STORE variable to know when the application is used from an Iphone or an Ipod
        //so we can block some features as Billing because of their policy
        if( /iPhone|iPod/i.test(navigator.userAgent) ) {
            this.$store.commit('setIphoneOrIpodState', true);
        }

        EventBus.$on('on_logInCompanyFromApi', function() {

            let language = vm.$store.getters.getUserLanguage;

            //disable on ELECTRON APP - events page.
            if (vm.$route.name !== 'loginRfid' && vm.$route.name !== 'dashboardRfid' && vm.$route.name !== 'myProfile') {
                // attache tawk
                if (language === 'ro_RO') {
                    tdSupportChat.attachChat('ro_RO');
                } else {
                    tdSupportChat.attachChat('en_US');
                }
            }

            let subscriptionStatus = vm.$store.getters.getCompanyObj;
            //console.log(subscriptionStatus.subscription_status);
            if (subscriptionStatus.subscription_status === 'trial') {
                tdHotJar.attach(language);
            }

            // check notifications, except on loginEfacturaRoute or mainEfacturaRoute
            if(vm.$route.name !== 'loginEfacturaRoute') {
                let registerApiCall = new tdApi('notifications/check_unread');
                registerApiCall.run({
                    'done': function (apiReply) {
                        vm.$store.commit('setUnreadNotifications', apiReply.unread_notifications);
                        vm.$store.commit('setUnreadReminders', apiReply.unread_reminders);
                        vm.$store.commit('setUnreadComments', apiReply.unread_comments);
                    }.bind(this),
                    'error': function (errorApiReply) {}.bind(this)
                });
            }
            // run cron
            // let tdCronApiCall = new tdApi('td_cron/run');
            // tdCronApiCall.run({
            //     'done': function (apiReply) {
            //         if ( apiReply.length && this.$store.getters.isSuperAdmin === true ) {
            //             //window.EventBus.$emit('banner_onSuccessPermanentWithDataFields', 'TD Cron Run OK', apiReply);
            //         }
            //     }.bind(this),
            //     'error': function (errorApiReply) {
            //         //window.EventBus.$emit('banner_onErrorPermanent', 'TD Cron Operation failed:', errorApiReply);
            //     }.bind(this)
            // });


            // read the multi users if available
            vm.multiUserLogin = tdMultiUserLogin.getAllMultiUserLogin();
        });
    },
    computed: {
        settingsRoutes() {
            let buffy = '/settings/company';
            if(this.$store.getters.isTeamLeaderHr) {
                if (this.$store.getters.getReviewsTemplatesPermission) {
                    buffy = '/settings/employeeReviews/templates';
                }
                buffy = '/settings/predefinedShifts';
            }
            if((this.$store.getters.isTeamLeader || this.$store.getters.isTeamMember) && this.$store.getters.getReviewsTemplatesPermission) {
                buffy = '/settings/employeeReviews/templates';
            }
            return buffy;
        },

        isConnected() {
            return this.$store.getters.accountIsConnectedEfactura === 'connected' ? 'Conectat' : 'Conectare';
        },

        getFirstEnabledReport() {
            let vm = this,
                reportsList = [
                    { slug: 'clocking', path: '/reports/clocking' },
                    { slug: 'food_coupons', path: '/reports/foodCoupons' },
                    { slug: 'paid_leave', path: '/reports/paidLeave' },
                    { slug: 'medical', path: '/reports/medical' },
                    { slug: 'overtime', path: '/reports/overtime' },
                    { slug: 'employees', path: '/reports/employees' },
                    { slug: 'employees_contracts', path: '/reports/employeeContracts' },
                    { slug: 'custom_fields', path: '/reports/customFields' },
                    { slug: 'reviews', path: '/reports/reviews' },
                    { slug: 'attendance_schedule', path: '/reports/attendance/schedule' },
                    { slug: 'attendance_live', path: '/reports/attendance/live' },
                    { slug: 'attendance_schedule', path: '/reports/attendanceDetailed/schedule' },
                    { slug: 'attendance_live', path: '/reports/attendanceDetailed/live' },
                    { slug: 'real_attendance', path: '/reports/realAttendance' },
                    { slug: 'files', path: '/reports/files' },
                    { slug: 'compensatory_time', path: '/reports/compensatoryTime' },
                    { slug: 'organizational_chart', path: '/reports/organizationalChart' },
                    { slug: 'vacation_planner', path: '/reports/vacationPlanner/event' },
                    { slug: 'data_export', path: '/reports/dataExport' },
                    { slug: 'schedule_changes', path: '/reports/scheduleChanges' },
                    { slug: 'worked_hours', path: '/reports/workedHours' },
                    { slug: 'activity_overview', path: '/reports/activityOverview' },
                    { slug: 'overtime_compensation', path: '/reports/overtimeCompensation' },
                    { slug: 'overtime_compensation_detailed', path: '/reports/overtimeCompensationDetailed' },
                ],
                buffy = false;

            for (let i = 0; i < reportsList.length; i++) {
                let currentReport = reportsList[i];

                if (!vm.$store.getters.reportIsDisabled(currentReport.slug) &&
                    !(currentReport.slug === 'compensatory_time' && vm.$store.state.company.country_code !== 'RO')
                    && !(currentReport.slug === 'reviews' && vm.$store.getters.getReviewsViewReportPermission === false)) {
                    buffy = currentReport.path;
                    break;
                }
            }


            return buffy;
        },

        getMainClasses(){
            let vm = this;
            let classes = [];
            let features = ['projects', 'documents'];
            if(vm.$route.name === 'workScheduleRoute'){
                classes.push('td-disable-touch-scroll');
            }
            if(vm.isLoginLanguage('en_US')){
                classes.push('td-is-en-us');
            }
            if(vm.isLoginLanguage('hu_HU')){
                classes.push('td-is-hu-hu');
            }
            if(vm.tdTopBanner36){
                classes.push('td-top-banner-36');
            }
            if(vm.tdTopBanner72){
                classes.push('td-top-banner-72');
            }
            if(vm.$store.state.loginRfidOn){
                classes.push('td-login-rfid');
            }

            if(vm.$store.state.company !== null && vm.$store.state.company !== undefined) {
                features.forEach(function (feature, index, arr) {
                    if (vm.$store.state.company['unlock_' + feature] === '1' || vm.$store.state.company['unlock_full_' + feature] === '1') {
                        classes.push('td-has-feature-' + feature);
                    }
                    if (vm.$store.state.company['hide_banner_' + feature] === '1') {
                        classes.push('td-hide-banner-' + feature);
                    }
                });
            }
            return classes;
        },
		userHasProjectsPermissions() {
			return (this.$store.getters.hasAnyPermission('add_team', 'projects') ||
					this.$store.getters.hasAnyPermission('edit_team', 'projects') ||
					this.$store.getters.hasAnyPermission('disable_team', 'projects') ||
					this.$store.getters.hasAnyPermission('delete_team', 'projects') ||
                    this.$store.getters.hasAnyPermission('view_team', 'projects')
            );

		},

        userHasUserEditPermissions() {
            return (this.$store.getters.isAdmin || this.$store.getters.isTeamLeaderHrOnDepartments || this.$store.getters.hasAnyPermission('edit_team', 'users') === true)
        },

        userHasWorkspacePermissions() {
            return (this.userHasUserEditPermissions || (this.$store.getters.useProjects && this.userHasProjectsPermissions));
        },

        haveUnreadNotifications() {
            return parseInt(this.$store.getters.getUnreadNotifications) > 0;
        },
        unreadNotifications() {
            return parseInt(this.$store.getters.getUnreadNotifications);
        },
        haveUnreadReminders(){
            let vm = this;
            if(vm.$store.getters.getAvailableFeatures.features_settings.documents.unlock) {
                return parseInt(vm.$store.getters.getUnreadReminders) > 0;
            }
            return false;
        },
        unreadReminders(){
            let vm = this;
            if(vm.$store.getters.getAvailableFeatures.features_settings.documents.unlock) {
                return parseInt(vm.$store.getters.getUnreadReminders);
            }
            return 0;
        },
        haveUnreadComments(){
            let vm = this;
            return parseInt(vm.$store.getters.getUnreadComments) > 0;
        },
        unreadComments(){
            let vm = this;
            return parseInt(vm.$store.getters.getUnreadComments);
        },
        getUserTypeMeta() {
            let userTypeName = '';

            // let userTeamName = '';
            // console.log(this.$store.getters.getTeamByID(this.$store.state.user.team_id));
            // if (this.$store.state.user.team_id !== "0") {
            //     //userTeamName = this.$store.getters.getTeamByID(this.$store.state.user.team_id).team_name + ' - ';
            // }


            switch (this.$store.state.user.user_type) {
                case 'admin':
                    userTypeName = 'Admin';
                    break;
                case 'team_member':
                    userTypeName = 'Team Member';
                    break;
                case 'team_leader':
                    userTypeName = 'Team Leader';
                    break;
            }

            return userTypeName;
        },

        isMultiUserEnabled() {
            // only one user
            if (this.multiUserLogin.length === 1) {
                return false;
            }

            switch (this.$store.state.user.user_type) {
                case 'admin':
                    if (this.$store.state.company.multi_user_admin === true) {
                        return true;
                    }
                    break;
                case 'team_member':
                    if (this.$store.state.company.multi_user_team_member === true) {
                        return true;
                    }
                    break;
                case 'team_leader':
                    if (this.$store.state.company.multi_user_team_leader === true) {
                        return true;
                    }
                    break;
            }


            return false;
        },

        hasReviewsPermission() {
            if (this.$store.getters.isAdmin === true) {
                return true;
            }

            return this.$store.getters.getReviewsViewReportPermission;
        },

    },
    methods: {
        toggleLogoDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },

        multiUserDelete(index) {
            tdMultiUserLogin.deleteMultiUserLogin(index);

            this.multiUserLogin = tdMultiUserLogin.getAllMultiUserLogin();

        },

        getHomePageLink() {
            if (this.isLoginLanguage('en_US')) {
                return 'https://iflow.ro/en';
            }

            if (this.isLoginLanguage('hu_HU')) {
                return 'https://iflowapp.hu';
            }

            if (this.isLoginLanguage('es_ES')) {
                return 'https://iflowapp.es';
            }

            return 'https://iflow.ro';
        },

        isLoginLanguage(languageCountryCode) {
            if (this.language && this.language.toLowerCase() === languageCountryCode.toLowerCase()) {
                return true;
            }
            return false;
        },

        setLanguage(newLanguage) {
            this.language = newLanguage;
        },

        topSearch_onSearchClose() {
            this.$store.commit('setSearchBarIsOpen', false);
        },
        onSearchClick(event) {
            event.preventDefault();
            this.$store.commit('setSearchBarIsOpen', true);
        },

        hasReportsPermission() {
            if (this.$store.getters.isTeamLederOrAdmin === true) {
                return true;
            }

            if (this.$store.getters.hasAnyPermission('edit_team', 'reports') === true) {
                return true;
            }

            return false;
        },

        setRouterViewTopMargin(tdSiteMessageHeight) {
            this.tdRouterViewTopMargin = tdSiteMessageHeight;

            // we use the two classes for sticky
            switch (tdSiteMessageHeight) {
                case 36:
                    this.tdTopBanner36 = true;
                    this.tdTopBanner72 = false;
                    break;
                case 72:
                    this.tdTopBanner36 = false;
                    this.tdTopBanner72 = true;
                    break;
                default:
                    this.tdTopBanner36 = false;
                    this.tdTopBanner72 = false;



            }
        },
        getAvatarUrl() {
            if (typeof this.$store.state.user.avatar_url !== 'string') {
                return;
            }

            let avatarUrl = this.$store.state.user.avatar_url;

            return tdDeploy.apiThumbUrl + avatarUrl;
        },

        preventBootstrapMenuClose(e) {
            e.stopPropagation();
            e.preventDefault();
            /**
             * do nothing
             * just prevent bootstrap menu from closing on click
             * menu opens on mouseenter
             * menu closes on mouseleave or click on one of it's links
             */
        },
        onClickInsideNav(e) {
            let element = jQuery(e.target);

            //disable menu close when dropdown header is clicked
            if (element.hasClass('dropdown-header')) {
                e.stopPropagation();
                e.preventDefault();
            }
        },

        onTouchOutsideNav(e) {
            let navBar = jQuery('#navbar'),
                navOpened = navBar.hasClass("navbar-collapse") && navBar.hasClass("in"),
                eventTarget = jQuery(e.target);

            if (navOpened && navBar.find(eventTarget).length === 0) {
                //close nav when you click outside the nav container
                jQuery("button.navbar-toggle").click();
            }
        },
        onTouchOutsideNavEfactura(e) {
            let navBar = jQuery('#navbar-efactura-main'),
                navOpened = navBar.hasClass("navbar-collapse") && navBar.hasClass("in"),
                eventTarget = jQuery(e.target);

            if (navOpened && navBar.find(eventTarget).length === 0) {
                //close nav when you click outside the nav container
                jQuery("button.navbar-toggle").click();
            }
        },
        onTouchmoveInsideNav(e) {
            this.navTouchmove = true;
        },
        onTouchInsideNav(e) {
            /**
             * hack made on knees (jenunti) to fix menu for touch devices
             * issue - touch event was propagating to the page elements located behind the menu
             * issue - user menu opens only once, if you open another dropdown you cannot open it again
             * todo - a better solution would be to create a dedicated mobile menu
             */

            e.stopPropagation();

            //don't trigger on touchmove
            let vm = this;
            if (vm.navTouchmove === true) {
                e.preventDefault();
                vm.navTouchmove = false;
                return true;
            }

            //close the menu when a link is clicked
            let element = jQuery(e.target),
                parent = element.parent();

            if (parent.hasClass('td-navbar-link')) {
                //wait for bootstrap dropdown to close and run the link
                setTimeout(function(){
                    jQuery("button.navbar-toggle").click();
                }, 100);
            } else if (element.hasClass('dropdown-toggle')) {
                e.preventDefault();
                //dropdowns
                if (parent.hasClass('open')) {
                    element.attr('aria-expanded', 'false');
                    parent.removeClass("open");
                    return;
                }
                //clear open drowpdowns
                let openDropdowns = jQuery(".dropdown.open");
                openDropdowns.children('dropdown-toggle').attr('aria-expanded', 'false');
                openDropdowns.removeClass("open");

                element.attr('aria-expanded', 'true');
                parent.addClass("open");
            } else if (element.hasClass("nav-user-name") || element.hasClass("nav-user-type") || element.hasClass("nav-user-avatar")) {
                e.preventDefault();
                //user menu
                if (parent.parent().hasClass('open')) {
                    parent.attr('aria-expanded', 'false');
                    parent.parent().removeClass("open");
                    return;
                }

                //clear open drowpdowns
                let openDropdowns = jQuery(".dropdown.open");
                openDropdowns.children('dropdown-toggle').attr('aria-expanded', 'false');
                openDropdowns.removeClass("open");

                parent.attr('aria-expanded', 'true');
                parent.parent().addClass("open");

            }
            else if(element.hasClass("search-touch")) {
                return;
            } else {
                e.preventDefault();
            }
        },

        onMouseEnterNav(e) {
            let eventElement = jQuery(e.target);

            eventElement.addClass('open');
            eventElement.children('.td-navbar-dropdown').attr("aria-expanded","true");
        },
        onMouseLeaveNav(e) {
            let eventElement = jQuery(e.target);

            eventElement.removeClass('open');
            eventElement.children('.td-navbar-dropdown').attr("aria-expanded","false");
        },

        onClickNav(e) {
            let eventElement = jQuery(e.target);



            if (eventElement.attr('href') === '#' || eventElement.attr('href') == window.location.hash) {
                e.stopPropagation();
                e.preventDefault();
            }

        },
        isProduction() {
            return process.env.NODE_ENV === 'development';
        },
        isAdmin() {
            return this.$store.getters.isAdmin === true
        },
        logout_onTouchend(event){
            event.preventDefault();

            //close menu
            this.$refs.navbarToggle.click();

            if(this.$route.name === 'importerRoute'){
                this.logout = true;
            }else {
                this.logoutProcessing();
            }
        },
        logout_onClick(event) {
            event.preventDefault();

            if(this.$route.name === 'importerRoute'){
                this.logout = true;
            }else{
                this.logoutProcessing();
            }
        },

        logoutProcessing(){
            let companyLanguage = this.$store.getters.getUserLanguage;
            this.logout = false;

            //Mobile notifications
            tdMobileNotificationsUtil.sendLogoutEvent();

            tdLocalStorage.delete('td_remember_login_new');
            this.$store.commit('logOut');
            this.$router.push('/login' + '/' + companyLanguage);
        },


        logOutEfactura_onClick(){
            let companyLanguage = this.$store.getters.getUserLanguage;
            this.logout = false;

            //Mobile notifications
            tdMobileNotificationsUtil.sendLogoutEvent();

            tdLocalStorage.delete('td_remember_login_new');
            this.$store.commit('logOutEfactura');
            this.$router.push('/loginEfactura' + '/' + companyLanguage);
        },

        logoutReset(){
            this.logout = false;
        },

        allowRegister() {

            let registerApiCall = new tdApi('auth/allow_register');
            registerApiCall.run({
                'done': function (apiReply) {
                    this.allowRegistration = apiReply.api_allow_registration;
                }.bind(this),
                'error': function (errorApiReply) {}.bind(this)
            });
        },




    },
    components: {
        'companies-messages': companiesMessages,
        'message-banner': messageBanner,
        'top-site-message': topSiteMessage,
        'top-search': topSearch,
        'app-loader':appLoader
    },
    beforeDestroy () {
        window.removeEventListener('touchend', this.onTouchOutsideNav);
        window.removeEventListener('touchend', this.onTouchOutsideNavEfactura);

        // document.getElementById('navbar').removeEventListener('touchend', this.onTouchInsideNav);
        // Check if elements exist before removing event listeners(necesar cand esti logat pe Efacura)
        const navbar = document.getElementById('navbar');
        if (navbar !== null) {
            navbar.removeEventListener('touchend', this.onTouchInsideNav);
        }

        document.getElementById('navbar-efactura-main').removeEventListener('touchend', this.onTouchInsideNav);
    },
    watch:{

    }
}
</script>

<style lang="scss">

    /*
    @keyframes td-loader-background-animation {
        0% {
            background-position: 0% 50%;
        }
        50% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0% 50%;
        }
    }

    .td-loader-bg-animate {
        background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
        background-size: 400% 400%;
        animation: td-loader-background-animation 5s ease infinite;
    }
    */


    /*custom font */
    @font-face {
        font-family: 'iflow';
        src: url('./assets/font/iflow.eot?16');
        src: url('./assets/font/iflow.eot?16#iefix') format('embedded-opentype'),
             url('./assets/font/iflow.woff?16') format('woff'),
             url('./assets/font/iflow.ttf?16') format('truetype'),
             url('./assets/font/iflow.svg?16#iflow') format('svg');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'signature';
        src: url('./assets/font/JustMeAgainDownHere.otf?16') format('opentype'),
            url('./assets/font/JustMeAgainDownHere-Regular.ttf?16') format('truetype');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'Poppins';
        src: url('./assets/font/Poppins-Regular.ttf?16') format('truetype');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'Poppins';
        src: url('./assets/font/Poppins-Medium.ttf?16') format('truetype');
        font-weight: 500;
        font-style: normal;
    }

    @font-face {
        font-family: 'Poppins';
        src: url('./assets/font/Poppins-SemiBold.ttf?16') format('truetype');
        font-weight: 600;
        font-style: normal;
    }

    @font-face {
        font-family: 'Poppins';
        src: url('./assets/font/Poppins-Bold.ttf?16') format('truetype');
        font-weight: bold;
        font-style: normal;
    }

    @font-face {
        font-family: 'ri-small';
        src: url('./assets/font/ri-small.eot?11078412');
        src: url('./assets/font/ri-small.eot?11078412#iefix') format('embedded-opentype'),
        url('./assets/font/ri-small.woff2?11078412') format('woff2'),
        url('./assets/font/ri-small.woff?11078412') format('woff'),
        url('./assets/font/ri-small.ttf?11078412') format('truetype'),
        url('./assets/font/ri-small.svg?11078412#ri-small') format('svg');
        font-weight: normal;
        font-style: normal;
    }

    [class^="ri-"] {
        line-height: 1;
        display: inline-block;
    }


    [class^="ri-"]:before, [class*=" ri-"]:before {
        font-family: "ri-small";
        font-style: normal;
        font-weight: normal;
        line-height: 1;
        speak: never;
    }

    .ri-add-circle-fill:before { content: '\ea10'; } /* '' */
    .ri-add-fill:before { content: '\ea12'; } /* '' */
    .ri-arrow-down-s-line:before { content: '\ea4e'; } /* '' */
    .ri-arrow-left-s-line:before { content: '\ea64'; } /* '' */
    .ri-arrow-right-s-line:before { content: '\ea6e'; } /* '' */
    .ri-arrow-up-s-line:before { content: '\ea78'; } /* '' */
    .ri-briefcase-5-line:before { content: '\eaf3'; } /* '' */
    .ri-delete-bin-line:before { content: '\ec2a'; } /* '' */
    .ri-money-dollar-circle-fill:before { content: '\ef64'; } /* '' */
    .ri-money-dollar-circle-line:before { content: '\ef65'; } /* '' */
    .ri-play-circle-fill:before { content: '\f008'; } /* '' */
    .ri-stop-circle-fill:before { content: '\f19e'; } /* '' */
    .ri-circle-fill:before { content: '\f3c1'; } /* '' */


    //@font-face {
    //    font-family: 'Inter';
    //    src: url('./assets/font/Inter-VariableFont_opsz,wght.ttf?16') format('truetype');
    //    font-weight: 100 900;
    //    font-style: normal;
    //}



    [class^="td-icon-"]:before, [class*=" td-icon-"]:before {
        font-family: 'iflow';
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;

        text-align: center;

        /* Better Font Rendering =========== */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;

    }

    [class*="td-icon-"] {
        line-height: 1;
        text-align: center;
        display: inline-block;
    }

    .td-icon-checkbox-checked:before {content: "\ea52";}
    .td-icon-checkbox-unchecked:before {content: "\ea53";}
    .td-icon-dots-circle-big:before { content: "\e909";}
    .td-icon-dots-circle-medium:before { content: "\e90b";}
    .td-icon-dots-romb-big:before { content: "\e90c";}
    .td-icon-dots-square:before { content: "\e90d";}
    .td-icon-dots-square-big:before { content: "\e90e";}
    .td-icon-dots-square-medium:before { content: "\e90f";}
    .td-icon-magnifier-big-rounded:before { content: "\e910";}
    .td-icon-magnifier-medium-long:before { content: "\e92e";}
    .td-icon-magnifier-medium-short:before { content: "\e92f";}
    .td-icon-magnifier-thin-long:before { content: "\e930";}
    .td-icon-magnifier-thin-short:before { content: "\e931";}
    .td-icon-menu-arrow-down:before { content: "\e932";}
    .td-icon-menu-arrow-right:before { content: "\e933";}
    .td-icon-menu-circle-equal:before { content: "\e934";}
    .td-icon-menu-dots-circle:before { content: "\e935";}
    .td-icon-menu-dots-romb:before { content: "\e936";}
    .td-icon-menu-dots-romb-united:before { content: "\e937";}
    .td-icon-menu-dots-rounded:before { content: "\e938";}
    .td-icon-menu-dots-square:before { content: "\e939";}
    .td-icon-menu-fill-circles:before { content: "\e93a";}
    .td-icon-menu-fill-squares:before { content: "\e93b";}
    .td-icon-menu-line-circles:before { content: "\e93c";}
    .td-icon-menu-line-square-center-equal:before { content: "\e93d";}
    .td-icon-menu-line-square-left:before { content: "\e93e";}
    .td-icon-menu-line-square-right:before { content: "\e93f";}
    .td-icon-menu-medium:before { content: "\e940";}
    .td-icon-menu-medium-center:before { content: "\e941";}
    .td-icon-menu-medium-left:before { content: "\e942";}
    .td-icon-menu-medium-right:before { content: "\e943";}
    .td-icon-menu-medium-square:before { content: "\e944";}
    .td-icon-menu-outline-rounded-square:before { content: "\e945";}
    .td-icon-menu-outline-square:before { content: "\e946";}
    .td-icon-menu-outline-square-round:before { content: "\e947";}
    .td-icon-menu-outline-square-round-lines:before { content: "\e948";}
    .td-icon-menu-rounded-square:before { content: "\e949";}
    .td-icon-menu-square:before { content: "\e94a";}
    .td-icon-menu-square-arrow-right:before { content: "\e94b";}
    .td-icon-menu-square-round:before { content: "\e94c";}
    .td-icon-menu-square-round-lines:before { content: "\e94d";}
    .td-icon-menu-thin:before { content: "\e94e";}
    .td-icon-menu-thin-left:before { content: "\e94f";}
    .td-icon-menu-thin-right:before { content: "\e950";}
    .td-icon-menu-thin-square:before { content: "\e951";}
    .td-icon-menu-vertical:before { content: "\e952";}
    .td-icon-line3-thin:before { content: "\e953";}
    .td-icon-line2-thin:before { content: "\e954";}
    .td-icon-line1-thin:before { content: "\e955";}
    .td-icon-line3-thik:before { content: "\e956";}
    .td-icon-line2-thik:before { content: "\e957";}
    .td-icon-line1-thik:before { content: "\e958";}
    .td-icon-schedule-arrow:before { content: "\e900";}
    .td-icon-add-new-user:before { content: "\e901";}
    .td-icon-bin:before { content: "\e902";}
    .td-icon-team-leader:before { content: "\e903";}
    .td-icon-team:before { content: "\e904";}
    .td-icon-logout:before { content: "\e800";}
    .td-icon-down:before { content: "\e801";}
    .td-icon-left:before { content: "\e802";}
    .td-icon-right:before { content: "\e803";}
    .td-icon-up:before { content: "\e804";}
    .td-icon-views:before { content: "\e805";}
    .td-icon-menu-down:before { content: "\e806";}
    .td-icon-left-arrow:before { content: "\e807";}
    .td-icon-right-arrow:before { content: "\e808";}
    .td-icon-menu-up:before { content: "\e809";}
    .td-icon-search:before { content: "\e80a";}
    .td-icon-user:before { content: "\e80b";}
    .td-icon-menu-left:before { content: "\e80c";}
    .td-icon-menu-right:before { content: "\e80d";}
    .td-icon-star:before { content: "\e80f";}
    .td-icon-mail:before { content: "\e810";}
    .td-icon-facebook:before { content: "\e818";}
    .td-icon-googleplus:before { content: "\e81b";}
    .td-icon-instagram:before { content: "\e81d";}
    .td-icon-linkedin:before { content: "\e81f";}
    .td-icon-mail-1:before { content: "\e820";}
    .td-icon-paypal:before { content: "\e823";}
    .td-icon-picasa:before { content: "\e824";}
    .td-icon-rss:before { content: "\e828";}
    .td-icon-share:before { content: "\e829";}
    .td-icon-skype:before { content: "\e82a";}
    .td-icon-twitter:before { content: "\e831";}
    .td-icon-vimeo:before { content: "\e832";}
    .td-icon-windows:before { content: "\e833";}
    .td-icon-yahoo:before { content: "\e835";}
    .td-icon-youtube:before { content: "\e836";}
    .td-icon-star-empty:before { content: "\e839";}
    .td-icon-star-half:before { content: "\e83a";}
    .td-icon-comments:before { content: "\e83b";}
    .td-icon-close:before { content: "\e83c";}
    .td-icon-read-down:before { content: "\e83d";}
    .td-icon-mobile:before { content: "\e83e";}
    .td-icon-close-mobile:before { content: "\e905";}
    .td-icon-modal-back:before { content: "\e906";}
    .td-icon-modal-close:before { content: "\e907";}
    .td-icon-list-close:before { content: "\e907";}
    .td-icon-category:before { content: "\e908";}
    .td-icon-home:before { content: "\e90a";}
    .td-icon-acolade:before { content: "\e911";}
    .td-icon-backslash:before { content: "\e912";}
    .td-icon-bracket-square:before { content: "\e913";}
    .td-icon-circle:before { content: "\e914";}
    .td-icon-circle-full:before { content: "\e915";}
    .td-icon-circle-line:before { content: "\e916";}
    .td-icon-circless:before { content: "\e917";}
    .td-icon-comma-round:before { content: "\e918";}
    .td-icon-comma-square:before { content: "\e919";}
    .td-icon-hash:before { content: "\e91a";}
    .td-icon-linee:before { content: "\e91b";}
    .td-icon-pluss:before { content: "\e91c";}
    .td-icon-point-comma-round:before { content: "\e91d";}
    .td-icon-point-comma-square:before { content: "\e91e";}
    .td-icon-point-round:before { content: "\e91f";}
    .td-icon-point-square:before { content: "\e920";}
    .td-icon-quote-round:before { content: "\e921";}
    .td-icon-quote-square:before { content: "\e922";}
    .td-icon-romb-full:before { content: "\e923";}
    .td-icon-romb-line:before { content: "\e924";}
    .td-icon-romb-round-full:before { content: "\e925";}
    .td-icon-romb-round-line:before { content: "\e926";}
    .td-icon-rombs:before { content: "\e927";}
    .td-icon-slashh:before { content: "\e928";}
    .td-icon-star-full:before { content: "\e929";}
    .td-icon-star-line:before { content: "\e92a";}
    .td-icon-translingual:before { content: "\e92b";}
    .td-icon-upp:before { content: "\e92c";}
    .td-icon-vertical-line:before { content: "\e92d";}
    .td-icon-plus:before { content: "\ea0a";}
    .td-icon-minus:before { content: "\ea0b";}
    .td-icon-print:before { content: "\f02f";}
    .td-icon-whatsapp:before { content: "\f232";}
    .td-icon-commenting:before { content: "\f27a";}

    .basic-guide-link::before {
      content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
      color: #ff0000; /* Change the color */
      font-weight: bold; /* If you want it to be bold */
      width: 5em; /* Also needed for space (tweak if needed) */
      margin-left: 0; /* Also needed for space (tweak if needed) */
    }



    //general body settings
    body {
        background-color: #eff2f7;
        font-family: "Open Sans",Arial,sans-serif;
        font-size: 13px;
        line-height: 1.4;
        color: #444;
    }


    //main container settings
    .container {
        @media (max-width: 767px) {
            padding-left: 5px;
            padding-right: 5px;
        }
    }

    //main row responsive settings
    .row {
        @media (max-width: 767px) {
            margin-right: 0;
            margin-left: 0;
        }
    }

    //column responsive settings
    .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9,
    .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9 {
        @media (max-width: 767px) {
            padding-left: 5px;
            padding-right: 5px;
        }
    }

    //all links
    a {
        color: #395fc5;
    }

    //all links hover
    a:hover,
    a:active,
    a:focus {
        text-decoration: none;
        opacity: 0.7;
    }

    //fix menu for mobile devices (on lengthy menu some elements were out of screen, unable to reach)
    #navbar.navbar-collapse.in {
        @media (max-width: 767px) {
            overflow-y: auto;
            position: fixed;
            width: 100%;
            max-height: calc(100% - 50px) !important;
            background-color: #395fc5;
            //// scrollbar-width: thin;
        }
    }
    #navbar-efactura-main.navbar-collapse.in {
        @media (max-width: 767px) {
            overflow-y: auto;
            max-height: calc(100% - 50px) !important;
            background-color: #395fc5;
            position: fixed;
            width: 100%;
            z-index: 1;
            top: 50px;
        }
    }

    //main menu bar
    .navbar {
        background-color: #395fc5;
        border-width: 0;
        -webkit-box-shadow: 0 2px 8px rgba(0,0,0,0.2);
        box-shadow: 0 2px 8px rgba(0,0,0,0.2);
        user-select: none;
        moz-user-select: none;
        -webkit-user-select: none;

        .container {
            @media (max-width: 991px) {
                width: 100%;
            }
        }

        .container>.navbar-header {
            @media (max-width: 767px) {
                margin-left: 0;
                margin-right: 0;
            }
        }

        //logo
        .navbar-brand {
            padding: 0;
            margin: 0 20px 0 0 !important;
            color: #fff;
            opacity: 1;

            @media (min-width: 768px) and (max-width: 860px) {
                margin: 0 5px 0 0 !important;
            }


            img {
                height: 50px;
                width: 86px;
                padding: 7px 0;
            }

            &:hover,
            &:active,
            &:focus {
                color: #fff;
                opacity: 1;
            }

            @media (min-width: 768px) and (max-width: 991px) {
                //display: none;
            }
        }

        //logo-on-iphone/ipod devices
        .navbar-brand-iphone {
            padding: 0;
            margin: 0 20px 0 0 !important;
            color: #fff;
            opacity: 1;
            pointer-events: none;

            img {
                height: 50px;
                width: 86px;
                padding: 7px 0;
            }

            &:hover,
            &:active,
            &:focus {
                color: #fff;
                opacity: 1;
            }

            @media (min-width: 768px) and (max-width: 991px) {
                //display: none;
            }
        }

        .td-fake-navbar-brand {
            padding: 7px 0;
            margin-left: 7px !important;
        }

        //menu tags options
        .navbar-nav > li > a {
            color: #fff;
            background-color: transparent;
            padding-left: 13px;
            padding-right: 13px;
            transition: all 0.2s ease-in-out;

            &:before {
                content: '';
                width: 0;
                height: 4px;
                position: absolute;
                left: 0;
                right: 0;
                margin: 0 auto;
                background-color: #8dacff;
                bottom: -4px;
                transition: all 0.2s ease-in-out;
            }



            @media (max-width: 1229px) {
                padding-left: 10px;
                padding-right: 10px;
            }

            @media (min-width: 768px) and (max-width: 991px) {
                padding-left: 5px;
                padding-right: 5px;
            }
        }

        //menu tags spacing
        .navbar-left > li > a {
            margin: 0 2px;

            @media (min-width: 768px) {
                white-space: nowrap;
            }

            @media (min-width: 768px) and (max-width: 788px) {
                margin: 0;
            }
        }

        .navbar-left {
            @media (min-width: 768px) {
                display: flex;
            }
        }


        //arrow right on menu tags with submenu
        .navbar-left .dropdown .td-navbar-dropdown {
            padding-right: 28px;

            &:after {
                font-family: "iflow";
                content:'\E803';
                font-size: 11px;
                color: #fff;
                position: absolute;
                right: 15px;
                top: 17px;
                transition: transform 0.2s ease;

                @media (max-width: 767px) {
                    top: 11px;

                }
            }



            @media (min-width: 768px) and (max-width: 991px) {
                padding-right: 10px;

                &:after {
                    display: none;
                }
            }
        }

        //submenu dropdown align with tags
        .navbar-left .dropdown-menu {
            left: 2px;
			max-height: calc(100vh - 100px);
			overflow: auto;
        }

        //focus settings
        .navbar-nav > li > a:focus {
            color: #fff;
            background-color: transparent;
            opacity: 1;
        }

        //hover effects on menu tags
        .navbar-nav > li > a:hover {
            color: #fff;
            background-color: #2c50af;
            opacity: 1;

            &:before {
                width: 100%;
            }

            &:after {
                transform: rotate(90deg);
            }
        }

        .navbar-nav > .active > a,
        .navbar-nav > .active > a:focus,
        .navbar-nav > .active > a:hover {
            color: #fff;
            background-color: #2c50af;

            &:before {
                width: 100%;
            }

            &:after {
                transform: rotate(90deg);
            }
        }

        .navbar-nav > .open > a,
        .navbar-nav > .open > a:focus,
        .navbar-nav > .open > a:hover {
            color: #fff;
            background-color: #2c50af;

            &:after {
                transform: rotate(90deg);
            }
        }


        //responsive mobile settings
        @media (max-width: 767px) {
            .navbar-nav {
                margin: 0 -25px;
            }

            .navbar-nav > li > a:hover,
            .navbar-nav > li > a:focus {
                &:before {
                    display: none;
                }
            }

            .navbar-nav > .active > a,
            .navbar-nav > .active > a:focus,
            .navbar-nav > .active > a:hover {
                &:before {
                    display: none;
                }
            }

            //dropdown menu on mobile
            .navbar-nav .open .dropdown-menu>.active>a,
            .navbar-nav .open .dropdown-menu>.active>a:focus,
            .navbar-nav .open .dropdown-menu>.active>a:hover {
                color: #fff;
                //opacity: 0.7;
                background-color: #2c50af;
            }

            .navbar-nav .open .dropdown-menu>li>a:focus,
            .navbar-nav .open .dropdown-menu>li>a:hover {
                color: #ffffff;
            }

            .navbar-nav .open .dropdown-menu>.active {
                .td-sub-type-info-box {
                    background-color: #2c50af;
                }
            }

            .navbar-nav .open .dropdown-menu>li>a {
                color: #fff;
            }

            .navbar-nav .open .dropdown-menu .dropdown-header,
            .navbar-nav .open .dropdown-menu>li>a {
                padding: 5px 15px 5px 30px;
            }
        }

        .dropdown-menu {
            font-size: 12px;
            top: 50px;
            border: none;
            -webkit-box-shadow: 0 2px 10px rgba(0,0,0,0.15);
            box-shadow: 0 2px 10px rgba(0,0,0,0.15);

            li>a {
                line-height: 2;
            }

            li>a:focus,
            li>a:hover,
            .active>a,
            .active>a:focus,
            .active>a:hover {
                color: #0038ce;
                background-color: transparent;
                opacity: 1;
            }

            .dropdown-header {
                color: #333;
                background-color: #eff6ff;
                font-size: 11px;
                line-height: 1;
                margin-top: 12px;
                margin-bottom: 2px;
                padding: 5px 20px 6px;
                font-weight: 700;
                //pointer-events: none;

                @media (max-width: 767px) {
                    color: rgba(255, 255, 255, 0.8);
                    background-color: rgba(255,255,255,0.06);
                    font-size: 12px;
                    padding: 6px 20px 7px 30px !important;
                    font-weight: 400;
                }
            }

            .divider {
                margin: 5px 0;

                @media (max-width: 767px) {
                    margin: 9px 0;
                    background-color: rgba(255, 255, 255, 0.2);
                }
            }

            .td-extra-sub-type {
                display: flex;
                a {
                    flex: 1 1 auto;
                }

                .td-sub-type-info-box {

                    .td-sub-type-value {
                        margin: 5px 20px 0 0;
                        background-color: #395fc5;
                        color: #fff;
                        padding: 2px 6px;
                        line-height: 1.4;
                        height: 19px;
                        border-radius: 50px;
                        font-weight: 600;
                        font-size: 10px;
                    }
                    &:hover {
                        .td-sub-type-info {
                            display: block;
                        }
                    }

                    .td-sub-type-info {
                        width: 250px;
                        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
                        background-color: #fff;
                        padding: 10px;
                        position: fixed;
                        color: #666;
                        transform: translate(-70%, 1%);
                        display: none;
                        font-size: 12px;
                        font-weight: 400;
                        z-index: 1;
                    }

                    @media (max-width: 768px) {
                        .td-sub-type-value {
                            background-color: #fff;
                            color: #395fc5;
                            margin-top: 6px;
                        }
                        .td-sub-type-info {
                            width: 80vw;
                            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
                            background-color: #fff;
                            padding: 10px;
                            position: fixed;
                            transform: translate(5%, 1%);
                            left: 0;
                            color: #666;
                            display: none;
                            font-size: 12px;
                            font-weight: 400;
                        }
                    }
                }
            }

            &.td-organization-menu,
            &.td-reports-dropdown {
                @media (min-width: 768px) {
                    overflow: visible;
                }
            }

            &.td-settings-menu {
                @media (min-width: 768px) {
                    overflow: visible;
                }
            }


            &.td-reports-dropdown {
                padding: 0;
                > li:first-of-type {
                    padding-top: 5px;
                }
                > li:last-of-type {
                    padding-bottom: 5px;
                }
            }
        }

        .navbar-toggle {
            border: none;

            .icon-bar {
                background-color: #fff;
            }

            &:active,
            &:focus,
            &:hover {
                background-color:transparent;

                .icon-bar {
                    background-color: #fff;
                    opacity: 0.7;
                }
            }

            @media (max-width: 767px) {
                margin-right: -5px;
            }
        }

        .navbar-collapse,
        .navbar-form {
            @media (max-width: 767px) {
                max-height: 100%;
                border: none;
                box-shadow: inset 0 3px 5px rgba(0,0,0,0.15);
                -webkit-box-shadow: inset 0 3px 5px rgba(0,0,0,0.15);
            }
        }

        .navbar-collapse {
            @media (max-width: 767px) {
                padding-left: 25px;
                padding-right: 25px;
                margin-left: -10px;
                margin-right: -10px;
            }
        }

        //right navbar area
        .navbar-right {
            margin-right: 0;

            @media (max-width: 767px) {
                margin-right: -25px;
            }

            @media (min-width: 768px) {
                .nav-item {
                    height: 50px;
                    display: table;
                }
            }

            .td-emag-promotion-link {
                .fa-gift {
                    margin-left: 6px;
                }
            }

        }

        .navbar-right>li>a:hover,
        .navbar-right>li>a:focus {
            background-color: transparent;
        }

        .navbar-right>.open>a,
        .navbar-right>.open>a:focus,
        .navbar-right>.open>a:hover {
            background-color: transparent;
        }

        //user link a
        .nav-user {
            font-weight: 600;
            margin: 0 !important;
            padding: 0 35px 0 0 !important;
            text-align: right;
            position: relative;
            display: table-cell;
            vertical-align: middle;

            &:before {
                display: none;
            }

            &:hover,
            &:active,
            &:focus {
                opacity: 1 !important;
            }

            @media (max-width: 767px) {
                text-align: left;
                display: inline-block;
                padding: 0 0 0 35px !important;
                margin: 5px 0 10px 20px !important;
            }
        }

        //user navbar image
        .td-user-avatar {
            width: 26px;
            height: 26px;
            border-radius: 100px;
            position: absolute;
            top: 12px;
            left: calc(100% - 26px);
            z-index: -10;

            @media (max-width: 767px) {
                left: 0;
                top: 0;
            }
        }

        .nav-user-company {
            font-size: 11px;
            display: block;
            line-height: 1.4;
        }

        //user name
        .nav-user-name {
            line-height: 1;
            display: block;
            margin-bottom: 2px;
            text-transform: uppercase;
            white-space: nowrap;
            max-width: 225px;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        //user type
        .nav-user-type {
            line-height: 1;
            display: block;
            font-size: 11px;
            font-weight: 400;
            opacity: 0.8;
        }

        @media (min-width: 768px) and (max-width: 1229px) {
            .nav-user-name {
                display: none;
            }
            .nav-user-type {
                display: none;

            }
        }


        //login and register links
        .td-navbar-login-register a {
            margin: 0 2px;

            &:hover {
                background-color: #2c50af !important;
            }
        }

        .td-import-menu {
            position: relative;

            &:hover>a {
                color: #0038ce;
            }

            &:before {
                content: '';
                position: absolute;
                top: 0;
                width: 100%;
                height: 185px;
                z-index: -1;
            }

            &:after {
                font-family: "iflow";
                content: '\E803';
                font-size: 11px;
                color: #000;
                position: absolute;
                right: 15px;
                top: 8px;
                cursor: pointer;
                pointer-events: none;
            }

            &:hover:after {
                color: #0038ce;
            }

            li a {
                display: block;
                padding: 3px 20px;
                clear: both;
                font-weight: 400;
                line-height: 2;
                color: #333;
                white-space: nowrap;
            }
            @media (max-width: 767px) {
                display: none;
            }
            .td-import-list-wrap {
                position: absolute;
                left: 100%;
                top: -5px;
                padding: 5px 0;
                background-color: #fff;
                box-shadow: 0 2px 10px #00000026;
            }
        }

        .td-monthly-attendance-menu {
            position: relative;

            &:hover>a {
                color: #0038ce;
            }

            &:before {
                content: '';
                position: absolute;
                top: 0;
                width: 100%;
                height: 185px;
                z-index: -1;
            }

            &:after {
                font-family: "iflow";
                content: '\E803';
                font-size: 11px;
                color: #000;
                position: absolute;
                right: 15px;
                top: 8px;
                cursor: pointer;
                pointer-events: none;
            }

            &:hover:after {
                color: #0038ce;
            }

            li a {
                display: block;
                padding: 3px 20px;
                clear: both;
                font-weight: 400;
                line-height: 2;
                color: #333;
                white-space: nowrap;
            }

            .td-attendance-list-wrap {
                position: absolute;
                left: 100%;
                top: -5px;
                padding: 5px 0;
                background-color: #fff;
                box-shadow: 0 2px 10px #00000026;
            }

            @media (max-width: 767px) {
                .td-attendance-list-wrap {
                    position: relative;
                    left: 0;
                    top:0;
                }
            }
        }
    }

    .td-documents-menu {
        position: relative;
        &:hover>a {
            color: #0038ce;
        }
        &:hover:after {
            color: #0038ce;
        }
        &:after {
            font-family: "iflow";
            content: '\E803';
            font-size: 11px;
            color: #000;
            position: absolute;
            right: 10px;
            top: 8px;
            cursor: pointer;
            pointer-events: none;
            @media (max-width: 768px) {
                display: none;
            }
        }
        li a {
            display: block;
            padding: 3px 20px;
            clear: both;
            font-weight: 400;
            line-height: 2;
            color: #333;
            white-space: nowrap;
        }
        @media (max-width: 767px) {
            display: none;
        }
        .td-documents-list-wrap {
            position: absolute;
            left: 100%;
            top: -5px;
            padding: 5px 0;
            background-color: #fff;
            box-shadow: 0 2px 10px #00000026;
        }
    }

    .no-margin-hr {
        margin: 5px 0;
        border-top: 1px solid #eaeaea;

        @media (max-width: 767px) {
            border-top: 1px solid #617fd1;
        }
    }


    .td-multi-user-wrap {
        position: relative;

        &.td-multi-user-active {
            a {
                color: #0038ce;
            }
        }

        a {
            line-height: 1.3 !important;
        }
    }
    .td-multi-user-company-name,
    .td-multi-user-email {
        color: #b7b7b7;
    }

    .td-multi-user-delete {
        position: absolute;
        top: -3px;
        right: 0;
        padding: 5px;
        cursor: pointer;
    }




    #quit-guide-button {
      position: fixed;
      bottom: 50px;
      left: 50px;
      z-index:10050;

        .quit-guide-button {
            display: block;
            padding: 16px 24px;
            font-size: 14px;
            line-height: 1;
            background-color: #e88383;
            box-shadow: 0 2px 4px 0 rgba(222, 74, 74, 0.4);

            &:hover,
            &:active,
            &:focus {
                background-color: #e27878;
                box-shadow: none;
            }
        }
    }

    //pages padding top
    .td-login-companies,
    .td-dashboard-wrap,
    //.td-dashboard,
    .td-activity-page-wrap,
    .td-activity-event,
    .td-reports,
    .td-user-page,
    .td-login,
    .td-comp-settings-wrap,
    .td-work-schedule-two,
    .td-import-users,
	.td-page-padding-top,
    .td-404-page,
    .td-superadmin,
    .td-checkout,
    .td-checkoutOP,
    .td-notifications,
	.td-location-check-in {
        padding-top: 80px;
        padding-bottom: 40px;
    }
    .td-team-info-page {
        padding-top: 80px;
        padding-bottom: 40px;
    }

    .panel {
        border: none;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.08);

        .panel-heading {
            background-color: #fff;
            color: #444;
            border: none;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
            font-size: 14px;
            line-height: 1;
            font-weight: 700;
            padding: 18px;
            border-bottom: 2px solid rgba(186, 204, 222, 0.38);

            .pull-right a {
                font-size: 13px;
                color: #444;
            }

            @media (max-width: 767px) {
                padding: 15px 10px;
            }
        }

        .panel-body {
            padding: 20px;

            @media (max-width: 767px) {
                padding: 10px;
            }
        }
    }


    .btn {
        color: #fff;
        background-color: #395fc5;
        //text-transform: uppercase;
        font-size: 13px;
        line-height: 1;
        font-weight: 600;
        padding: 12px 20px;
        border: none;
        box-shadow: 0 2px 3px rgba(69, 114, 199, 0.4);
        transition: all 0.2s ease;

        i {
            margin-right: 6px;
        }

        &:hover,
        &:active,
        &:focus {
            color: #fff;
            opacity: 1;
            border: none;
            box-shadow: none;
            background-color: #294eb0;
        }
        &.cancel-btn {
            background-color: transparent !important;
            box-shadow: none !important;
            cursor: default;
        }
    }

    .btn-default:hover,
    .btn-default:active,
    .btn-default:focus,
    .btn-default:active:focus {
        color: #fff;
        background-color: #395fc5;
        opacity: 1;
        border: none;
        box-shadow: none;
    }

    .btn.disabled,
    .btn[disabled],
    fieldset[disabled] .btn {
        opacity: 1;
        background-color: #ccc;

        &:hover {
            opacity: 1;
        }
    }



    .btn.active.focus,
    .btn.active:focus,
    .btn.focus,
    .btn:active.focus,
    .btn:active:focus,
    .btn:focus {
        outline: none;
        outline-offset: 0;
    }

    .btn-success:hover {
        border: none;
    }

    .btn-sm {
        padding: 6px 14px 7px;
        font-size: 11px;
        line-height: 1.4;
        border-radius: 3px;
    }




    /* calendar */
    .ui-widget-content {
        color: #444;
    }

    .ui-datepicker {
        border: none !important;
        border-radius: 0;
        -webkit-box-shadow: 0 2px 10px rgba(0,0,0,0.25);
        box-shadow: 0 2px 10px rgba(0,0,0,0.25);
        padding: 15px;
        margin-bottom: 25px;
        width: 320px;
        font-family: 'Open Sans', arial, sans-serif;

        //header
        .ui-datepicker-header {
            border: none;
            border-bottom: 1px solid #ddd;
            border-radius: 0;
            background: transparent;
            color: #444;
            font-weight: 700;
            padding-bottom: 10px;
            margin-bottom: 5px;
            text-transform: uppercase;
        }

        //calendar body
        .ui-datepicker-calendar {
            font-size: 12px;
            line-height: 1;
            margin: 0;
            height: 250px;

            //table head
            thead {
                th {
                    padding: 15px 0;
                    font-size: 13px;
                }
                span {
                    position: relative;
                    right: 3px;
                }
            }

            //all table data
            td {
                border-radius: 0;
                border: none;
                padding: 0;
            }

            //default state td
            .ui-state-default {
                width: 33px;
                height: 33px;
                line-height: 31px;
                text-align: center;
                border-radius: 100px;
                padding: 0;
                font-weight: 600;
                color: #888;
                background: transparent;
                border: none;
                transition: all 0.2s ease;
            }

            //current day
            .ui-datepicker-today a,
            .ui-datepicker-today span {
                box-shadow: 0 3px 12px rgba(0,0,0,0.1);
                background-color: #fff;
            }

            .ui-state-highlight,
            .ui-widget-content .ui-state-highlight,
            .ui-widget-header .ui-state-highlight {
                background: transparent;
                color: #888;
            }

            .ui-state-highlight a,
            .ui-widget-content .ui-state-highlight a,
            .ui-widget-header .ui-state-highlight a {
                background: #f462da none !important;
                -webkit-box-shadow: 0 6px 10px rgba(0,0,0,0.15);
                box-shadow: 0 6px 10px rgba(0,0,0,0.15);
            }

            .ui-state-disabled,
            .ui-widget-header .ui-state-disabled {
                opacity: 0.5;
            }
        }
    }




    #ui-datepicker-div {
        .ui-state-active {
            background: #f462da; //normal selection
            color: #fff !important;
            font-weight: 700;
            -webkit-box-shadow: 0 6px 10px rgba(0,0,0,0.15);
            box-shadow: 0 6px 10px rgba(0,0,0,0.15);
        }


        .td-datepick-company-free-day {
            a {
                color: #ff0000 !important; // company free day
            }

        }

        .ui-datepicker-current-day.td-datepick-company-free-day {
            a {
                color: #dc0000 !important; //company free day + selected on calendar
            }
        }
    }


    //x button
    .glyphicon-remove {
        color: #ff0000;
        top: 2px;
    }

    .td-loading-button {
        padding-right: 12px;
        .fa-spin {
            margin-left: 10px !important;
        }

        &:hover {
            background-color: #395fc5 !important;
        }
    }

    //ok button
    .glyphicon-ok {
        color: #3ec76d;
    }

    //left menu
    .list-group {
        -webkit-box-shadow: 0 1px 3px rgba(0,0,0,0.08);
        box-shadow: 0 1px 3px rgba(0,0,0,0.08);
        background-color: #fff;
        border-radius: 4px;
        padding: 12px 0;

        &:last-child {
            margin-bottom: 40px;
        }
    }

    a.list-group-item,
    button.list-group-item {
        color: #444;
    }
    .list-group-item {
        background-color: #fff;
        border: none;
        margin-bottom: 0;
        padding: 7px 15px;
        font-weight: 600;
    }

    a.list-group-item:focus,
    a.list-group-item:hover,
    button.list-group-item:focus,
    button.list-group-item:hover,
    .list-group-item.active,
    .list-group-item.active:focus,
    .list-group-item.active:hover {
        color: #395fc5;
        text-decoration: none;
        background-color: #fff;
        opacity: 1;
    }

    //login and register
    .td-login-company,
    .td-register,
    .td-password-recover,
    .td-password-reset {

        /*background-image: url(assets/bg.jpg);*/
        /*background-size: cover;*/
        /*background-repeat: no-repeat;*/
        /*background-position: center;*/

        background-color: white;

        .td-login-register-wrap {
            height: 100vh;
            position: relative;


            //small fix for form over footer on lower height phones
            &.td-login-register-long-form {
                @media (max-height: 750px) {
                    height: calc(100vh + 50px);
                    .td-login-register-form {
                        //fix for login form on lower height phones where form header gets under navbar
                        transform: none !important;
                        top: 55px;
                    }
                }
            }

            .td-google-authenticator-code {
                margin-bottom: 0;
                padding-bottom: 0;
                > label {
                    text-align: center;
                }

                > input {
                    max-width: 100%;
                }
            }
        }

        .td-login-register-form {
            background-color: #fff;
            padding: 0 20px 26px;
            border-top-left-radius: 7px;
            border-top-right-radius: 7px;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            position: absolute;
            top: 49%;
            left: 0;
            right: 0;
            margin: 0 auto;
            transform: translateY(-50%);
            box-shadow: 0 10px 70px 0 rgba(67, 120, 180, 0.16), 0 15px 105px 0 rgba(67, 120, 180, 0.16);
            border: 1px solid rgba(186, 210, 238, 0.79);
            z-index: 10;


            @media (max-width: 767px) {
                margin: 0 15px;
            }
        }

        .td-login-register-title {
            text-align: center;
            font-size: 16px;
            font-weight: 700;
            line-height: 1;
            padding: 18px;
            margin: 0 -20px;
            font-weight: 700;
            color: #fff;
            border: none;
            background-color: #395fc5;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
        }

        .form-header-welcome {
            margin: 0 0 35px;
            padding: 20px 0;
            border-bottom: 1px solid #eaf1fb;

            h4 {
                font-size: 14px;
                text-align: center;
                font-weight: 600;
            }
        }

        .form-group {
            margin-bottom: 23px;
        }

        .form-control {
            padding: 5px 15px;
            height: 48px;
            margin-bottom: 7px;
            border-radius: 0;
            border: 1px solid #eaeaea;
            -moz-box-shadow: none;
            -webkit-box-shadow: none;
            box-shadow: none;
            font-size: 13px;
            line-height: 1;
            color: #444;

            &:focus {
                border: 1px solid #bbb;
            }
        }

        label {
            //text-transform: uppercase;
            font-weight: 600;
            margin-bottom: 7px;
        }


        //buttons
        .td-login-button,
        .td-register-button,
        .td-recover-button {
            height: 48px;
            padding: 5px 15px;
            border-radius: 0;
            background-color: #ef9595;
            box-shadow: none;
            /*-webkit-box-shadow: 0 2px 8px 0 rgba(222, 74, 74, 0.5);*/
            /*-moz-box-shadow: 0 2px 8px 0 rgba(222, 74, 74, 0.5);*/
            /*box-shadow: 0 2px 8px 0 rgba(222, 74, 74, 0.5);*/
            -webkit-transition: all 0.2s ease;
            -moz-transition: all 0.2s ease;
            -o-transition: all 0.2s ease;
            transition: all 0.2s ease;

            &:hover,
            &:active,
            &:focus,
            &:active:focus {
                background-color: #395fc5;
                -webkit-box-shadow: 0 2px 8px 0 rgba(74, 90, 222, 0.5);
                -moz-box-shadow: 0 2px 8px 0 rgba(74, 90, 222, 0.5);
                box-shadow: 0 2px 8px 0 rgba(74, 90, 222, 0.5);
            }
        }

        .td-login-button {
            margin-top: 35px;
        }

        .td-register-button {
            float: right;
            margin-top: 20px;
        }

        .td-register-back {
            position: relative;
            top: 35px;
            font-weight: 600;
            text-transform: uppercase;

            &:hover,
            &:active,
            &:focus {
                color: #395fc5;
            }

            .td-register-back-arrow {
                font-size: 9px;
                top: 0;
                margin-right: 5px;
            }
        }

        //links
        .td-login-company-links {
            margin-top: 20px;
            text-align: center;

            a {
                color: #ef9595;
                font-weight: 600;
            }

            a:hover,
            a:active,
            a:focus {
                color: #395fc5;
                opacity: 1;
            }
        }

        .td-password-group {
            position: relative;

            .td-forgot-password {
                position: absolute;
                top: 0;
                right: 0;

                a {
                    color: #aaa;
                }

                a:hover,
                a:active,
                a:focus {
                    color: #444;
                    opacity: 1;
                }
            }
        }

        .alert {
            margin: 0 -20px;
            padding: 20px;
            text-align: center;
        }
    }

    //general alert settings
    .alert {
        border: none;
        border-radius: 0;
        padding: 15px 15px 9px;
        margin-bottom: 25px;
        position: relative;

        &:before {
            font-family:'Glyphicons Halflings';
            content: "\e209";
            display: inline-block;
            font-size: 19px;
            line-height: 1;
            text-align: center;
            position: absolute;
            left: 14px;
            top: 13px;
        }
    }

    .alert-danger {
        color: #fff;
        background-color: #f77764;
        border-color: transparent;
        border: none;
    }

    //error list items
    .td-error-list-items {
        list-style-type: none;
        margin-left: 30px;
        margin-bottom: 6px;
        line-height: 17px;

        a {
            color: #fff;
            font-weight: 600;
        }
    }


    //general warning settings
    .td-warning-wrap {
        margin-top: 9px;
        background-color: #f1b413;
        color: #fff;
    }

    .td-warning-message {
        display: block;
        line-height: 17px;
        margin-left: 30px;
        margin-bottom: 6px;

        a {
            color: #fff;
            font-weight: 600;
        }
    }


    // paragraph info description
    .td-info-desc {
        color:#7b7b7b;
    }

    // [?] hover - info box
    .td-info-box {
        display: inline-block;
        position: relative;
        margin-left: 5px;
        color: rgba(25, 97, 199, 0.5);

        .td-info-box-text {
            font-size: 12px;
            font-weight: 400;
            text-transform: none;
            position: absolute;
            /*left: 50%;*/
            /*top: 50%;*/
            width: 200px;
            max-height: 200px;
            padding: 15px;
            overflow: auto;
            z-index: 3;
            /*border-top-left-radius: 0;*/
            background-color: #ffffff;
            color: #666;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
            -moz-box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
            /*// scrollbar-width: thin;*/

            @media (max-width: 767px) {
                position: fixed;
                left:0;
                bottom: 100px;
                width: 100%;
                background-color: #2b2b2b;
                color:white;

                a {
                    color: white;
                    text-decoration: underline;
                }
            }

            p {
                margin: 0;
            }

            .td-info-box-title {
                font-weight: bold;
                margin-bottom: 10px;
            }

            .td-info-box-subtitle {
                font-weight: bold;
            }

            ul {
                padding-left: 6px;
                margin: 0;

                li {
                    margin-top: 6px;
                }
            }
        }

        &:hover .td-info-box-text {
            display: block !important;
        }
    }

    //readonly field fix
    .form-control[readonly] {
        background-color: #fff;
    }

    //footer
    .td-app-footer-wrap {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: #f4f6f8;
        color: #fff;
        padding: 16px 0;

        //left column
        .td-app-footer-text {
            font-size: 12px;
            color:#637381;

            .td-app-footer-links {
                margin: 0 0 2px -8px;

                .td-footer-link {
                    color:#637381;
                    margin: 0 8px;
                    transition: color 0.2s ease;

                    font-size:13px;
                    &:hover {
                        color: black;
                    }
                }

                .td-icon-point-round {
                    position: relative;
                    top: -1px;
                    left: 2px;
                }
            }

            .td-app-footer-copy {
                opacity: 0.5;
            }
        }


        //right column
        .td-app-footer-socials {
            text-align: right;

            .td-footer-social {
                .td-icons-social {
                    color:#637381;
                    background-color: rgb(255, 255, 255);
                    margin: 0 4px;
                    width: 32px;
                    height: 32px;
                    font-size: 14px;
                    line-height: 33px;
                    border-radius: 100px;
                    transition: all 0.2s ease;
                }

                &:hover {
                    opacity: 1;

                    .td-icons-social {
                        color: rgba(0, 0, 0, 0.7);
                        background-color: rgba(255, 255, 255, 0.4);
                    }
                }
            }
        }



        //responsive mobile
        @media (max-width: 992px) {
            position: static;
            background-color: #142239;
            padding: 20px 0;

            //left column
            .td-app-footer-text {
                text-align: center;
                margin-bottom: 15px;

                .td-app-footer-links {
                    margin: 0 -5px 2px -5px;

                    .td-footer-link {
                        display: inline-block;
                        margin: 2px 5px;
                    }
                }
            }

            //right column
            .td-app-footer-socials {
                text-align: center;
            }
        }
    }

    .td-user-required-field {
        margin-left: 4px;
    }

    //ios hack, if just overflow hidden is applied, body scroll is still working behind modal
    .td-modal-is-open {
        overflow: hidden;
        position: relative;
        height: 100%;
    }

    .td-modal-is-open-general {
        .td-reports-content {
            .td-report-company-wrap {
               position: static;
            }
        }
    }

    #driver-highlighted-element-stage {
        background: transparent!important;
    }

    input {
        outline: none;
        border-radius: 4px;
        border: 1px solid #e4e4e4;
    }
    input:focus {
        border: 1px solid #395fc5;
    }


    // header tabs
    .td-header-tabs-wrap {
        @media (max-width: 767px) {
            overflow-x: auto;
            padding-top: 10px;
            padding-bottom: 10px;
        }
    }

    //tabs
    .td-header-tabs {
        width: 100%;
        list-style: none;
        padding: 0 0;
        margin: 0;
        font-size: 12px;
        font-weight: 600;


        white-space: nowrap;


        li {
            display: inline-block;
            a {
                padding: 10px 10px 13px 10px;
                color: #444;
                transition: opacity 0.2s ease;
                position: relative;
                top:5px;
                border: 1px solid transparent;

                @media (max-width: 767px) {
                    padding: 10px;
                    display: block;


                }

                .td-fix-for-log {
                    padding: 0;
                    color: inherit;
                    transition: none;
                    position: relative;
                    top: unset;
                    border: unset;

                    @media (max-width: 767px) {
                        padding: 0;
                        display: block;
                    }
                }

            }

            a:hover {
                @media (min-width: 768px) {
                    color: #395fc5;
                }

            }

            .router-link-exact-active {
                opacity: 1;
                background-color: white;
                border: 1px solid rgba(186, 204, 222, 0.38);
                border-bottom: none;
                text-decoration: none !important;

                @media (max-width: 767px) {
                    color: #395fc5;
                    border: 1px solid transparent;
                }
            }


        }

        li:first-child {
            margin-left: -10px;
        }
    }


    // help text - full paragraph
    .td-info-paragraph {
        color:black;
        font-size:13px;
    }


    // the : separator that we use between the hour:minutes
    .td-min-h-sep {
        color: #a6a6a6;
        font-size: 11px;
        padding: 0 1px 0 1px;
        position: relative;
        top:-1px;
    }


    .td-is-en-us .td-app-footer-socials {
        .td-footer-social {
            display: none;
        }

        .td-footer-social-email {
            display: block;
        }
    }


    //scrollbar style for modals only
    // it here because we have at least 3 differend components for modals
    .modal-body::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.15);
        background-color: #dfdfdf;
    }

    .modal-body::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    .modal-body::-webkit-scrollbar-thumb {
        background-color: #999999;
        opacity: 1;
    }


    /*
    in case tawk dosn't work
    .td-contact-us-corner {
        @media print {
            display: none;
        }
        @media (max-width: 768px) {
            z-index: 10;
        }

        background-color: #395fc5;

        position: fixed;
        bottom: 0;
        right:0;

        a {
            display: block;

            padding: 5px;
            color:white;
            font-weight: bold;
            font-size: 11px;
        }
    }
*/

    @media (max-width: 768px) {
        .td-import-location-display {
            display: none !important;
        }
    }



    //::-webkit-scrollbar-track {
    //    -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.15);
    //    background-color: #dfdfdf;
    //}
    //
    //::-webkit-scrollbar {
    //    width: 6px;
    //    height: 6px;
    //}
    //
    //::-webkit-scrollbar-thumb {
    //    background-color: #999999;
    //    opacity: 1;
    //}
    .td-navbar-wrap, .td-navbar-wrap-efactura {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .td-login-menu {

            position: absolute;
            right: 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;

            .td-navbar-login-register {
                transition: all 0.2s ease-in-out;
                &.router-link-exact-active {
                    background-color: #2c50af !important;
                }

                a {
                    opacity: 1;
                    color: #fff;
                    line-height: 20px;
                    margin: unset;
                }

                &:hover {
                    opacity: 1;
                    background-color: #2c50af;

                    a {
                        opacity: 1;
                        color: #fff;
                        text-decoration: none;
                        background-color: transparent !important;
                    }
                }
            }

            .td-navbar-login-register {
                position: relative;
                padding: 15px 13px;
                margin: 0 2px;

                a:before {
                    content: "";
                    width: 0;
                    height: 4px;
                    position: absolute;
                    left: 0;
                    right: 0;
                    margin: 0 auto;
                    background-color: #8dacff;
                    bottom: -4px;
                    transition: all .2s ease-in-out;
                }

                &.active a:before {
                    width: 100%;
                }

                & a:hover:before {
                    width: 100%;
                }
            }

        }

        .td-menu-element {
            display: flex;
            align-items: center;
            position: relative;

            &:before {
                content: '';
                width: 0;
                height: 4px;
                position: absolute;
                left: 0;
                right: 0;
                margin: 0 auto;
                background-color: #8dacff;
                bottom: -4px;
                transition: all 0.2s ease-in-out;
            }
            &:hover:before {
                width: 100%;
            }

            @media (min-width: 768px) and (max-width: 991px) {
                padding: 0 5px;
            }

            a {
                padding: 16px 12px;
                position: relative;
                color: #fff;
                @media (max-width: 768px) {
                    padding: 13px 12px;
                }
            }
        }

        .notifications {
            margin-left: auto;

            .unread {
                position: absolute;
                top: -11px;
                white-space: nowrap;
                left: 4px;
                min-width: 17px;
                height: 17px;
                padding: 0 4px 0 3px;
                line-height: 1;
                font-weight: bold;
                border-radius: 50px;
                background-color: #ff0000;
                color: #fff;
                border: 1px solid #395fc5;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: "Open Sans",Arial,sans-serif;

                @media (min-width: 768px) {
                    top: 0;
                    left: 0;
                    position: relative;
                    margin: -9px 0 0 -9px;
                    padding: 0 4px;
                }
            }

            .td-unread-count {
                color: #fff;
                font-weight: 700;
                font-size: 10px;
                position: relative;
                top: -1px;

                @media (min-width: 768px) {
                    top: 0;
                }
            }
            .glyphicon-bell {
                @media (min-width: 768px) {
                    display: flex;
                    margin-bottom: 2px;
                }
            }
        }

        @media (min-width: 768px) and (max-width: 850px) {
            #navbar {
                ul {
                    li {
                        font-size: 11px;
                    }
                }
            }
        }
    }

    .td-navbar-wrap-efactura {
        .navbar-right {
            margin-left: auto;
            .nav-user {
                padding: 0 !important;
            }
        }

    }

    @media (min-width: 767px) {
        .button-logo-dropdown-mobile {
            display: none;
        }

        .logo-swiper-container {
            display: none;
        }

    }


    @media (max-width: 767px) {
        .navbar-fixed-top .td-navbar-wrap {
            display: block;

            .button-logo-dropdown-mobile-arrow {
                position: relative;

                &:after {
                    font-family: "iflow";
                    content: '\E803';
                    font-size: 11px;
                    color: #fff;
                    position: absolute;
                    right: -15px;
                    top: 17px;
                    transition: transform 0.2s ease;
                }
            }

            .is-open .button-logo-dropdown-mobile-arrow {
                position: relative;

                &:after {
                    font-family: "iflow";
                    content: '\E803';
                    font-size: 11px;
                    color: #fff;
                    position: absolute;
                    right: -15px;
                    top: 17px;
                    transform: rotate(90deg);
                    transition: transform 0.2s ease;
                }
            }

            .logo-dropdown-container {
                width: calc(100% + 10px);
                overflow-x: auto;
                white-space: nowrap;
                background-color: #fff;
                box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                position: absolute;
                top: 50px;
                left: -5px;
                z-index: 100;
                scrollbar-width: thin;

                .link-logo-mobil {
                    transition: transform 0.2s ease, stroke-width 0.2s ease;
                    transform-origin: center;
                }

                .logo-swiper-container {
                    padding: 10px 7px;
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    width: fit-content;
                }

                .logo-swiper-container a {
                    display: flex;
                    align-items: center;
                    flex: 0 0 70px;
                }
            }



            .navbar-header .navbar-brand.is-open {
                transform: rotate(180deg);
                transition: transform 0.3s ease;
            }

            .navbar-toggle {
                float: left;
                margin: 9px 10px 9px -5px;
            }

            .navbar-right {
                position: absolute;
                z-index: 0;
                top: 0;
                right: -5px;
                background-color: #395fc5;
                margin: 0;
                pointer-events: none;

                .nav-user {
                    span {
                        display: none;
                    }
                }

                .nav-item li > a {
                    padding: 5px 20px !important;
                }
            }
            .nav-user {
                float: right;
                padding: 12px !important;
                pointer-events: auto;
                margin: 0 !important;
            }
            .td-user-avatar {
                position: relative;
                top: auto;
                left: auto;
            }
            .dropdown-menu {
                pointer-events: auto;
            }

            > .notifications {
                position: absolute;
                top: 2px;
                right: 43px;
                z-index: 1;
                font-size: 15px;

                &:before {
                    display: none;
                }
            }
            > .search {
                position: absolute;
                top: 1px;
                right: 93px;
                z-index: 1;
                font-size: 16px;

                &:before {
                    display: none;
                }

                &:after {
                    content: '';
                    position: absolute;
                    right: -8px;
                    width: 1px;
                    height: 20px;
                    background-color: #fff;
                    opacity: .2;
                }
            }
            > .emag-promotion {
                position: absolute;
                right: 143px;
                top: 2px;
                font-size: 14px;
                z-index: 1;
                &:after {
                    content: '';
                    position: absolute;
                    right: -8px;
                    width: 1px;
                    height: 20px;
                    background-color: #fff;
                    opacity: .2;
                }
            }

            .td-nav-account {

            }
            .td-margin-space {
                height: 10px;
                position: relative;
                overflow: hidden;
                width: 100%;

                &:before {
                    content: '';
                    position: absolute;
                    width: 100%;
                    height: 10px;
                    left: 0;
                    top: 0;
                    box-shadow: 0 1px 8px 0 rgba(0,0,0,.2);
                    margin-top: -10px;
                }
            }
            .td-multi-user-wrap {
                margin-top: -5px;
                padding-top: 5px;

                &.td-multi-user-active,
                &:hover {
                    background-color: #5476d4;
                }

                .td-multi-user-full-name {
                    font-weight: 600;
                    margin-bottom: 4px;
                }
                .td-multi-user-company-name,
                .td-multi-user-email {
                    color: rgba(255, 255, 255, 0.5);
                    font-size: 10px;
                }
                .td-multi-user-delete {
                    color: #fff;
                    top: 5px;
                }
            }
            .navbar-left .dropdown-menu {
                //overflow-x: hidden;
            }
        }
    }

    @media (min-width: 768px) {
        .navbar-fixed-top .td-navbar-wrap .logo-dropdown-container {
            display: none;
        }
    }

    @media (max-width: 767px) {
        .td-navbar-wrap-efactura {
            display: block;


            .button-logo-dropdown-mobile-arrow {
                position: relative;

                &:after {
                    font-family: "iflow";
                    content:'\E803';
                    font-size: 11px;
                    color: #fff;
                    position: absolute;
                    right: -15px;
                    top: 17px;
                    transition: transform 0.2s ease;
                }
            }

            .is-open .button-logo-dropdown-mobile-arrow {
                position: relative;

                &:after {
                    font-family: "iflow";
                    content: '\E803';
                    font-size: 11px;
                    color: #fff;
                    position: absolute;
                    right: -15px;
                    top: 17px;
                    transform: rotate(90deg);
                    transition: transform 0.2s ease;
                }
            }


            .logo-dropdown-container {
                width: calc(100% + 10px);
                overflow-x: auto;
                white-space: nowrap;
                background-color: #fff;
                box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                position: absolute;
                top: 50px;
                left: -5px;
                z-index: 100;
                scrollbar-width: thin;

                .link-logo-mobil {
                    transition: transform 0.2s ease, stroke-width 0.2s ease;
                    transform-origin: center;
                }

                .logo-swiper-container {
                    padding: 10px 7px;
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    width: fit-content;
                }

                .logo-swiper-container a {
                    display: flex;
                    align-items: center;
                    flex: 0 0 70px;
                }
            }

            .navbar-toggle {
                float: left;
                margin: 9px 10px 9px -5px;
            }

            .navbar-right {
                position: absolute;
                top: 0;
                right: -5px;
                background-color: #395fc5;
                margin: 0;
                pointer-events: none;
                z-index: 101;

                //.nav-user {
                //    span {
                //        display: none;
                //    }
                //}

                .nav-item > a {
                    padding: 15px!important;
                }
            }
            .nav-user {
                float: right;
                padding: 12px !important;
                pointer-events: auto;
                margin: 0 !important;
            }
            .td-user-avatar {
                position: relative;
                top: auto;
                left: auto;
            }
            .dropdown-menu {
                pointer-events: auto;
            }

            > .notifications {
                position: absolute;
                top: 2px;
                right: 43px;
                z-index: 1;
                font-size: 15px;

                &:before {
                    display: none;
                }
            }
            > .search {
                position: absolute;
                top: 1px;
                right: 93px;
                z-index: 1;
                font-size: 16px;

                &:before {
                    display: none;
                }

                &:after {
                    content: '';
                    position: absolute;
                    right: -8px;
                    width: 1px;
                    height: 20px;
                    background-color: #fff;
                    opacity: .2;
                }
            }
            > .emag-promotion {
                position: absolute;
                right: 143px;
                top: 2px;
                font-size: 14px;
                z-index: 1;
                &:after {
                    content: '';
                    position: absolute;
                    right: -8px;
                    width: 1px;
                    height: 20px;
                    background-color: #fff;
                    opacity: .2;
                }
            }

            .td-nav-account {

            }
            .td-margin-space {
                height: 10px;
                position: relative;
                overflow: hidden;
                width: 100%;

                &:before {
                    content: '';
                    position: absolute;
                    width: 100%;
                    height: 10px;
                    left: 0;
                    top: 0;
                    box-shadow: 0 1px 8px 0 rgba(0,0,0,.2);
                    margin-top: -10px;
                }
            }
            .td-multi-user-wrap {
                margin-top: -5px;
                padding-top: 5px;

                &.td-multi-user-active,
                &:hover {
                    background-color: #5476d4;
                }

                .td-multi-user-full-name {
                    font-weight: 600;
                    margin-bottom: 4px;
                }
                .td-multi-user-company-name,
                .td-multi-user-email {
                    color: rgba(255, 255, 255, 0.5);
                    font-size: 10px;
                }
                .td-multi-user-delete {
                    color: #fff;
                    top: 5px;
                }
            }
            .navbar-left .dropdown-menu {
                //overflow-x: hidden;
            }
        }
    }

    //blue message
    .td-alert-blue {
        font-size: 13px;
        line-height: 1.2;
        background-color: #F0F8FF;
        padding: 5px 10px;
        margin:10px 0;
        color: #65b7ff;
        border: 1px solid #e7f4ff;
    }

    .td-team-select-container, .td-team-select-wrap {
        .td-team-select {
            font-size: 11px;
            line-height: 1;
            font-weight: 700;
            text-transform: uppercase;
            padding: 8px 11px 9px;
            background-color: #e6ecf2;
            color: #444;
            box-shadow: none;
            border: none;
            transition: all 0.2s ease;

            &.td-is-selected {
                background-color: #f9e4e4;;
            }
        }
    }

    .td-button-small {
        user-select: none;
        transition: all 0.3s ease;
        opacity: 1;
        background-color: #f0f8ff;
        padding: 6px 12px;
        border-radius: 4px;
        color: #395fc5;
        font-weight: 600;
        line-height: 1;
        display: inline-block;

        &:hover {
            color: #fff;
            background-color: #395fc5;
            opacity: 1;
        }
    }

    //-------------------------------------------------
    //-------------------------------------------------
    //-------------------------------------------------
    //-------------------------------------------------
    //-------------------------------------------------
    // grid reports content
    .td-reports-content {
        @media (max-width: 768px) {
            .td-sticky-right {
                position: relative !important;
            }
            .td-table-details-edit {
                opacity: 1 !important;
            }
        }


        //modal fix on sticky report company name
        .modal-mask {
            @media (min-width: 980px) {
                left: 50%;
                transform: translateX(-50%);
            }
        }
        padding: 20px 20px 20px;
        background-color: #eff2f7;
        display: table;
        margin: 0 auto;
        width: max-content;

        // sidebar links
        .td-sidebar-link {
            color: #444;
            padding: 5px 0;
            font-weight: 600;
            display: block;
            position: relative;

            &:hover,
            &:focus,
            &.active {
                color: #395fc5;
                opacity: 1;
            }
            &.active {
                &:before {
                    content: '';
                    background-color: #395fc5;
                    width: 4px;
                    height: 100%;
                    position: absolute;
                    left: -15px;
                    top: 0;
                }
            }
        }
        .td-sidebar-box {
            padding: 12px 15px;
            margin-bottom: 20px;
        }
        .td-content-box {
            margin-bottom: 20px;
        }

        // row grid
        .td-row-container {
            width: 100%;
            min-width: 1140px;
            display: flex;
            gap: 20px;
            align-items: flex-start;

            // missing text when no results
            .td-missing-text {
                text-align: center;
                font-weight: 700;
                padding: 20px 40px 0;
            }

            // date picker
            .td-date-interval-select {
                float: none;

                .td-period-text {
                    display: none !important;
                }

                label {
                    display: flex;
                    flex-direction: row-reverse;
                    align-items: center;
                    cursor: pointer;

                    &:hover .td-period-glyph {
                        background-color: #395fc5;
                        color: #fff;
                    }
                }

                input {
                    top: 0;
                    height: 100%;
                    right: 0;
                }

                .btn {
                    padding: 0;
                    cursor: pointer;
                    margin: 0;
                    color: #444;
                    font-size: 12px;
                    font-weight: 600;
                    background-color: transparent;
                    box-shadow: none;
                    display: block;
                }

                .td-period-glyph {
                    display: inline-block;
                    top: 0;
                    margin: 0 5px 0 0;
                    transition: all 0.2s ease;
                    padding: 6px;
                    background-color: #f0f8ff;
                    color: #395fc5;
                    border-radius: 4px;
                    font-size: 11px;
                }
            }
        }

        // column grid
        .td-sidebar {
            width: 260px !important;
            flex: 0 0 260px;

            hr {
                margin: 10px 0;
            }

            .td-sidebar-box:last-child {
                margin-bottom: 0;
            }
        }

        // column grid
        .td-content {
            flex: 1 0 auto;
            width: auto !important;
        }

        .td-column-flex {
            flex: 1 0 auto;
        }

        .td-report-title-wrap {
            text-align: center;
            -webkit-user-select: none;
            user-select: none;
            padding: 15px 0;

            h1 {
                font-size: 18px;
                margin-bottom: 30px;
            }
            @media print {
                flex: auto !important;
            }
        }

        h1.td-report-title-no-margin {
            margin-top: 0;
            margin-bottom: 0;
        }

        // report header
        .td-reports-team-filter, .td-reports-location-filter, .td-reports-project-filter, .td-reports-users-filter { // filter button
            font-weight: 700;
            margin-left: 10px;
            background-color: #fff;
            padding: 2px 9px;
            font-size: 11px;
            border-radius: 4px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, .08);
            display: inline-block;

            &:hover {
                color: #fff;
                background-color: #395fc5;
                opacity: 1;
            }
            @media print {
                display: none;
            }
        }
        .td-company-name {
            @media screen {
                display: none;
            }
            text-transform: capitalize;
            font-weight: 700;
        }
        .td-company-billing-cui {
            @media screen {
                display: none;
            }
            margin-bottom: 10px;
        }
        .td-company-legend {
            text-align: right;
            @media print {
                max-width: 400px !important;
            }
        }

        // column design background and shadow
        .td-panel {
            background-color: #fff;
            border-radius: 4px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        }

        // content head
        .td-content-head {
            display: flex;
            padding: 13px 20px;
            justify-content: space-between;
            align-items: center;
            border-bottom: 2px solid rgba(186, 204, 222, 0.38);
            background-color: #fff;
        }
        .td-table-buttons {
            margin-left: auto;
            // sticky right
            background-color: #fff;
            position: sticky;
            right: 20px;

            .fa-hourglass {
                padding-left: 7px;
            }

            .fa-circle-o-notch {
                background-color: transparent !important;
                color: #395fc5 !important;
                transition: none !important;

                &:hover {
                    background-color: transparent !important;
                    color: #395fc5 !important;
                    transition: none !important;
                }
            }

            a {
                cursor: pointer;
                margin-left: 15px;
                color: #444;
                font-size: 12px;
                font-weight: 600;

                &:focus {
                    opacity: 1;
                }
                &:hover, &:active {
                    opacity: 1;

                    i {
                        background-color: #395fc5;
                        color: #fff;
                    }
                }
            }
            i {
                transition: all 0.2s ease;
                padding: 6px;
                background-color: #f0f8ff;
                color: #395fc5;
                border-radius: 4px;
                margin-right: 5px;
                width: 24px;
                height: 24px;
            }
        }

        // table body
        .td-table-body,
        .td-table-bodyx {

            .td-saturday,
            .td-sunday {
                background-color: #f0f8ff;
            }
            .td-table-free-day {
                background-color: #ffefeb;
            }

            .td-day-data-wrapper {
                height: 100%;
                font-size: 11px;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                color:#444;
                white-space: nowrap;

                &:hover {
                    background-color: rgba(93, 190, 255, 0.1) !important;
                    color: #000;
                }
            }

            .td-week-day-name {
                font-size: 10px;
                font-weight: 600;
                margin-top: 3px;
            }

            border-collapse: collapse;
            flex: 0 0 auto;
            font-size: 13px;
            width:100%;

            tbody{
                background-color: #fff;
            }

            td {
                background-color: #fff;
                border: 1px solid #ededed;
                padding: 4px 6px;
                position: relative;
                max-width: 500px;
                word-break: break-word;

                ul {
                    margin-bottom: 0;
                    padding-left: 0;
                    list-style-type: none;
                }
            }

            // align center
            .td-center {
                text-align: center;
                .td-tb {
                    justify-content: center;
                }
            }
            // align right
            .td-right {
                text-align: right;
            }

            .td-v-text {
                -webkit-writing-mode: vertical-rl;
                -ms-writing-mode: tb-rl;
                writing-mode: vertical-rl;
                text-orientation: sideways;
                text-align: center;
            }

            // header table
            th {
                max-width: 500px;
                height: 60px;
                background-color: #f0f8ff;
                position: relative;
                border-left: 1px solid #e5ecf2;
                user-select: none;
                line-height: 1;

                .glyphicon {
                    font-size: 8px;
                    background-color: #fff;
                    padding: 4px;
                    margin-right: 6px;
                    box-shadow: 0 0 1px 1px rgba(0, 0, 0, .06);
                    color: #000;
                    border-radius: 4px;
                    top: 0;
                    margin-top: -2px;
                    height: 16px;
                }
            }
            .td-cp {
                cursor: pointer;
            }
            .td-tb {
                height: 100%;
                display: flex;
                align-items: center;
                padding: 4px 6px;
            }

            .td-resize {
                resize: horizontal;
                overflow: hidden;
                min-width: 100px;
            }

            // days columns
            .td-nr {
                position: relative;
                width: 24px;
                letter-spacing: -0.5px;

                // minutes
                span {
                    font-size: 9px;
                    margin-top: 1px;
                    margin-left: 1px;
                    vertical-align: top;
                    position: relative;
                    top: -3px;
                }

                > div {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    white-space: nowrap;
                }
            }

            .td-nr-big {
                width: 40px;
                height: 47px;
                padding: 2px;
            }

            .td-nr-square {
                width: 24px;
                height: 24px;
                padding: 2px;
                p {
                    margin: 0;
                }
            }

            thead {
                .td-hp {
                    padding: 4px 6px;
                }
            }
        }

        .td-table-body {
            tr {
                &:hover td {
                    background-color: #f0f8ff;
                }
            }
        }

        .td-report-title-wrap {
            flex-direction: column;
            .td-column-flex {
                position: sticky;
                left: 50%;
                transform: translateX(-50%);
                margin-right:-100%;
            }
            @media print {
                .td-column-flex {
                    position: relative;
                }
            }
        }

        .td-events-warnings {
            transition: all 0.3s ease;
            position: sticky;
            left: 50%;
            transform: translateX(-50%);
            margin: 10px -100% 15px 0;
            @media (max-width: 787px) {
                width: 310px;
            }
        }

        .td-report-company-wrap {
            .td-column-flex {
                flex: 0 0 33.33%;
            }
            z-index: 5;
            margin-bottom: 5px;
            gap: 0;

            @media screen and (min-width: 1230px) {
                max-width: calc(100vw - 40px);
                left: 20px;
                right: 20px;
                position: sticky;
                min-width: auto;
            }
            @media screen and (min-width:980px) and (max-width:1229px) {
                max-width: calc(100vw - 40px);
                left: 20px;
                right: 20px;
                position: sticky;
                min-width: auto;
            }
            .modal-mask {

                .modal-mask {
                    margin-top: 0;
                }
            }
        }

        .td-company-info {
            @media print {
                max-width: 400px !important;
            }

            .td-department-line {
                height: 7px;
                width: 11px;
                border: 1px solid #868686;
                display: inline-block;
                border-top: none;
                border-right: none;
                position: absolute;
                top: calc(100% + 4px);
                left: 7px;
            }

            .td-display-filtered-team {
                font-size: 12px;

                &.td-is-department {
                    position: relative;
                    background-color: #fff;
                    width: fit-content;
                    border-radius: 3px;
                    padding: 2px 5px 0;
                    margin-bottom: 2px;
                    font-weight: bold;
                }
            }

            .td-company-department-title {
                font-weight: bold;
                flex: 0 0 60px;
            }
            .td-dep-title-projects {
                @media print {
                    flex: 0 0 60px;
                }
            }
        }

        @media screen {
            .td-company-legend {
                max-height: 290px;
                overflow-y: auto;
                overflow-x: hidden;

                .td-table-notes {
                    margin-right: 2px;
                }
            }

            .td-company-legend::-webkit-scrollbar-track {
                -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.15);
                background-color: #dfdfdf;
            }

            .td-company-legend::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }

            .td-company-legend::-webkit-scrollbar-thumb {
                background-color: #999999;
                opacity: 1;
            }


            .td-company-info {
                .td-company-department {
                    display: flex;
                    flex-direction: column;
                    gap: 5px;
                    width: fit-content;
                    .td-company-department-dropdown {
                        max-height: 200px;
                        overflow-y: auto;
                        flex: 1 1 auto;
                        word-break: break-word;
                        padding-right: 3px;
                        min-width: 120px;
                    }
                    .td-company-department-dropdown::-webkit-scrollbar-track {
                        -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.15);
                        background-color: #dfdfdf;
                    }

                    .td-company-department-dropdown::-webkit-scrollbar {
                        width: 10px;
                        height: 10px;
                    }

                    .td-company-department-dropdown::-webkit-scrollbar-thumb {
                        background-color: #999999;
                        opacity: 1;
                    }
                }
            }
        }

        .td-report-filter-wrap {
            display: flex;
            align-items: flex-start;
            font-size: 12px;
        }

    }
    .td-report-location-modal,
    .td-trigger-location-modal,
    .td-report-team-modal,
    .td-report-project-modal,
    .td-team-modal,
    .td-report-users-modal {
        .td-search-input-filter {
            margin: 0 auto 20px !important;
            cursor: text;
        }
    }

    // employee with image
    .td-employee {
        color: #444;
        word-break: initial;
        display: flex;
        align-items: center;

        &:hover,
        &:active,
        &:focus {
            color: #395fc5;
            opacity: 1;

            img {
                border: 2px solid #89a7d6;
            }
        }

        img {
            width: 25px;
            height: 25px;
            margin-right: 5px;
            border-radius: 100px;
            border: 2px solid #aac1ff;
        }
    }

    // report missing  img + text
    .td-report-missing {
        text-align: center;
        font-weight: 700;
        padding: 20px 40px 0;
        max-width: 100%;
    }

    .td-month-back,
    .td-month-forward {
        font-size: 9px;
        padding: 10px;
        cursor: pointer;
        position: relative;
        top: -1px;
        border-radius: 100px;
        background-color: #fff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        transition: all 0.2s ease;

        &:hover,
        &:active,
        &:focus {
            box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.12);
            color: #395fc5;
        }
    }
    .td-month-date {
        display: inline-block;
        width: 150px;
        font-weight: 700;
    }

    // reset filters button x
    .td-filter-reset {
        padding: 6px;
        background-color: #f0f8ff;
        color: #395fc5;
        width: 25px;
        border-radius: 4px;
        margin-left: 5px;
        transition: all 0.3s ease;
        cursor: pointer;

        &[disabled="disabled"] {
            padding: 6px 0;
            margin-left: 0;
            width: 0;
            overflow: hidden;
        }

        &:before {
            width: 13px;
            display: block;
        }
        &:hover {
            opacity: 1;
            color: #ff0000;
            background-color: #ffebeb;
        }
    }

    // fields selected text
    .td-fields-selected,
    .td-date-interval {
        font-weight: 700;
        font-size: 12px;
        margin-right: 25px;
        display: flex;
        align-items: center;
    }

    // filters general style
    .td-filters {
        display: flex;
        flex-wrap: wrap;
        column-gap: 15px;

        // filter wrap
        .td-filter {
            margin-bottom: 15px;
            flex: 1 0 100%;
            font-size: 12px;

            &.td-height-increase {
                .td-list-wrap {
                    height: 200px;
                    min-height: unset;
                    max-height: unset;
                }
            }

            &:last-child {
                margin-bottom: 0;
            }

            > label {
                line-height: 1;
                //font-size: 11px;
            }
            &.td-filter-title-out {
                margin-bottom: 5px;
                line-height: 1;
            }

            .td-filter-btn {
                user-select: none;
                transition: background-color 0.3s ease, color 0.3s ease;
                opacity: 1;
                background-color: #f0f8ff;
                padding: 6px 12px;
                border-radius: 4px;
                color: #395fc5;
                font-weight: 600;
                line-height: 1;
                display: inline-block;

                &:hover {
                    color: #fff;
                    background-color: #395fc5;
                }
            }

            .td-filter-btn-reset {
                &[disabled="disabled"] {
                    display: none;
                }
                &:hover {
                    color: #ff0000;
                    background-color: #ffebeb;
                }
            }

            .fa-calendar {
                position: absolute;
                top: -15px !important;
                right: -27px !important;
            }
        }
        .td-filter-half {
            flex: 1 0 calc(50% - 15px);
        }

        // general style
        select,
        input {
            font-weight: 500;
            border: 1px solid #e4e4e4;
            border-radius: 4px;
            color: #333;
        }
        input[type=checkbox] {
            margin: 0 5px 1px 0;

            & + label {
                margin: 0;
                font-weight: 500;
                color: #333;
                cursor: pointer;
                word-break: break-word;
            }
        }

        // filter - dropdown
        .td-filter-dropdown {
            display: flex;
            align-items: center;

            select {
                padding: 0 2px;
                height: 25px;
                width: 100%;

                &:focus {
                    outline: none;
                    border-color: #395fc5;
                }

                option {
                    padding: 0;
                }
            }
        }

        //filter - input - search
        .td-filter-search {
            input {
                border-radius: 0;
                border: none;
                border-bottom: 1px solid #e4e4e4;
            }
        }

        //filter - input
        .td-filter-input {
            display: flex;
            align-items: center;

            input {
                padding: 0 6px;
                height: 25px;
                width: 100%;

                &:focus {
                    outline: none;
                    border-color: #395fc5;
                }
                &::placeholder {
                    color: #333;
                }
            }
        }
        #td-filter-search {
            margin: 2px 0 8px;
        }

        //filter - checkbox list
        .td-filter-checkbox-list {
            ul {
                overflow: auto;
                max-height: 140px;
                list-style-type: none;
                padding: 0 10px 0 0;
                margin: 0;

                //scrollbar style
                &::-webkit-scrollbar-track {
                    -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.15);
                    background-color: #dfdfdf;
                }

                &::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }

                &::-webkit-scrollbar-thumb {
                    background-color: #999;
                    opacity: 1;
                }
            }
            li {
                display: flex;
                align-items: center;
                min-height: 23px;
                flex-wrap: nowrap;
            }
            .td-filter-select-all {
                display: flex;
                justify-content: space-between;
                margin-top: 10px;

                input {
                    display: none;
                }
            }
        }

        //checkbox align with text
        .td-filter-checkbox {
            display: flex;
            align-items: center;
            min-height: 23px;
        }

        .td-filter-btn-reset-wrap{
            display: flex;
            justify-content: center;
            padding-top: 20px;

        }
    }

    tr {
        .td-table-details-edit {
            opacity: 0;
            font-size: 12px;

            .fa {
                transition: all 0.2s ease;
                padding: 6px;
                background-color: #fff;
                color: #395fc5;
                border-radius: 4px;
                width: 24px;
                height: 24px;


                &:hover,
                &:focus,
                &:active {
                    background-color: #395fc5;
                    color: #fff;
                    opacity: 1;
                }
            }
            & .fa-times:hover {
                color: #ff0000;
                background-color: #ffebeb;
            }

        } &:hover {
            .td-table-details-edit {
                opacity: 1;
            }
        }
    }

    // sticky
    .td-sticky,
    .td-sticky2 {
        position: sticky;
        z-index: 4;
    }
    .td-sticky {
        top: 50px;
    }
    .td-sticky2 {
        top: 102px; // 50px menu + 52px sticky
    }
    #app .td-sticky-right {
        position: sticky;
        right: 0;
    }

    #app .td-banner-fix { margin-top: 50px; } // 50px menu

    #app.td-top-banner-36 {
        .td-sticky { top: 86px; } // 50px menu + 36px banner
        .td-sticky2 { top: 138px; } // 50px menu + 36px banner + 52px sticky
        .td-banner-fix { margin-top: 86px; } // 50px menu + 36px banner

        .td-user-document .ql-toolbar.ql-snow {
            top: 86px;
        }
    }
    #app.td-top-banner-72 {
        .td-sticky { top: 122px; } // 50px menu + 72px banners
        .td-sticky2 { top: 174px; } // 50px menu + 72px banners + 52px sticky
        .td-banner-fix { margin-top: 122px; } // 50px menu + 72px banners

        .td-user-document .ql-toolbar.ql-snow {
            top: 122px;
        }
    }
    .td-date-interval-print {
        display: none;

        @media print {
            display: block;
        }
    }

    // fix firefox borders and reports css
    @-moz-document url-prefix() {

        .td-sliders_control {
            padding: 1px 0 !important;
        }


        //force all firefox scrollbar widths
        * {
            scrollbar-width: thin;
        }

        .td-index-importer {
            .td-step-4 {

                .td-step-header {
                    display: block !important;
                    h2 {
                        position: unset !important;
                        margin: unset !important;
                        transform: none !important;
                        left: unset !important;
                    }
                }
                .td-container-for-sticky {
                    .td-valid-result-wrap, .td-error-result-wrap {
                        position: relative !important;
                        left: unset !important;
                        margin: 0 auto 10px !important;
                        transform: none !important;
                    }
                }
            }
        }

        @media (max-width: 600px) {
            .td-router-view .td-clocking .td-content-head .td-table-buttons {
                left: 0;
                right: 0;
                position: relative;
                transform: none;
                margin: 0;
            }
        }
        .td-router-view .td-report-project-modal .modal-container {
            margin-top: initial;
        }
        .td-router-view .td-content-head {
            > span {
                margin-right: auto;
            }
            > .td-teams-path {
                margin-right: auto;
            }
            > .td-projects-header-title {
                margin-right: auto;
            }
            .td-date-interval {
                margin-right: auto;
            }
        }
        .td-router-view .td-reports-content .td-report-title-wrap {
            flex-direction: initial;
            .td-column-flex {
                position: relative;
                left: 0;
                margin: initial;
                transform: none;
            }
        }

        .td-router-view .td-reports-content .td-events-warnings {
            position: relative;
            left: 0;
            margin: 15px auto;
            transform: none;
            transition: none;
        }
        .td-table-body,
        .td-table-bodyx {
            td, th {
                background-clip: padding-box;
            }
        }
        .td-reports-content {
            .td-attendance, .td-attendance-detailed {
                .td-attendance-report-table {
                    tr {
                        height: 47px;
                        td {
                            height: 100%;
                        }
                    }
                }
            }
        }



        .td-router-view .td-index-importer {
            .td-sticky .td-progress-bar-sticky-center {
                left: unset;
                transform: unset;
                margin-right: auto;
                margin-left: auto;
            }
        }
    }

    // print + generated with iflow
    @media print {
        .td-router-view {
            margin-top: 0 !important;
        }
        .td-banner-fix {
            margin-top: 0 !important;
            padding-top: 20px !important;
        }
        .td-pagination {
            display: none !important;
        }

        .td-reports-content {
            .td-sticky-right {
                display: none;
            }
            .td-table-body,
            .td-table-bodyx {
                tr th:nth-last-child(2) {
                    border-right: 1px solid #000;
                }
            }
            .td-sticky2 {
                //fix for sticky table header to prevent print issues
                position: relative;
                top: 0 !important;
            }
            .td-row-container {
                min-width: auto;

                &:after {
                    content: 'Generat cu iFlow.ro';
                    background-color: #fff !important;
                    color: #395fc5 !important;
                    display: block;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    -webkit-transform: rotate(-90deg);
                    transform: rotate(-90deg);
                    -webkit-transform-origin: 0 0;
                    transform-origin: 0 0;
                }
            }
            td, th {
                border-color: #000 !important;
            }
            th {
                border-top: 1px solid;
            }
            // fix borders
            .td-content-body {
                border-top: 1px solid #e5ecf2;
            }
            .td-table-body,
            .td-table-bodyx {
                tr th:last-child {
                    border-right: 1px solid #e5ecf2;
                }
                th .glyphicon {
                    display: none;
                }
                .td-resize {
                    resize: none;
                    min-width: auto;
                }
                th, td {
                    padding: 4px 6px;
                }
            }
            .td-sidebar,
            .td-content-head,
            .td-month-back,
            .td-month-forward,
            .td-reports-team-filter,
            .td-employee img,
            .td-hp,
            input[type=checkbox] {
                display: none;
            }
        }
        .td-is-en-us .td-reports-content .td-row-container:after { content: 'Generated with iFlow.ro'; }
    }


    //evenimente care cer aprobare, evenimente care cer editare
    .td-events-warnings {
        padding: 12px;
        background-color: #f77764;
        color: #ffffff;
        text-align: center;
        line-height: 20px;
        max-width: 570px;
        width: fit-content;
        margin: 15px auto;
        border-radius: 6px;
        @media print {
            display: none;
        }
    }

    .td-events-waiting-click {
        background-color: #fff;
        color: #f77764;
        padding: 3px 7px;
        font-size: 10px;
        line-height: 1;
        font-weight: 700;
        text-transform: uppercase;
        border-radius: 2px;
        display: inline-block;
        margin: 0 5px;
    }
    //table edit disable without permissions
    .td-cannot-edit {
        .td-table-details-edit a{
            color: #adadad;
            pointer-events: none;
        }
    }

    .td-report-users-modal, .td-report-team-modal, .td-report-location-modal, .td-trigger-location-modal, .td-team-modal {

        .td-modal-tle-filter-tle-list {
            word-break: break-word;
            padding: 15px 30px;

            input {
                margin: 0 5px 0 0;
                position: relative;
                top: 2px;
            }
            label {
                font-weight: normal;
                position: relative;
                margin-bottom: 2px;
            }

            .td-is-department {
                position: relative;
                left: -3px;
                background-color: #f2f2f2;
                width: fit-content;
                border-radius: 3px;
                padding: 1px 7px 1px 3px;
                margin-bottom: 2px;
                label {
                    font-weight: bold;
                    margin-bottom: 0;
                }

                &.td-is-empty-department {
                    opacity: 0.6;
                    pointer-events: none;
                    user-select: none;
                }
            }
            .td-department-line {
                width: 8px;
                left: 9px;
            }
        }

        .td-tle-filter-options {
            display: flex;
            align-items: center;
            padding: 15px 27px;
            background-color: #F9F9F9;

            .td-search-input-filter {
                margin: 0 auto 0 0 !important;
                font-size: 12px;
                border-radius: 6px;
                padding: 9px 12px;
                line-height: 1;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                border: 1px solid #E9E9E9;
                box-shadow: 0 0 8px #0000000A;
                flex: 1 1 auto;
                max-width: 265px;
                transition: border .2s ease;
                &:focus {
                    border: 1px solid #395fc5;
                }
            }
        }

        .td-users-select-all, .td-teams-select-all, .td-locations-select-all {
            user-select: none;
            flex: 0 0 120px;

            label {
                font-weight: 600;
                display: flex;
                align-items: center;
                position: relative;
                margin: 0;
                top: 1px;
            }

            svg {
                fill: #fff;
                margin-right: 5px;
            }

            input {
                display: none;
            }

            &:hover {
                label {
                    color: #395fc5;
                }
            }

            input:checked + label>svg {
                circle {
                    fill: #395fc5;
                }
            }
        }

        .td-tle-filter-list-wrap {
            overflow-y: auto;

            &::-webkit-scrollbar-track {
                -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.15);
                background-color: #dfdfdf;
            }

            &::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #999;
                opacity: 1;
            }
            .td-add-new-team-link {
                left: 30px;
                position: relative;
                bottom: 10px;
                svg {
                    position: relative;
                    top: 1px;
                    margin-right: 7px;
                }
            }
        }


        .modal-close {
            z-index: 2;
        }

        .modal-header {
            z-index: 1;
        }

        .modal-body {
            padding: 0 !important;
            margin: 0 -15px;
            background-color: #fff;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            font-size: 12px;
        }

        input, label {
            cursor: pointer;
        }
        .td-filter-list-alert {
            margin: 15px 15px 0;
        }

    }

    .td-is-iphone {
        #app {
           .td-select-single {
               .td-select-list {
                   padding: 55px 20px 0;
                   width: 100%;
               }
               .td-select-list-header {
                   width: 90%;
                   border-bottom: none;
                   .td-icon-list-close {
                       top: 62px;
                       right: 20px;
                   }
               }
               .td-elements-list {
                   padding-bottom: 250px;
               }
           }
        }
    }

    .td-is-android {
        .td-team-options {
            .td-teams-edit-button, .td-icon-close {
                opacity: 1 !important;
            }
        }
        .td-attachments-and-connections {
            .td-file-row-wrap {
                .td-download-icon-close, .td-file-icon-close {
                    opacity: 1 !important;
                }
            }
        }
        .td-team-info-report {
            .td-report-body-wrap .td-attendance-report-table {
                tbody tr td {
                    user-select: none;
                }
            }
        }
        .td-document-icon-and-text {
            .td-data-options {
                opacity: 1 !important;
            }
        }
    }

    .td-is-electron {
        #ui-datepicker-div {
            transform:scale(1.3);
        }

        .ui-timepicker-wrapper {
            width: 17.2em;
            .ui-timepicker-list {
                li {
                    font-size: 20px;
                    padding: 5px;
                }
            }
        }
    }
    .password-reset-form-wrap {
        position: relative;
    }
    .td-show-password-wrap {
        position: absolute;
        right: 5px;
        top: 50%;
        cursor: pointer;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        transition: all 0.2s ease-in-out;

        .fa-eye, .fa-eye-slash {
            padding: 5px;
            color: #000;
            font-size: 14px;
        }
    }
    .td-password-input {
        padding: 5px 35px 5px 15px;
    }

    .td-hide-reason-on-rfid {
        display: none;
    }

    .td-login-rfid {
        background-image: url("./assets/bg2.jpg");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        height: 100vh;

        .td-app-footer-wrap, .navbar, .td-contact-us-corner {
            display: none;
        }

        .td-banner {
            width: fit-content;
            top: 70% !important;
            left: 50%;
            transform: translate(-50%, -30%) scale(1.3);
            border-radius: 10px;
            .td-banner-wrap {
                width: auto;
                padding: 0;
                margin: 0;
                .td-banner-close {
                    right: 0;
                    top: -10px;
                    .td-icon-close {
                        width: 38px;
                        height: 38px;
                        border-radius: 4px 10px 10px 4px;
                        &:before {
                            position: relative;
                            top: 9px;
                            font-size: 20px;
                        }
                    }
                }
            }
        }
        .td-companies-messages-banner {
            display: none;
        }
    }

    .td-list-shortener {
        overflow: auto;
        max-height: 400px;

        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.15);
            background-color: #dfdfdf;
        }

        &::-webkit-scrollbar {
            width: 6px;
            height: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #999;
            opacity: 1;
        }
    }

    //documents templates-series-folders general style
    .td-document-templates-settings, .td-document-series, .td-document-folders {
        .panel-body {
            padding: 0;
        }
        //msf-models-series-folders
        .td-add-document-msf-button-wrap {
            padding: 16px 20px;
            background-color: #fbfbfb;
            border-bottom: 3px solid #fff;
            button {
                font-size: 12px;
                padding: 13px 20px;
            }
        }

        .td-country-templates {
            margin-bottom: 20px;
            .td-table {
                width: 100%;
            }
            thead tr {
                background-color: #fbfbfb;
                th {
                    vertical-align: middle;
                    font-size: 12px;
                    font-weight: 600;
                    position: relative;
                    padding: 6px;
                    border-top: 3px solid #fff;
                    &:first-of-type {
                        padding-left: 20px;
                    }
                    &:last-of-type {
                        padding-right: 20px;
                    }
                }
            }

            tbody {
                tr:hover {
                    background-color: #f9f9f9;
                }
                tr {
                    td {
                        border-bottom: 1px solid #F3F3F3;
                        &:first-of-type {
                            padding-left: 20px;
                        }

                        &:last-of-type {
                            padding-right: 20px;
                        }
                    }
                }
            }
            .td-table-header-permissions {
                border-bottom: none;
            }
        }

        .td-center {
            text-align: center;
        }

        .td-table {
            border-collapse: separate;

            .td-table-data {
                position: relative;
                padding: 6px;
                word-break: break-word;
            }


            .td-document-templates-edit-delete {
                white-space: nowrap;
                .fa {
                    transition: all 0.2s ease;
                    padding: 6px;
                    background-color: #fff;
                    color: #395fc5;
                    border-radius: 4px;
                    width: 24px;
                    height: 24px;
                }
                .fa-times, .fa-minus-circle {
                    cursor: pointer;
                    &:hover {
                        color: #ff0000;
                        background-color: #ffebeb;
                        opacity: 1;
                    }
                }
                .fa-pencil {
                    cursor: pointer;
                    color: #395fc5;
                    &:hover {
                        background-color: #395fc5;
                        color: #fff;
                        opacity: 1;
                    }
                }
                .fa-check {
                    cursor: pointer;
                    &:hover {
                        background-color: #cdffde;
                        color: #3ec76d;
                        opacity: 1;
                    }
                }
            }

            .td-default {
                .td-document-templates-edit-delete .fa,
                {
                    color: lightgray;
                    cursor: not-allowed;
                    &:hover {
                        color: lightgray;
                        background-color: #fff;
                    }
                }
            }
            .td-disabled.fa  {
                color: lightgray;
                cursor: not-allowed;
                &:hover {
                    color: lightgray;
                    background-color: #fff;
                }
            }
        }
    }

    //document series edit and add style
    .td-add-document-template, .td-edit-document-template {
        padding-top: 80px;

        .td-add-document-template-header-wrap {
            display: flex;
            gap: 10px;
            margin-bottom: 10px;
            .td-series-series, .td-folder {
                flex: 0 0 auto;
            }
            @media (max-width: 715px) {
                flex-wrap: wrap;
            }
        }

        .td-back-to-document-models {
            display: inline-flex;
            height: 35px;
            width: 35px;
            flex: 0 0 35px;
            justify-content: center;
            align-items: center;
            background-color: #F1F4F8;
            border-radius: 100%;
            opacity: 1;
            align-self: center;
            transition: all .2s ease;
            &:hover {
                background-color: #395FC5;
                svg path {
                    stroke: #fff;
                }
            }
        }

        .td-template-name-wrap {
            display: flex;
            flex-direction: column;
            margin-left: 10px;
            flex: 1 1 auto;
            min-width: 135px;
            label {
                margin-bottom: 0;
                color: #444444;
                font-weight: normal;
                font-size: 11px;
            }
            input {
                color: #444444;
                border-top: none;
                border-left: none;
                border-right: none;
                border-radius: 0;
                font-size: 17px;
                font-weight: 700;
                text-overflow: ellipsis;
                padding-left: 0;
            }
        }


        .td-warning {
            color: red;
            word-break: break-word;
            max-width: 150px;
        }

        .td-superadmin-header {
            text-align: center;
        }

        .td-superadmin-header h1 {
            font-size: 24px;
            font-weight: 700;
            margin-top: 13px;
            margin-bottom: 20px;
            text-transform: uppercase;
        }

        textarea {
            width: 100% !important;
            height: 120px;
            border: 1px solid #e4e4e4;
            padding: 5px 10px;

            &:focus {
                border: 1px solid #bbb;
                outline: 0;
            }
        }

        .td-input-required {
            margin-left: 4px;
        }

        .td-text-editor {

        }
        #toolbar {
            position: sticky;
            top: 50px;
            z-index: 1;
        }
        .ql-toolbar.ql-snow {
            border: 1px solid #e4e4e4;
            position: sticky;
            top: 50px;
            z-index: 1;
            background-color: #F9F9F9 !important;
            border-left: none;
            border-right: none;
            margin: 0 -30px;
            text-align: center;
            @media (max-width: 767px) {
                margin: 0 -20px;
            }
        }

        .td-add-button {
            display: none;
            height: 37px;
            @media (max-width: 991px) {
                font-size: 11px;
                padding: 10px;
            }
            &.td-feature-unlocked {
                display: block !important;
            }
        }

        .td-save-button{
            height: 37px;
            background-color: #3ec76d;
            box-shadow: 0 2px 4px #3ec76d66;
            &:hover {
                background-color: #33c06a;
                box-shadow: none;
            }
            @media (max-width: 991px) {
                font-size: 11px;
                padding: 10px;
            }
        }

        .form-control {
            height: 37px;
            padding: 5px 10px;
            font-size: 13px;
            line-height: 1;
            color: #444;
            border: 1px solid #E5E5E5;
            border-radius: 3px;
            box-shadow: none;
            &:focus {
                border: 1px solid #bbb;
            }
        }

        .panel-body {
            padding: 15px;
        }

        .ql-editor {
            padding-top: 0.5in;
            margin: 0 0.5in 0.5in 0.5in;
        }

        .ql-editor ol li:not(.ql-direction-rtl), .ql-editor ul li:not(.ql-direction-rtl) {
            padding-left: 0;
        }

        .ql-editor ol, .ql-editor ul {
            padding-left: 0;
        }

        .ql-container.ql-snow {
            margin: auto;
            max-width: 8in;
            width: 100%;
            border: none;
        }
        .ql-editor {
            overflow-y: unset;
            .ql-page-break {
                @media (min-width: 1230px) {
                    width: calc(100% + 528px) !important;
                    left: 50% !important;
                    transform: translateX(-50%);
                }
                @media (max-width: 991px) {
                    width: calc(100% + 186px) !important;
                    left: 50% !important;
                    transform: translateX(-50%);
                }
                @media (max-width: 767px) {
                    width: calc(100% + 166px) !important;
                    left: 50% !important;
                    transform: translateX(-50%);
                }
            }
        }
    }

    .td-calculator-column {
        cursor: text;
        input {
            width: 100%;
            border: none;
            padding: 0 2px;
            text-align: center;
        }
    }

    .td-google-authenticator-code {
        padding-top: 0;
        padding-bottom: 25px;
        display: flex;
        flex-direction: column;
        align-items: center;

        button {
            display: inline-block;
            margin-top: 10px;
            width: fit-content;
            &[disabled] {
                pointer-events: none;
            }
        }
        > input {
            max-width: 250px;
        }
        .authenticator-error-msg {
            margin-top: 3px;
        }
    }

    .td-navbar-link {
        &.td-efactura-connection-status {
            position: relative;
            a {
                padding-left: 24px !important;
            }
        }
    }

    .td-efactura-modal-wrap {
        .td-team-modal {
            .modal-body {
                margin: 0 !important;
            }
        }
        .modal-wrapper .modal-container {
            padding: 0;
            .td-icon-modal-close {
                position: absolute;
                font-size: 12px;
                top: 16px;
                right: 25px;
            }
            .modal-header, .modal-footer {
                margin: 0;
            }
            .modal-body {
                padding: 15px;
            }
            @media (max-width: 768px) {
                width: 95% !important;
                .td-icon-modal-close {
                    right: 15px;
                    top: 13px;
                }
            }
        }
        &.td-add-edit-company-efactura, &.td-add-edit-client-efactura {
            .modal-wrapper .modal-container {
                width: 700px;
                .td-icon-modal-close {
                    position: absolute;
                    font-size: 12px;
                    top: 16px;
                    right: 25px;
                }
            }
            .row {
                margin: 0;
                padding: 0;
                &.td-cui-row  {
                    margin: -15px -15px 0;
                    background-color: #F9F9F9;
                    padding: 15px 15px 0;
                }
            }
        }
        &.td-add-edit-user-efactura {
            .row {
                margin: 0;
                padding: 0;
            }
        }
    }

    .td-dashboard-panel-container-efactura {
        .td-efactura-user-companies-list-wrap {
            max-height: 92px;
            overflow-y: auto;
            &::-webkit-scrollbar-track {
                background-color: #fff;
            }

            &::-webkit-scrollbar {
                width: 3px;
                height: 3px;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #395fc5;
                opacity: 1;
            }
        }
        .td-table-efactura-body {
            tbody tr {
                &:nth-of-type(2n) {
                    background-color: #f7fafd;
                }
            }
        }
    }

    @media print {
        .quill-better-table-wrapper {
            overflow: hidden !important;
        }
    }

    @media (max-width: 767px) {
        .td-logo-dropdown {
            display: none !important;
        }
        .td-efactura-connection-status>a {
            width: 100%;
        }
    }

    @media (max-width: 767px) {
        .td-logo-dropdown a {
            display: none;
            &:after {
                display: none;
            }
        }
    }

    @media (min-width: 767px) {
        .navbar-collapse .navbar-left .td-logo-dropdown {
            li {
                border-bottom: 1px solid #eee;

                &:last-child {
                    border-bottom: none;
                }
            }

            .link-logo {
                width: 4rem;
                height: 4rem;
                margin-right: 5px;
                vertical-align: middle;
            }

            .link-logo-mobil {
                width: 4rem;
                height: 4rem;
                margin-right: 5px;
                vertical-align: middle;
            }

            ul .logo-nav-dropdown {
                margin-left: -10px;
                color: black;

                &:hover {
                    color: #395FC5;
                    opacity: 1;
                }
            }

            .td-navbar-link.active .logo-nav-dropdown-active {
                color: #395FC5;
                opacity: 1;
                font-weight: 600;
            }

            > .dropdown-menu {
                border-radius: 4px;
                padding: 0;
                .logo-nav-dropdown {
                    font-size: 13px;
                    padding: 8px 12px 8px 20px;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    transition: color .2s ease;
                    svg {
                        margin-right: 0;
                    }
                }
            }

            .logo-nav-dropdown {
                opacity: 1 !important;
            }
            &.td-not-ro {
                .dropdown-menu {
                    display: none!important;
                }
                >.navbar-brand {
                    color: #333 !important;
                    background-color: transparent !important;
                    padding: 0;
                    &:before {
                        display: none !important;
                    }
                }
            }
        }
    }


    //Design library

    .td-shadow-xxxs {
        box-shadow: 0 2px 2px -2px rgba(24, 39, 75, 0.04), 0 2px 4px -2px rgba(24, 39, 75, 0.08);
    }
    .td-shadow-xxs {
        box-shadow: 0 4px 4px -2px rgba(24, 39, 75, 0.04), 0 2px 4px -2px rgba(24, 39, 75, 0.08);
    }
    .td-shadow-xs {
        box-shadow: 0 8px 8px -4px rgba(24, 39, 75, 0.04), 0 4px 6px -4px rgba(24, 39, 75, 0.08);
    }
    .td-shadow-s {
        box-shadow: 0 8px 16px -6px rgba(24, 39, 75, 0.04), 0 6px 8px -6px rgba(24, 39, 75, 0.08);
    }
    .td-shadow-m {
        box-shadow: 0 8px 24px -4px rgba(24, 39, 75, 0.04), 0 6px 12px -6px rgba(24, 39, 75, 0.08);
    }
    .td-shadow-l {
        box-shadow: 0 10px 32px -4px rgba(24, 39, 75, 0.05), 0 6px 14px -6px rgba(24, 39, 75, 0.08);
    }
    .td-shadow-xl {
        box-shadow: 0 12px 42px -4px rgba(24, 39, 75, 0.06), 0 8px 18px -6px rgba(24, 39, 75, 0.08);
    }
    .td-shadow-xxl {
        box-shadow: 0 14px 64px -4px rgba(24, 39, 75, 0.1), 0 8px 22px -6px rgba(24, 39, 75, 0.08);
    }
    .td-shadow-xxxl {
        box-shadow: 0 18px 88px -4px rgba(24, 39, 75, 0.1), 0 8px 28px -6px rgba(24, 39, 75, 0.08);
    }

    //use with white text
    .td-primary-1000 {
        background-color: #1A3E9E;
        color: #fff;
    }
    .td-primary-900 {
        background-color: #2146AA;
        color: #fff;
    }
    .td-primary-800 {
        background-color: #2A50B8;
        color: #fff;
    }
    .td-primary-700 {
        background-color: #395FC5;
        color: #fff;
    }
    .td-primary-600 {
        background-color: #4371DD;
        color: #fff;
    }
    .td-primary-500 {
        background-color: #7092E4;
        color: #fff;
    }
    //use with black text
    .td-primary-400 {
        background-color: #A6B8E3;
        color: #000;
    }
    .td-primary-300 {
        background-color: #BBCCF5;
        color: #000;
    }
    .td-primary-200 {
        background-color: #CDDCFD;
        color: #000;
    }
    .td-primary-100 {
        background-color: #DEE8FF;
        color: #000;
    }
    .td-primary-50 {
        background-color: #E8EEFD;
        color: #000;
    }


    //use with white text
    .td-primary-1400 {
        background-color: #000000;
        color: #fff;
    }
    .td-blueGrey-1300 {
        background-color: #1B1E24;
        color: #fff;
    }
    .td-blueGrey-1200 {
        background-color: #2B3038;
        color: #fff;
    }
    .td-blueGrey-1100 {
        background-color: #343B45;
        color: #fff;
    }
    .td-blueGrey-1000 {
        background-color: #545E6D;
        color: #fff;
    }
    .td-blueGrey-900 {
        background-color: #727F92;
        color: #fff;
    }
    .td-blueGrey-800 {
        background-color: #8A97AB;
        color: #fff;
    }
    .td-blueGrey-700 {
        background-color: #A2B0C3;
        color: #fff;
    }
    //use with black text
    .td-blueGrey-600 {
        background-color: #C3CDDD;
        color: #000;
    }
    .td-blueGrey-500 {
        background-color: #D9E2F0;
        color: #000;
    }
    .td-blueGrey-400 {
        background-color: #E2EAF5;
        color: #000;
    }
    .td-blueGrey-300 {
        background-color: #EEF2F8;
        color: #000;
    }
    .td-blueGrey-200 {
        background-color: #F1F8FF;
        color: #000;
    }
    .td-blueGrey-100 {
        background-color: #F8FAFD;
        color: #000;
    }
    .td-blueGrey-0 {
        background-color: #FFFFFF;
        color: #000;
    }


    //use with white text
    .td-red-800 {
        background-color: #C10404;
        color: #fff;
    }
    .td-red-700 {
        background-color: #DA0000;
        color: #fff;
    }
    .td-red-600 {
        background-color: #FF0505;
        color: #fff;
    }
    .td-red-500 {
        background-color: #F45353;
        color: #fff;
    }
    .td-red-400 {
        background-color: #F88181;
        color: #fff;
    }
    .td-red-300 {
        background-color: #FBAEAE;
        color: #fff;
    }
    //use with black text
    .td-red-200 {
        background-color: #FFDEDE;
        color: #000;
    }
    .td-red-100 {
        background-color: #FFF1F1;
        color: #000;
    }


    //use with white text
    .td-green-800 {
        background-color: #097F3B;
        color: #fff;
    }
    .td-green-700 {
        background-color: #17934C;
        color: #fff;
    }
    .td-green-600 {
        background-color: #2AAA61;
        color: #fff;
    }
    .td-green-500 {
        background-color: #34C471;
        color: #fff;
    }
    .td-green-400 {
        background-color: #3DD47D;
        color: #fff;
    }
    //use with black text
    .td-green-300 {
        background-color: #4BE48C;
        color: #000;
    }
    .td-green-200 {
        background-color: #5AF29A;
        color: #000;
    }
    .td-green-100 {
        background-color: #ABFFCF;
        color: #000;
    }


    //use with black text
    .td-yellow-800 {
        background-color: #CBA10D;
        color: #000;
    }
    .td-yellow-700 {
        background-color: #DFB41B;
        color: #000;
    }
    .td-yellow-600 {
        background-color: #EBC027;
        color: #000;
    }
    .td-yellow-500 {
        background-color: #F7CB2E;
        color: #000;
    }
    .td-yellow-400 {
        background-color: #FBD242;
        color: #000;
    }
    .td-yellow-300 {
        background-color: #FFE485;
        color: #000;
    }
    .td-yellow-200 {
        background-color: #FFF1BF;
        color: #000;
    }
    .td-yellow-100 {
        background-color: #FFF8E0;
        color: #000;
    }


    //use with white text
    .td-grey-800 {
        background-color: #424242;
        color: #fff;
    }
    .td-grey-700 {
        background-color: #888888;
        color: #fff;
    }
    .td-grey-600 {
        background-color: #999999;
        color: #fff;
    }
    //use with grey text
    .td-grey-500 {
        background-color: #BBBBBB;
        color: #4e4e4e;
    }
    .td-grey-400 {
        background-color: #D6D6D6;
        color: #4e4e4e;
    }
    .td-grey-300 {
        background-color: #E8E8E8;
        color: #4e4e4e;
    }
    .td-grey-200 {
        background-color: #F3F3F3;
        color: #4e4e4e;
    }
    .td-grey-100 {
        background-color: #F9F9F9;
        color: #4e4e4e;
    }

    .td-uploaded-file-row {
        display: flex;
        gap: 5px;
        align-items: center;
        .td-file-icons {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .td-file-icon {
            margin: 3px 3px -3px -3px;
        }
        .td-files-name {
            position: relative;
            top: 1px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/App.vue